import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  HostListener,
  ViewChild,
  ApplicationRef,
  ChangeDetectorRef,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NgForm,
  FormGroup,
  FormControl,
  FormArray,
  FormBuilder,
  Validators,
  FormsModule,
} from "@angular/forms";
import { QueryBuilderConfig } from "angular2-query-builder";
import { ApplicationService } from "../../services/application.service";
import { RuleengineService } from "../../services/ruleengine.service";
import { SharedService } from "../../services/shared.service";
import { Workexpservice } from "../../services/workexp.service";
import { SearchfilterPipe } from "../../pipe/searchfilter.pipe";
import { AclService } from "../../services/acl.service";
import { ToastrService } from "ngx-toastr";
import { ProjectService } from "../../services/project.service";
import * as moment from "moment";
import { DatepickerOptions } from "ng2-datepicker";
import { environment } from "../../../environments/environment";

import {
  trigger,
  transition,
  state,
  animate,
  style,
  AnimationEvent,
} from "@angular/animations";
//import {LOCAL_STORAGE} from 'angular-webstorage-service'


import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { type } from 'os';
import { timestamp } from 'rxjs/operators';
@Component({
  selector: "app-rulengine",
  templateUrl: "./rulengine.component.html",
  animations: [
    trigger("openClose", [
      // ...
      state(
        "open",
        style({
          //height: '200px',
          opacity: 1,
          display: "block",
          //backgroundColor: 'yellow'
        })
      ),
      state(
        "closed",
        style({
          //height: '0px',
          opacity: 0.5,
          display: "none",
          //backgroundColor: 'green'
        })
      ),
      transition("open => closed", [animate("1s")]),
      transition("closed => open", [animate("0.5s")]),
    ]),
  ],
  styleUrls: ["./rulengine.component.css"],
})
export class RulengineComponent implements OnInit {
  // objectKeys = Object.keys;

  showCRRule: boolean = false;
  showWorkexpRuleManagement: boolean = true;
  showWorkexpRule: boolean = false;
  showAge: boolean = false;
  showEditRule: boolean = false;
  finalArray: [];
  finaldata: any;
  showRuleng: boolean = true;
  showDependent: boolean = false;
  showPreference: boolean = false;
  showUploadSec: boolean = false;
  showUploadSecPref: boolean = false;
  showMappingSec: boolean = false;
  showVacancySec: boolean = false;
  showGridMandatorySec: boolean = false;
  model: any = { accountName: "", projectName: "", _id: "" };
  options: DatepickerOptions = {
    format: "dd/MM/yyyy",
  };
  accountData: any;
  dependentOnLen: any;
  projectData: any;
  logicString: any;
  ruleEngineData = [];
  // worExpData = [];
  // DynworExpData = [];
  gridCheckData = [];
  worExpData = [];
  armedForcesWorkExpData = [];
  DynworExpData = [];
  postBasedWorkExpData = [];
  formJson = [];
  applNew: any = 0;
  formJsonEdit_id = "";
  gridEditJson_id = "";
  alertmsgstr: string = "";
  inputSelectInsert: string = "";
  ruleFor: string = "";
  feeCond1: string = "";
  feeCond2: string = "";
  feeVal1: string = "";
  feeVal2: string = "";
  feeCond: any = [];
  inputSearch: string = "";
  jsonConvertedString = "";
  arrayMatchString = "";
  pincodeJSONString: any;
  arrayLengthString = "";
  jsonConvertedStrWorkExp = "";
  jsonConvertedStringAge = "";
  jsonConvertedStringAgeClc = "";
  QueryBuilderConfigOrigArr = {};
  displayPrevJson: boolean = false;
  displayPrevJsonVal = "";
  RelaxFieldThird: any = [];
  GenderFieldSecond: any = [];
  RelaxFieldThirdAvail: any = [];
  parentData: any;
  listData: any;
  mappingModel: any;
  AccProjectdet: any;
  formFieldsM: any;
  genRelaxAgeJSONList: any;
  selectedFile: File = null;
  depmodel: any = { depField: "", depData: "" };

  ruleForVal = [
    { ruleValue: "Eligibility", ruleDisplay: "Validation" },
    { ruleValue: "Fee", ruleDisplay: "Fee" },
    { ruleValue: "Conditional", ruleDisplay: "Conditional" },
    { ruleValue: "Concatination", ruleDisplay: "Concatination" },
    { ruleValue: "mapValue", ruleDisplay: "mapValue" },
    { ruleValue: "alert", ruleDisplay: "alert" },
    { ruleValue: "pincode", ruleDisplay: "pincode" },
    { ruleValue: "dop", ruleDisplay: "dop" },
    { ruleValue: "minmax", ruleDisplay: "minmax" },
  ];

  //ruleForVal = ['Eligibility','Fee'];
  configPushArrayOrigStr: string = "";
  fieldListArr: any;
  ageRelaxationList: any;
  dependentkeys: any;
  selectFieldIpArr1 = [];
  relaxFieldVal = [];
  relaxationlistcount = [];
  relaxFieldCount = [];
  ageDependent: any;
  ageDependFieldVal = [];
  masterData = [];
  tableData = [];

  datagridFlag: boolean = false;

  vacancyParent = [];
  vacancyParentValue = [];
  vacancyChild = [];
  vacancyChildValue = [];
  fldMappingData: any;
  isOpen: boolean = false;

  dataGridName: string[] = [];
  dataGridvalues: string[] = [];
  labelArr = [];
  objdata = {};
  finalobjdata = [];
  gridValuesArr = [];
  gridField = [];
  getGridDataFlag: boolean;
  fetchedGridValues = [];
  checkedValobj = {};
  gridvaluesObj = {};

  i: number = 1;
  LoadDis = 1;
  loading = false;
  dynCalcAppendField: string = "";
  dyntodate: string = "";
  dynfromdate: string = "";
  formTouchedFlag: boolean = true;
  unSaveData: boolean = true;
  queryInitVal = {
    condition: "or",
    rules: [
      /* {field: "age", operator: "<="},
      {field: "birthday", operator: ">="},
      {
        condition: 'or',
        rules: [
          {field: "gender", operator: "="},
          {field: "occupation", operator: "in"},
          {field: "school", operator: "is null"}
        ]
      } */
    ],
  };

  query = {
    condition: "or",
    rules: [
      /* {field: "age", operator: "<="},
      {field: "birthday", operator: ">="},
      {
        condition: 'or',
        rules: [
          {field: "gender", operator: "="},
          {field: "occupation", operator: "in"},
          {field: "school", operator: "is null"}
        ]
      } */
    ],
  };

  convertedStr = this.query;

  btnSubmission = true;
  deletebtn = false;

  config: QueryBuilderConfig = {
    fields: {},
  };

  inputFiledSel: String[];
  dependentinputFiledSel: any;
  public myForm: FormGroup;
  public myFormworkexp: FormGroup;
  public myFormworkexpArmedForces: FormGroup;
  public vacancyForm: FormGroup;
  public myDynFormworkexp: FormGroup;
  public myPostbasedFormworkexp: FormGroup;
  public myFormGridCheck: FormGroup;
  public myFormAge: FormGroup;
  @ViewChild("ruleengineform")
  ruleengineform: NgForm;
  constructor(
    private router: Router,
    private sharedService: SharedService,
    private Workexpservice: Workexpservice,
    private applicationService: ApplicationService,
    private ruleengineService: RuleengineService,
    private aclService: AclService,
    private elementRef: ElementRef,
    private _fb: FormBuilder,
    private toastr: ToastrService,
    private projectService: ProjectService,
    private appRef: ApplicationRef
  ) { }
  //ruleEngForm: Object;

  createruleAdd: any = 0;
  createruleView: any = 0;
  createruleEdit: any = 0;
  createruleDelete: any = 0;
  pages = 0;

  ngOnInit() {
    console.log("inisde ng ON Init");
    this.loading = true;


    this.sharedService.currentAccInfo.subscribe(
      (data) => (this.model.accountName = data)
    );
    this.sharedService.currentProjInfo.subscribe(
      (data) => (this.model.projectName = data)
    );
    this.getAppln();
    this.getProjectAccDet();
    //this.getProjects();
    this.getRuleDet();

    this.getUserAccess("createrule", "add");
    this.getUserAccess("createrule", "view");
    this.getUserAccess("createrule", "edit");
    this.getUserAccess("createrule", "delete");

    //console.log(this.model.accountName);
    this.myForm = this._fb.group({
      ageDep: new FormControl(""),
      formFields: new FormControl(""),
      relaxFields: new FormControl(""),
      dobVal: new FormControl(""),
      ageVal: new FormControl(""),
      dependenton: this._fb.array([]),
      //ageDependentFields:new FormControl(''),
    });

    this.myFormAge = this._fb.group({
      age: this._fb.array([
        //this.initAge(),
      ]),
    });

    this.myFormworkexp = this._fb.group({
      totexp: [""],
      workexp: this._fb.array([
        //this.initwork(),
      ]),
    });

    this.myDynFormworkexp = this._fb.group({
      dyntotexp: [""],
      dynworkexp: this._fb.array([
        //this.initwork(),
      ]),
    });

    this.myFormGridCheck = this._fb.group({
      gridcomp: "",
      chooseone: "",
      gridval: [],
    });
  }
  initAge(getStoreData) {
    let asondate = getStoreData.ageAsonDate;
    let mindate = getStoreData.ageMinDate;
    let maxdate = getStoreData.ageMaxDate;

    let modifiedasondate = new Date(moment(asondate).format("YYYY-MM-DD"));

    let modifiedmindate = new Date(moment(mindate).format("YYYY-MM-DD"));
    let modifiedmaxdate = new Date(moment(maxdate).format("YYYY-MM-DD"));



    return this._fb.group({
      ageAsonDate: modifiedasondate,
      ageMinDate: modifiedmindate,
      ageMaxDate: modifiedmaxdate,
      ageMin: [getStoreData.ageMin],
      ageMax: [getStoreData.ageMax],
      ageRel: [getStoreData.ageRel],
    });
  }


  generateAge(getStoreData) {
    const control = <FormArray>this.myFormAge.controls["age"];
    control.push(this.initAge(getStoreData));
    console.log("get store Data is", this.initAge(getStoreData));

  }
  removeSectionAge(i: number) {
    const control = <FormArray>this.myFormAge.controls["age"];
    control.removeAt(i);
  }

  getUserAccess(compName: any, functAcc: any) {
    this.aclService.getRoles().then((userRoles) => {
      if (compName == "createrule") {
        if (functAcc == "add") this.createruleAdd = 0;
        if (functAcc == "view") this.createruleView = 0;
        if (functAcc == "edit") this.createruleEdit = 0;
        if (functAcc == "delete") this.createruleDelete = 0;
      }
      var avail = 0;
      for (let pages of Object.values(userRoles)) {
        if (pages.page == compName) {
          var accFunc = pages.functionality;
          //console.log(accFunc.includes(functAcc));
          if (accFunc.includes(functAcc) == true) {
            this.router.navigate(["/rulengine"]);
          } else {
            this.router.navigate(["/dashboard"]);
          }
          if (accFunc.includes(functAcc)) {
            avail = 1;
          }
        }
      }
      if (compName == "createrule") {
        if (functAcc == "add") this.createruleAdd = avail;
        if (functAcc == "view") this.createruleView = avail;
        if (functAcc == "edit") this.createruleEdit = avail;
        if (functAcc == "delete") this.createruleDelete = avail;
      }
    });
  }
  getAppln() {
    //console.log(this.model.accountName);
    if (this.model.accountName != "" && this.model.projectName != "") {
      this.applNew = 0;
      this.applicationService
        .getAppln(this.model.accountName, this.model.projectName)
        .subscribe((res) => {
          if (res.data.length > 0) {
            //console.log(res.data);
            this.QueryBuilderConfigOrigArr = res.data["0"].applicationJson;
            //console.log(this.AccountNameDet);
            //this.QueryBuilderConfigOrigArr = {'components':res.data['0'].applicationJson,display: 'wizard'};
            //declare var projectIdentifier : string;
            //projectIdentifier= res.data['0'].ProjectIdentifier;
            //console.log(projectIdentifier);
            this.convertConfigJsonQuery();
          } else {
            //this.form = {'components':[],display: 'wizard'};
            //this.formJson = [{'components':[],display: 'wizard'}];
            this.applNew = 1;
          }
        });
    }
  }
   getRuleDet() {
    if (this.model.accountName != "" && this.model.projectName != "") {
      this.ruleengineService.getRulesManage(this.model.accountName, this.model.projectName, "").subscribe((res) => {
        this.ruleEngineData = res.data;
        //this.ruleEngineData = res.data['0'].applicationJson;
        this.loading = false;
        console.log("data>>>>>>>>>>>", this.ruleEngineData);
        if(this.ruleEngineData[0].rulesJsonLogic != "" || this.ruleEngineData[0].rulesJsonLogic != undefined){
          this.jsonpreviewView(this.ruleEngineData[0].rulesJsonLogic,'show');
        }
        

      });
      console.log("inside", this.ruleEngineData);

    }
  }
  async convertConfigJsonQuery() {
    var JsonConfigOrig = this.QueryBuilderConfigOrigArr;
    console.log("JsonConfigOrig is=", JsonConfigOrig);
    var jsonConvertedConfigValue = new Array();
    var configPushArrayOrig = new Array();

    //var selectFieldIpArr1 = [];
    //var configPushArrayOrigStr = '';
    for (let key in JsonConfigOrig) {
      var value = JsonConfigOrig[key];
      var pageCompVal = value["key"];
      console.log("Value inside first loop", value);

      for (let keyC in value["components"]) {
        var valueC = value["components"][keyC];
        console.log("valueC is>>>>>>>>>", valueC);
        if (valueC["type"] === "datagrid") {
          //DATAGRID LATOUT
          var dataGridvalues = valueC["label"];
          console.log("dataGrid::::::", dataGridvalues);
          this.dataGridName.push(dataGridvalues);

          console.log("valueC:: inside datagrid", valueC);
          this.pushOuterGridCom(valueC, key, keyC, pageCompVal);
          var valueDG = valueC["components"];
          console.log("valueDG=====", valueDG);
          var obj = {};
          obj[dataGridvalues] = valueDG;
          var stringifiedJson = JSON.stringify(obj);
          this.dataGridvalues.push(JSON.parse(stringifiedJson));
          this.datagridFlag = false;

          for (let keyDG in valueDG) {
            var finalValueDG = valueDG[keyDG];
            console.log("value final is", finalValueDG);
            this.objdata[dataGridvalues] = finalValueDG.label;
            console.log("finalValueDG==========", finalValueDG.label);
            this.labelArr.push(this.objdata);
            console.log("valueC value before genArrJsonCompField", valueC);
            await this.genArrJsonCompField(valueC, key, keyDG, pageCompVal);
            console.log("labelsarray is", this.labelArr);
          }
          console.log("objjjjj", this.objdata);
        } else if (valueC["columns"]) {
          //COLUMN LAYOUT
          console.log("in column", valueC["columns"]);
          for (let keyCC in valueC["columns"]) {
            var valueCC = valueC["columns"][keyCC];
            var valueCCC = valueCC["components"];
            //console.log(projectIdentifier);

            //console.log(valueCCC);
            //console.log(this.model);
            for (let keyCVV in valueCCC) {
              var valueCVV = valueCCC[keyCVV];
              await this.genArrJsonCompField(valueCC, key, keyCVV, pageCompVal);
            }
          }
        } else if (valueC["rows"]) {
          //TABLE LAYOUT
          for (let keyCR in valueC["rows"]) {
            var valueCRC = valueC["rows"][keyCR];
            console.log("Inside Tble layout", valueCRC);
            for (let keyCRCC in valueCRC) {
              /*console.log("inner");
              console.log(valueCRC[keyCRCC]['components']);*/
              var valueCRCR = valueCRC[keyCRCC]["components"];
              for (let keyCV in valueCRCR) {
                var valueCV = valueCRCR[keyCV];
                await this.genArrJsonCompField(
                  valueCRC[keyCRCC],
                  key,
                  keyCV,
                  pageCompVal
                );
              }
            }
          }
        } else if (valueC["components"]) {
          //PANEL LAYOUT & FIELDSET LAYOUT
          //console.log("in");
          //console.log(this.configPushArrayOrigStr);
          //console.log(valueC.label);
          //console.log(valueC);
          if (valueC.type == "tabs") {
            var valueCT = valueC["components"];
            //console.log(valueCT);
            for (let keyCT in valueCT) {
              var valueCTT = valueCT[keyCT]["components"];
              for (let keyCTT in valueCTT) {
                var valueCTTT = valueCTT[keyCTT];
                await this.genArrJsonCompField(
                  valueCT[keyCT],
                  key,
                  keyCTT,
                  pageCompVal
                );
              }
            }
          } else {
            var valueCO = valueC["components"];
            for (let keyCO in valueCO) {
              var valueCOO = valueCO[keyCO];
              await this.genArrJsonCompField(valueC, key, keyCO, pageCompVal);
            }
          }
          //this.genArrJsonCompField(valueC,key,key);
        } 
        // else if(valueC["type"] === "htmlelement" ){

        // }
        else {
          console.log("in else", valueC);
          //console.log(this.configPushArrayOrigStr);
          await this.genArrJsonCompField(value, key, keyC, pageCompVal);
        }
      }
      console.log("this.datagrid label array is", this.dataGridName);
      // console.log("this.datagrid values array is", this.dataGridvalues);
    }
    //console.log(this.configPushArrayOrigStr);
    if (this.configPushArrayOrigStr != "") {
      this.configPushArrayOrigStr =
        this.configPushArrayOrigStr.replace(/,\s*$/, "") + "}";
    }
    //console.log(JSON.parse(this.configPushArrayOrigStr));
    this.fieldListArr = JSON.parse(this.configPushArrayOrigStr);
    //console.log(this.fieldListArr);
    this.config = { fields: JSON.parse(this.configPushArrayOrigStr) };
    console.log(
      "this.selectFieldIpArr1 front",
      JSON.stringify(this.selectFieldIpArr1)
    );
    this.selectFieldIpArr1 = this.selectFieldIpArr1.filter(function (e) {
      return e;
    });
    console.log(
      "this.selectFieldIpArr1 top",
      JSON.stringify(this.selectFieldIpArr1)
    );
    this.inputFiledSel = this.selectFieldIpArr1;

    this.dependentinputFiledSel = this.fieldListArr;
    console.log("this.inputFiledSel", this.inputFiledSel);
  }

  getGridValues(event) {
    this.gridValuesArr = [];
    this.gridvaluesObj = {};
    console.log("selcted value is", event.target.value);
    let selectedValue = event.target.value;
    console.log("this.datagrid values array is", this.dataGridvalues);

    this.dataGridvalues.forEach((gridValues) => {
      if (gridValues.hasOwnProperty(selectedValue)) {
        console.log("values::::::::", Object.keys(gridValues));
        console.log("gridValues::::::", Object.entries(gridValues));
        var dataCheck = Object.entries(gridValues);
        console.log("datacheck ;;;;", dataCheck);
        Object.values(dataCheck[0][1]).forEach((i) => {
          console.log("i::::::::", i["label"]);
          this.gridValuesArr.push(i["key"]);
          this.gridvaluesObj[i["key"]] = true;
        });
        console.log("gridvalue object is", this.gridvaluesObj);
      }
    });
    this.getGridDataFlag = false;
    console.log("DG::::::", this.gridValuesArr);
  }

  onSelectValues(name: string, isChecked: boolean) {
    console.log("the total values of an array>>>", this.gridvaluesObj);
    // this.checkedValobj = this.gridValuesArr;
    // console.log("checked val object before modifying", this.checkedValobj);
    if (isChecked) {
      this.gridvaluesObj[name] = true;
      // this.gridField.push(name);
      // console.log("gridField:::", this.gridField);
    } else {
      this.gridvaluesObj[name] = false;
      // const index: number = this.gridField.indexOf(name);
      // if (index !== -1) {
      //   this.gridField.splice(index, 1);
      // }

      // console.log("in elseblock gridField:::", this.gridField);
    }

    console.log("the modified object", this.gridvaluesObj);
  }

  pushOuterGridCom(value, key, keyC, pageCompVal) {
    var allowFiled = 0;
    console.log("value.type inside fun", value.type);

    if (value.type === "datagrid") {
      console.log("inside value.type");
      allowFiled = 1;
    }
    console.log("allowFiled", allowFiled);

    //if (allowFiled == 1) {
    if (value.type == "datagrid" && value.key != "" && allowFiled == 1) {
      console.log("value inside datagrid:::", value);
      console.log("this.i:::", this.i);
      this.selectFieldIpArr1[this.i] = {
        pageCompVal: pageCompVal,
        keyVal: value.key,
        keyIndex: keyC,
        componentIndex: key,
        DisplayVal: value.label,
        typeVal: value.type,
      };

      //  this.selectFieldIpArr1.push({ 'pageCompVal': pageCompVal, 'keyVal': value.key, 'keyIndex': keyC, 'componentIndex': key, 'DisplayVal': value.label, 'typeVal': value.type });
      // this.datagridFlag = true;
      console.log(
        "selectFieldIpArr1 is",
        JSON.stringify(this.selectFieldIpArr1)
      );
    }
    //}
  }

  async genArrJsonCompField(value, key, keyC, pageCompVal) {
    //for (let keyC in value['components']) {
    var layoutCompType = value.type;
    var layoutCompKey = value.key;
    console.log("value inside genArrJsonCompField", value);
    // var valueArray=[];
    // valueArray.push(value);
    // console.log("valueArray::",valueArray)

    console.log("keyC inside genArrJsonCompField", keyC);
    var valueC = value["components"][keyC];
    console.log("valueC inside genArrJsonCompField", valueC);

    var AID = this.model.accountName;
    var PID = this.model.projectName;
    //console.log(projectIdentifier);
    //console.log(value);
    //console.log(value);
    //console.log(valueC);
    //console.log(valueC.dataSrc)
    //var pageCompVal = value["key"];
    var allowFiled = 0;

    if (
      valueC.type == "textfield" ||
      valueC.type == "textarea" ||
      valueC.type == "number" ||
      valueC.type == "select" ||
      valueC.type == "radio" ||
      valueC.type == "selectboxes" ||
      valueC.type == "checkbox" ||
      valueC.type == "email" ||
      valueC.type == "phoneNumber" ||
      valueC.type == "datetime" ||
      valueC.type == "day" ||
      valueC.type == "password" ||
      valueC.type == "hidden" ||
      valueC.type == "file" ||
      value.type == "datagrid" ||
      valueC.type == "htmlelement"
    ) {
      if (this.i == 1) {
        this.configPushArrayOrigStr += "{";
      }
      console.log("value.type::", value.type);
      allowFiled = 1;
    }

    if (allowFiled == 1) {
      if (valueC.key != "") {
        console.log("pageCompVal:::", pageCompVal);
        console.log("valueC.label:::", valueC);
        console.log(
          "this.selectFieldIpArr1[this.i] inside allow::",
          this.selectFieldIpArr1[this.i]
        );

        // this.selectFieldIpArr1[this.i] = { 'pageCompVal': pageCompVal, 'keyVal': valueC.key, 'keyIndex': keyC, 'componentIndex': key, 'DisplayVal': valueC.label, 'typeVal': valueC.type };

        this.selectFieldIpArr1.push({
          pageCompVal: pageCompVal,
          keyVal: valueC.key,
          keyIndex: keyC,
          componentIndex: key,
          DisplayVal: valueC.label,
          typeVal: valueC.type,
        });

        console.log(
          "this.selectFieldIpArr1[this.i] after allowFiled",
          this.selectFieldIpArr1
        );
        if (
          valueC.type == "select" &&
          !valueC.data.hasOwnProperty("url") &&
          valueC.data.values.length > 0
        )
          this.selectFieldIpArr1[this.i]["selectOption"] = valueC.data.values;
      }
      // console.log("value inside datagrid",value);

      // if(value.type == 'datagrid' && value.key!='' && this.datagridFlag === false){

      //   console.log("value inside datagrid:::",value);
      //   this.selectFieldIpArr1[this.i] = { 'pageCompVal': pageCompVal, 'keyVal': value.key, 'keyIndex': key, 'componentIndex': key, 'DisplayVal': value.label, 'typeVal': value.type };

      //   this.datagridFlag = true;
      // }

      //console.log(valueC.type);
      //console.log(valueC.key);
      var KeyAssign = valueC.key;
      if (
        valueC.type == "textfield" ||
        valueC.type == "textarea" ||
        valueC.type == "email" ||
        valueC.type == "phoneNumber" ||
        valueC.type == "password" ||
        valueC.type == "file"
      ) {
        //Text BoX
        this.configPushArrayOrigStr +=
          '"' +
          [KeyAssign] +
          '": {"name":"' +
          valueC.label +
          '", "type": "string","layoutComp":"' +
          layoutCompType +
          '","layoutCompKey":"' +
          layoutCompKey +
          '"},';
      } else if (valueC.type == "number") {
        //Number
        this.configPushArrayOrigStr +=
          '"' +
          [KeyAssign] +
          '": {"name":"' +
          valueC.label +
          '", "type": "number","layoutComp":"' +
          layoutCompType +
          '","layoutCompKey":"' +
          layoutCompKey +
          '"},';
      } else if (valueC.type == "datetime" || valueC.type == "day") {
        //datetime && day
        this.configPushArrayOrigStr +=
          '"' +
          [KeyAssign] +
          '": {"name":"' +
          valueC.label +
          '", "type": "date","layoutComp":"' +
          layoutCompType +
          '","layoutCompKey":"' +
          layoutCompKey +
          '"},';
      } else if (
        valueC.type == "select" ||
        valueC.type == "radio" ||
        valueC.type == "selectboxes"
      ) {
        //Select & radio
        var optionStrVal = "";
        if (valueC.type == "select") {
          //var optionStrArray = [];
          if (valueC.dataSrc == "url") {
            //var optionStrArray = []];
            var getValues = await this.ruleengineService
              .getDBOption(AID, PID, valueC.key)
              .toPromise();
            //console.log(getValues.data);

            if (getValues["success"] == true) {
              //console.log(res.data);
              /*var optionStrArray1 = [];
              for (let keyOpt in getValues.data){
                var optiondb = {label: getValues.data[keyOpt].Value, value: getValues.data[keyOpt].Key};
                optionStrArray1.push(optiondb);
              }*/
              //var optionStrArray = optionStrArray1;
              var optionStrArray = getValues["data"];
              //console.log('111111');
              //console.log(optionStrArray);
            }

            //console.log(optionStrArray1);

            //console.log(optionStrArray);
          } else {
            //var optionStrArray = valueC['data']['values'];
            var optionStrArray = valueC["data"]["values"];
            //console.log(optionStrArray);
          }
        } else if (valueC.type == "radio" || valueC.type == "selectboxes")
          var optionStrArray = valueC["values"];
        //console.log(optionStrArray);
        //console.log('22222222222');
        for (let keyCV in optionStrArray) {
          var valueCV = optionStrArray[keyCV];
          optionStrVal +=
            '{"name":"' +
            valueCV.label +
            '", "value": "' +
            valueCV.value +
            '"},';
        }
        //console.log(optionStrVal);

        if (optionStrVal != "") {
          optionStrVal = optionStrVal.replace(/,\s*$/, "");
        }
        this.configPushArrayOrigStr +=
          '"' +
          [KeyAssign] +
          '": {"name":"' +
          valueC.label +
          '", "type": "category","options": [' +
          optionStrVal +
          '],"layoutComp":"' +
          layoutCompType +
          '","layoutCompKey":"' +
          layoutCompKey +
          '"},';
        //console.log(this.configPushArrayOrigStr);
      } else if (valueC.type == "checkbox") {
        //checkbox
        this.configPushArrayOrigStr +=
          '"' +
          [KeyAssign] +
          '": {"name":"' +
          valueC.label +
          '", "type": "boolean","layoutComp":"' +
          layoutCompType +
          '","layoutCompKey":"' +
          layoutCompKey +
          '"},';
      }

      //this.configPushArrayOrigStr = JSON.parse(this.configPushArrayOrigStr);
      //console.log(this.configPushArrayOrigStr);
      this.i++;
    }

    if (value.type == "datagrid") {
      console.log("inside datagrid block", value);

      // this.selectFieldIpArr1[1] = { 'pageCompVal': pageCompVal, 'keyVal': value.key, 'keyIndex': keyC, 'componentIndex': key, 'DisplayVal': value.label, 'typeVal': value.type };

      this.configPushArrayOrigStr +=
        '"' +
        [value.key] +
        '": {"name":"' +
        value.label +
        '", "type": "datagrid","layoutComp":"' +
        layoutCompType +
        '","layoutCompKey":"' +
        layoutCompKey +
        '"},';

      console.log(
        "this.configPushArrayOrigStr",
        JSON.stringify(this.configPushArrayOrigStr)
      );
    }
    /* if(valueC.type == 'htmlelement'){
      if(valueC.key!=''){
        this.selectFieldIpArr1[this.i] = {'pageCompVal':pageCompVal, 'keyVal': valueC.key, 'keyIndex': keyC, 'componentIndex': key, 'DisplayVal': valueC.label};
      }
    } */
    //}
  }

  convertJsonQuery(ruleEngForm: NgForm) {
    if (ruleEngForm.valid) {
      this.loading = true;
      this.btnSubmission = false;
      var JsonRuleVal = this.query;
      var jsonConvertedValue = new Array();
      var jsonConvertedValueAlert = new Array();
      var alertmsgstrDisp = this.alertmsgstr;
      var inputSelectInsertVal = this.inputSelectInsert;
      var inputFiledSelArr = this.inputFiledSel;

      var configArrJson = JSON.parse(this.configPushArrayOrigStr);
      //console.log(configArrJson);
      //console.log(this.configPushArrayOrigStr);
      //console.log("%%%%");
      //console.log(inputFiledSelArr);

      ruleEngForm.value.ruleFor = this.ruleFor;
      ruleEngForm.value.inputSelectInsert = this.inputSelectInsert;
      // console.log("ruleEngForm.value.ruleFor:::::", ruleEngForm.value.ruleFor);

      var variableKey = new Array();
      var variableValue = new Array();
      var conditionList = new Array();
      var operatorList = new Array();
      var jsCondition = new Array();
      var dopVariable = new Array();

      var inArray = new Array();

      //if(ruleEngForm.value.ruleFor == 'Fee') {
      /* console.log("start");
      console.log(JsonRuleVal);
      console.log("end"); */
      //}else if(ruleEngForm.value.ruleFor == 'Eligibility') {
      var alertMassageData = [];
      var stringAlert = "";
      var operatorListData = "";
      var operatorListDataLength = "";
      var arrayVal = [];
      var arrayField = "";
      for (let key in JsonRuleVal) {
        var RulePushArrayOrig = [];
        var nestedRulePushArrayOrig;
        var nestedRulePushArrayOrig1 = [];
        var nestedInsertArr = [];

        var value = JsonRuleVal[key];
        conditionList.push(value);
        console.log("operator outside", value);
        console.log("whole array is", conditionList);
        if (key == "rules") {
          if (value.length > 0) {
            let i = 0;
            let even = 0;
            for (let keyR in value) {
              i++;
              var valueR = value[keyR];

              if (
                valueR["rules"] != undefined &&
                Number(valueR["rules"].length) % 2 == 0
              ) {
                even = 0;
              }
              console.log("valueR::", valueR);
              variableValue.push(valueR["value"]);
              var condValChk = valueR["condition"];
              // console.log("condValChk::", condValChk);
              if (valueR["rules"] !== undefined) {
                var rulesArrlen = valueR["rules"].length;
                var flag = false;
                var nestedFlag = false;
                var nestedFlagOdd = false;
                let m;
                for (m = 0; m < rulesArrlen; m++) {
                  if (
                    typeof condValChk != "undefined" &&
                    typeof valueR["rules"][m]["rules"] === "undefined"
                  ) {
                    let j = 0;
                    if (flag == false) {
                      for (let keyR1 in valueR) {
                        var valueR1 = valueR[keyR1];
                        var RulePushArray = new Array();
                        var insertArry = new Array();
                        if (keyR1 == "rules") {
                          // Rules base
                          for (let keyR2 in valueR1) {
                            if (valueR1[keyR2].rules === undefined) {
                              console.log(
                                "valueR1   is:::::::::::::",
                                valueR1[keyR2].rules
                              );

                              console.log("keyR2 is", keyR2);
                              var valueR2 = valueR1[keyR2];

                              if (valueR2.operator != "") {
                                // console.log("iam insiede ++ valueR2.operator!=''");

                                /*Start for datagrid*/
                                var valueR2FieldVal = "data." + valueR2.field;
                                var valueR2SameValueVal =
                                  "data." + valueR2.sameValue;
                                var valueR2CompareValueVal =
                                  "data." + valueR2.compareValue;
                                //var valueR2addYear = "data."+valueR2.addYear;
                                var valueR2DependValueVal =
                                  "data." + valueR2.dependValue;
                                var valueR2MapValueVal =
                                  "data." + valueR2.mapValue;

                                if (
                                  configArrJson[valueR2.field]["layoutComp"] ==
                                  "datagrid"
                                )
                                  valueR2FieldVal = "row." + valueR2.field;
                                if (
                                  configArrJson[valueR2.sameValue] &&
                                  configArrJson[valueR2.sameValue][
                                  "layoutComp"
                                  ] == "datagrid"
                                )
                                  valueR2SameValueVal =
                                    "row." + valueR2.sameValue;
                                if (
                                  configArrJson[valueR2.compareValue] &&
                                  configArrJson[valueR2.compareValue][
                                  "layoutComp"
                                  ] == "datagrid"
                                )
                                  valueR2CompareValueVal =
                                    "row." + valueR2.compareValue;
                                //if(configArrJson[valueR2.addYear] && configArrJson[valueR2.addYear]['layoutComp'] == 'datagrid') valueR2addYear = "row."+valueR2.addYear;
                                if (
                                  configArrJson[valueR2.dependValue] &&
                                  configArrJson[valueR2.dependValue][
                                  "layoutComp"
                                  ] == "datagrid"
                                )
                                  valueR2DependValueVal =
                                    "row." + valueR2.dependValue;
                                if (
                                  configArrJson[valueR2.dependValue] &&
                                  configArrJson[valueR2.dependValue][
                                  "layoutComp"
                                  ] == "datagrid"
                                )
                                  valueR2MapValueVal =
                                    "row." + valueR2.mapValue;

                                /*End for datagrid*/

                                var OperatorAdd = valueR2.operator;
                                // console.log("OperatorAdd::::", OperatorAdd);

                                if (OperatorAdd == "=") OperatorAdd = "==";
                                /* if(OperatorAdd == 'equal')
                                  insertArry[keyR2] = {["=="]: [{"var": "data."+valueR2.field},{"var":"data."+valueR2.value}]}; */
                                if (OperatorAdd == "sameLetterFields") {
                                  var cmpVal = valueR2.value;
                                  var cmpValField = valueR2.sameValue;
                                  if (cmpVal == "=") cmpVal = "==";
                                  insertArry[keyR2] = {
                                    [cmpVal]: [
                                      { var: valueR2FieldVal },
                                      { var: valueR2SameValueVal },
                                    ],
                                  };
                                } else if (OperatorAdd == "compareFields") {
                                  var cmpVal = valueR2.value;
                                  var cmpValField = valueR2.compareValue;
                                  var addYear = valueR2.addYear;
                                  if (cmpVal == "=") cmpVal = "==";
                                  //For Date Fields
                                  if (
                                    configArrJson[valueR2.field]["type"] ==
                                    "date" &&
                                    configArrJson[valueR2.compareValue][
                                    "type"
                                    ] == "date"
                                  ) {
                                    if (addYear == "") {
                                      insertArry[keyR2] = {
                                        ["DateComparisonFnOperator"]: [
                                          { var: valueR2FieldVal },
                                          { var: valueR2CompareValueVal },
                                          cmpVal,
                                        ],
                                      };
                                    } else if (addYear != "") {
                                      insertArry[keyR2] = {
                                        ["checkDOP"]: [
                                          { var: valueR2FieldVal },
                                          { var: valueR2CompareValueVal },
                                          addYear,
                                          cmpVal,
                                        ],
                                      };
                                    }
                                  } else {
                                    insertArry[keyR2] = {
                                      [cmpVal]: [
                                        { var: valueR2FieldVal },
                                        { var: valueR2CompareValueVal },
                                      ],
                                    };
                                  }
                                } else if (OperatorAdd == "startsWith") {
                                  var cmpVal = valueR2.value;
                                  var cmpValField = valueR2.desiredValue;
                                  var cmpValFieldArr = cmpValField.split(",");
                                  //if(cmpVal == '=') cmpVal = '==';

                                  insertArry[keyR2] = {
                                    ["in"]: [
                                      {
                                        ["substr"]: [
                                          { var: valueR2FieldVal },
                                          parseInt(valueR2.value),
                                          parseInt(valueR2.lengthValue),
                                        ],
                                      },
                                      cmpValFieldArr,
                                    ],
                                  };
                                  inArray.push(valueR2FieldVal);
                                  //insertArry[keyR2] = {['substr']: [{"var": "data."+valueR2.field},{"var":"data."+valueR2.desiredValue}]};
                                } else if (OperatorAdd == "map") {
                                  // console.log("inside map ::::::")
                                  var dependVal = valueR2.dependValue;
                                  var mapVal = valueR2.mapValue;
                                  var targetVal = valueR2.field;
                                  //console.log(targetVal);
                                  var logicArr = [];

                                  //insertArry[keyR2] = {"if" : [ {"==": [{"var":"data."+valueR2.dependValue}, true] }, {"var":"data."+valueR2.mapValue}, ""]};
                                  //insertArry[keyR2] = {"if" :[ {"and": [{"==": [{"var":"data."+valueR2.dependValue}, true] }, {"==": [{"var":"data."+valueR2.mapValue}, {"var":"data."+valueR2.field}] }]},true,"not same"]};
                                  insertArry[keyR2] = {
                                    if: [
                                      {
                                        or: [
                                          {
                                            and: [
                                              {
                                                "==": [
                                                  {
                                                    var: valueR2DependValueVal,
                                                  },
                                                  true,
                                                ],
                                              },
                                              {
                                                "==": [
                                                  { var: valueR2MapValueVal },
                                                  { var: valueR2FieldVal },
                                                ],
                                              },
                                            ],
                                          },
                                          {
                                            "==": [
                                              { var: valueR2DependValueVal },
                                              false,
                                            ],
                                          },
                                        ],
                                      },
                                    ],
                                  };
                                  insertArry[keyR2] = {
                                    if: [
                                      {
                                        or: [
                                          {
                                            and: [
                                              {
                                                "==": [
                                                  {
                                                    var: valueR2DependValueVal,
                                                  },
                                                  true,
                                                ],
                                              },
                                              {
                                                "==": [
                                                  { var: valueR2MapValueVal },
                                                  { var: valueR2FieldVal },
                                                ],
                                              },
                                            ],
                                          },
                                          {
                                            "==": [
                                              { var: valueR2DependValueVal },
                                              false,
                                            ],
                                          },
                                        ],
                                      },
                                    ],
                                  };

                                  var logicObj = [
                                    {
                                      name: "same as correspondence",
                                      trigger: {
                                        type: "simple",
                                        simple: {
                                          show: true,
                                          when: dependVal,
                                          eq: "true",
                                        },
                                      },
                                      actions: [
                                        {
                                          name: "set permanent address",
                                          type: "value",
                                          value:
                                            "value = " +
                                            valueR2MapValueVal +
                                            "",
                                        },
                                      ],
                                    },
                                  ];

                                  logicArr.push(logicObj);
                                } else if (OperatorAdd == "validationRule") {
                                  var REValidt = valueR2.value;
                                  var patternStr = "";
                                  for (let keyVRule in REValidt) {
                                    var ValueREValidt = REValidt[keyVRule];

                                    if (ValueREValidt == "Alpha")
                                      patternStr += "A-Za-z"; //"^[A-Za-z]+$";
                                    else if (ValueREValidt == "Numeric")
                                      patternStr += "0-9"; //"^[A-Za-z]+$";
                                    else if (
                                      ValueREValidt == "Special character"
                                    ) {
                                      var specValidt = valueR2.specialValue;
                                      for (let keySpecRule in specValidt) {
                                        var ValueSpecValidt =
                                          specValidt[keySpecRule];
                                        var patternStrAdd = ValueSpecValidt;
                                        if (ValueSpecValidt == "s")
                                          patternStrAdd = "\\s";
                                        patternStr += patternStrAdd;
                                      }
                                    }
                                  }

                                  if (patternStr != "") {
                                    var patternFinalStr =
                                      "^[" + patternStr + "]+$";
                                    insertArry[keyR2] = {
                                      ["regexp_matches"]: [
                                        patternFinalStr,
                                        { var: valueR2FieldVal },
                                      ],
                                    };
                                    // console.log("insertArry[keyR2]::::"+JSON.stringify(insertArry[keyR2]))
                                  }
                                } else if (OperatorAdd == "concat") {
                                  var REValidt = valueR2.concatValue;
                                  var arrLength = REValidt.length;
                                  var concatArr = [];
                                  var spaceAdd = " ";

                                  for (var keyVRule in REValidt) {
                                    /* if (keyVRule != arrLength) {
                                      spaceAdd = " ";
                                    }
                                    if (keyVRule != arrLength-1) {
                                      //spaceAdd = " ";
                                      var concatVal = {"var": "data."+REValidt[keyVRule]+" "};
                                    } else {
                                      var concatVal = {"var": "data."+REValidt[keyVRule]};
                                    } */
                                    var REValidtVal =
                                      "data." + REValidt[keyVRule];
                                    if (
                                      configArrJson[REValidt[keyVRule]][
                                      "layoutComp"
                                      ] == "datagrid"
                                    )
                                      REValidtVal = "row." + REValidt[keyVRule];
                                    var concatVal = { var: REValidtVal };
                                    /* if (keyVRule != arrLength-1) {
                                      concatVal += " ";
                                    } */

                                    concatArr.push(concatVal);
                                    concatArr.push(spaceAdd);
                                  }
                                  //console.log('start');
                                  //console.log(concatArr);
                                  insertArry[keyR2] = { ["cat"]: concatArr };
                                } else if (OperatorAdd == "notZeros") {
                                  insertArry[keyR2] = {
                                    ["notZeros"]: [{ var: valueR2FieldVal }],
                                  };
                                } else {
                                  if (valueR2.value == null) valueR2.value = "";
                                  if (OperatorAdd == "WorkExpvalidationDate") {
                                    insertArry[keyR2] = {
                                      ["WorkExpvalidationRule"]: [
                                        valueR2.field,
                                        { var: "rowIndex" },
                                        configArrJson[valueR2.field][
                                        "layoutCompKey"
                                        ],
                                        {
                                          var:
                                            "data." +
                                            configArrJson[valueR2.field][
                                            "layoutCompKey"
                                            ],
                                        },
                                        valueR2.ToWokExpDate,
                                      ],
                                    };
                                  } else if (
                                    configArrJson[valueR2.field]["type"] ==
                                    "date" &&
                                    valueR2.value != ""
                                  ) {
                                    insertArry[keyR2] = {
                                      ["DateComparisonFnOperator"]: [
                                        { var: valueR2FieldVal },
                                        valueR2.value,
                                        OperatorAdd,
                                      ],
                                    };
                                  } else {
                                    insertArry[keyR2] = {
                                      [OperatorAdd]: [
                                        { var: valueR2FieldVal },
                                        valueR2.value,
                                      ],
                                    };
                                  }
                                }
                              }
                            }
                          }
                          var conditionalChild = valueR["condition"];
                          console.log(
                            " Inside if conditionalChild::::",
                            conditionalChild
                          );

                          // console.log("conditionalChild::::", conditionalChild);

                          if (keyR1 == "rules") {
                            //RulePushArray[0] = {[conditionalChild] : insertArry};
                            if (ruleEngForm.value.ruleFor == "Fee") {
                              let feeCondKey = "feeVal" + i;
                              let feeAmt =
                                ruleEngForm.value[feeCondKey] == "0"
                                  ? "NIL"
                                  : ruleEngForm.value[feeCondKey];
                              RulePushArrayOrig.push(
                                { [conditionalChild]: insertArry },
                                feeAmt
                              );
                            } else if (
                              ruleEngForm.value.ruleFor == "Eligibility"
                            ) {
                              // console.log("Iam in validation field::::::::::::::");
                              RulePushArrayOrig.push({
                                [conditionalChild]: insertArry,
                              });
                            } else if (
                              ruleEngForm.value.ruleFor == "Conditional"
                            ) {
                              console.log("inside conditional", insertArry);
                              RulePushArrayOrig.push({
                                [conditionalChild]: insertArry,
                              });
                            } else if (
                              ruleEngForm.value.ruleFor == "Concatination" ||
                              ruleEngForm.value.ruleFor == "mapValue"
                            ) {
                              RulePushArrayOrig.push({
                                [conditionalChild]: insertArry,
                              });
                            } else if (
                              ruleEngForm.value.ruleFor == "alert" ||
                              ruleEngForm.value.ruleFor == "alert"
                            ) {
                              // console.log("Iam in alert field::::::::::::::");

                              RulePushArrayOrig.push({
                                [conditionalChild]: insertArry,
                              });
                            }
                          }
                        }
                        console.log(
                          "RulePushArrayOrig after push inside ifblock",
                          JSON.stringify(RulePushArrayOrig)
                        );
                        j++;
                        if (j === Number(valueR["rules"].length) - 1) {
                          flag = true;
                        }
                      }
                    }
                  } else if (
                    typeof condValChk != "undefined" &&
                    typeof valueR["rules"][m]["rules"] != "undefined"
                  ) {
                    console.log(
                      "Inside first else if block???????????",
                      valueR
                    );

                    console.log(
                      "nested flag default" + m + "index flag value",
                      nestedFlag
                    );
                    if (nestedFlag == false) {
                      for (let keyR1 in valueR) {
                        let key;
                        // RulePushArrayOrig = [];
                        var valueR1 = valueR[keyR1];

                        var RulePushArray = new Array();
                        var insertArry = new Array();

                        if (keyR1 == "rules") {
                          // Rules base

                          console.log("Inner Rulesets are--", valueR1);

                          let feeAmt;
                          for (let keyR2 in valueR1) {
                            key = keyR2;
                            //console.log("keyR2 is", keyR2);
                            console.log(
                              "Inner Ruleset value " + keyR2 + "is::",
                              valueR1[keyR2]
                            );
                            if (valueR1[keyR2].rules !== undefined) {
                              var valueR2 = valueR1[keyR2];

                              if (valueR2.operator != "") {
                                if (valueR2.rules != undefined) {
                                  for (let keyR3 in valueR2) {
                                    var valueR4 = valueR2[keyR3];
                                    var RulePushArray = new Array();
                                    var insertArry = new Array();

                                    if (keyR3 == "rules") {
                                      // Rules base

                                      for (let keyR4 in valueR4) {
                                        var valueR5 = valueR4[keyR4];
                                        console.log(
                                          "Rules inside each Inner ruleset is",
                                          valueR5
                                        );

                                        /*Start for datagrid*/
                                        var valueR5FieldVal =
                                          "data." + valueR5.field;
                                        var valueR5SameValueVal =
                                          "data." + valueR5.sameValue;
                                        var valueR5CompareValueVal =
                                          "data." + valueR5.compareValue;
                                        //var valueR2addYear = "data."+valueR2.addYear;
                                        var valueR5DependValueVal =
                                          "data." + valueR5.dependValue;
                                        var valueR5MapValueVal =
                                          "data." + valueR5.mapValue;
                                        // console.log("configarrjson", configArrJson[valueR5]);

                                        if (
                                          configArrJson[valueR5.field][
                                          "layoutComp"
                                          ] == "datagrid"
                                        )
                                          valueR5FieldVal =
                                            "row." + valueR5.field;
                                        if (
                                          configArrJson[valueR5.sameValue] &&
                                          configArrJson[valueR5.sameValue][
                                          "layoutComp"
                                          ] == "datagrid"
                                        )
                                          valueR5SameValueVal =
                                            "row." + valueR5.sameValue;
                                        if (
                                          configArrJson[valueR5.compareValue] &&
                                          configArrJson[valueR5.compareValue][
                                          "layoutComp"
                                          ] == "datagrid"
                                        )
                                          valueR5CompareValueVal =
                                            "row." + valueR5.compareValue;
                                        if (
                                          configArrJson[valueR5.dependValue] &&
                                          configArrJson[valueR5.dependValue][
                                          "layoutComp"
                                          ] == "datagrid"
                                        )
                                          valueR5DependValueVal =
                                            "row." + valueR5.dependValue;
                                        if (
                                          configArrJson[valueR5.dependValue] &&
                                          configArrJson[valueR5.dependValue][
                                          "layoutComp"
                                          ] == "datagrid"
                                        )
                                          valueR5MapValueVal =
                                            "row." + valueR5.mapValue;

                                        /*End for datagrid*/

                                        var OperatorAdd = valueR5.operator;
                                        //console.log("OperatorAdd::::", OperatorAdd);

                                        if (OperatorAdd == "=")
                                          OperatorAdd = "==";

                                        if (OperatorAdd == "sameLetterFields") {
                                          var cmpVal = valueR5.value;
                                          var cmpValField = valueR5.sameValue;
                                          if (cmpVal == "=") cmpVal = "==";
                                          insertArry[keyR4] = {
                                            [cmpVal]: [
                                              { var: valueR5FieldVal },
                                              { var: valueR5SameValueVal },
                                            ],
                                          };
                                        } else if (
                                          OperatorAdd == "compareFields"
                                        ) {
                                          var cmpVal = valueR5.value;
                                          var cmpValField =
                                            valueR5.compareValue;
                                          var addYear = valueR5.addYear;
                                          if (cmpVal == "=") cmpVal = "==";
                                          //For Date Fields
                                          if (
                                            configArrJson[valueR5.field][
                                            "type"
                                            ] == "date" &&
                                            configArrJson[valueR5.compareValue][
                                            "type"
                                            ] == "date"
                                          ) {
                                            if (addYear == "") {
                                              insertArry[keyR4] = {
                                                ["DateComparisonFnOperator"]: [
                                                  { var: valueR5FieldVal },
                                                  {
                                                    var: valueR5CompareValueVal,
                                                  },
                                                  cmpVal,
                                                ],
                                              };
                                            } else if (addYear != "") {
                                              insertArry[keyR4] = {
                                                ["checkDOP"]: [
                                                  { var: valueR5FieldVal },
                                                  {
                                                    var: valueR5CompareValueVal,
                                                  },
                                                  addYear,
                                                  cmpVal,
                                                ],
                                              };
                                            }
                                          } else {
                                            insertArry[keyR4] = {
                                              [cmpVal]: [
                                                { var: valueR5FieldVal },
                                                { var: valueR5CompareValueVal },
                                              ],
                                            };
                                          }
                                        } else if (
                                          OperatorAdd == "startsWith"
                                        ) {
                                          var cmpVal = valueR5.value;
                                          var cmpValField =
                                            valueR5.desiredValue;
                                          var cmpValFieldArr =
                                            cmpValField.split(",");
                                          //if(cmpVal == '=') cmpVal = '==';

                                          insertArry[keyR4] = {
                                            ["in"]: [
                                              {
                                                ["substr"]: [
                                                  { var: valueR5FieldVal },
                                                  parseInt(valueR5.value),
                                                  parseInt(valueR5.lengthValue),
                                                ],
                                              },
                                              cmpValFieldArr,
                                            ],
                                          };
                                        } else if (OperatorAdd == "map") {
                                          // console.log("inside map ::::::")
                                          var dependVal = valueR5.dependValue;
                                          var mapVal = valueR5.mapValue;
                                          var targetVal = valueR5.field;
                                          //console.log(targetVal);
                                          var logicArr = [];

                                          insertArry[keyR4] = {
                                            if: [
                                              {
                                                or: [
                                                  {
                                                    and: [
                                                      {
                                                        "==": [
                                                          {
                                                            var: valueR5DependValueVal,
                                                          },
                                                          true,
                                                        ],
                                                      },
                                                      {
                                                        "==": [
                                                          {
                                                            var: valueR5MapValueVal,
                                                          },
                                                          {
                                                            var: valueR5FieldVal,
                                                          },
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                  {
                                                    "==": [
                                                      {
                                                        var: valueR5DependValueVal,
                                                      },
                                                      false,
                                                    ],
                                                  },
                                                ],
                                              },
                                            ],
                                          };
                                          insertArry[keyR4] = {
                                            if: [
                                              {
                                                or: [
                                                  {
                                                    and: [
                                                      {
                                                        "==": [
                                                          {
                                                            var: valueR5DependValueVal,
                                                          },
                                                          true,
                                                        ],
                                                      },
                                                      {
                                                        "==": [
                                                          {
                                                            var: valueR5MapValueVal,
                                                          },
                                                          {
                                                            var: valueR5FieldVal,
                                                          },
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                  {
                                                    "==": [
                                                      {
                                                        var: valueR5DependValueVal,
                                                      },
                                                      false,
                                                    ],
                                                  },
                                                ],
                                              },
                                            ],
                                          };

                                          var logicObj = [
                                            {
                                              name: "same as correspondence",
                                              trigger: {
                                                type: "simple",
                                                simple: {
                                                  show: true,
                                                  when: dependVal,
                                                  eq: "true",
                                                },
                                              },
                                              actions: [
                                                {
                                                  name: "set permanent address",
                                                  type: "value",
                                                  value:
                                                    "value = " +
                                                    valueR5MapValueVal +
                                                    "",
                                                },
                                              ],
                                            },
                                          ];

                                          logicArr.push(logicObj);
                                        } else if (
                                          OperatorAdd == "validationRule"
                                        ) {
                                          var REValidt = valueR5.value;
                                          var patternStr = "";
                                          for (let keyVRule in REValidt) {
                                            var ValueREValidt =
                                              REValidt[keyVRule];

                                            if (ValueREValidt == "Alpha")
                                              patternStr += "A-Za-z";
                                            //"^[A-Za-z]+$";
                                            else if (ValueREValidt == "Numeric")
                                              patternStr += "0-9";
                                            //"^[A-Za-z]+$";
                                            else if (
                                              ValueREValidt ==
                                              "Special character"
                                            ) {
                                              var specValidt =
                                                valueR5.specialValue;
                                              for (let keySpecRule in specValidt) {
                                                var ValueSpecValidt =
                                                  specValidt[keySpecRule];
                                                var patternStrAdd =
                                                  ValueSpecValidt;
                                                if (ValueSpecValidt == "s")
                                                  patternStrAdd = "\\s";
                                                patternStr += patternStrAdd;
                                              }
                                            }
                                          }

                                          if (patternStr != "") {
                                            var patternFinalStr =
                                              "^[" + patternStr + "]+$";
                                            insertArry[keyR4] = {
                                              ["regexp_matches"]: [
                                                patternFinalStr,
                                                { var: valueR5FieldVal },
                                              ],
                                            };
                                          }
                                        } else if (OperatorAdd == "concat") {
                                          var REValidt = valueR5.concatValue;
                                          var arrLength = REValidt.length;
                                          var concatArr = [];
                                          var spaceAdd = " ";

                                          for (var keyVRule in REValidt) {
                                            var REValidtVal =
                                              "data." + REValidt[keyVRule];
                                            if (
                                              configArrJson[REValidt[keyVRule]][
                                              "layoutComp"
                                              ] == "datagrid"
                                            )
                                              REValidtVal =
                                                "row." + REValidt[keyVRule];
                                            var concatVal = {
                                              var: REValidtVal,
                                            };

                                            concatArr.push(concatVal);
                                            concatArr.push(spaceAdd);
                                          }

                                          insertArry[keyR4] = {
                                            ["cat"]: concatArr,
                                          };
                                        } else if (OperatorAdd == "notZeros") {
                                          insertArry[keyR4] = {
                                            ["notZeros"]: [
                                              { var: valueR5FieldVal },
                                            ],
                                          };
                                        } else {
                                          if (valueR5.value == null)
                                            valueR5.value = "";
                                          if (
                                            OperatorAdd ==
                                            "WorkExpvalidationDate"
                                          ) {
                                            insertArry[keyR4] = {
                                              ["WorkExpvalidationRule"]: [
                                                valueR5.field,
                                                { var: "rowIndex" },
                                                configArrJson[valueR5.field][
                                                "layoutCompKey"
                                                ],
                                                {
                                                  var:
                                                    "data." +
                                                    configArrJson[
                                                    valueR5.field
                                                    ]["layoutCompKey"],
                                                },
                                                valueR5.ToWokExpDate,
                                              ],
                                            };
                                          } else if (
                                            configArrJson[valueR5.field][
                                            "type"
                                            ] == "date" &&
                                            valueR5.value != ""
                                          ) {
                                            insertArry[keyR4] = {
                                              ["DateComparisonFnOperator"]: [
                                                { var: valueR5FieldVal },
                                                valueR5.value,
                                                OperatorAdd,
                                              ],
                                            };
                                          } else {
                                            insertArry[keyR4] = {
                                              [OperatorAdd]: [
                                                { var: valueR5FieldVal },
                                                valueR5.value,
                                              ],
                                            };
                                            nestedInsertArr.push(
                                              insertArry[keyR4]
                                            );
                                            var insertedArr = insertArry[keyR4];
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                              var conditionalChildNested = valueR2["condition"];
                            }

                            var conditionalChild = valueR["condition"];

                            console.log(
                              "valueR1[keyR2].rules ",
                              valueR1[keyR2].rules
                            );

                            if (
                              keyR1 == "rules" &&
                              valueR1[keyR2].rules !== undefined
                            ) {
                              if (ruleEngForm.value.ruleFor == "Fee") {
                                let feeCondKey = "feeVal" + i;
                                feeAmt =
                                  ruleEngForm.value[feeCondKey] == "0"
                                    ? "NIL"
                                    : ruleEngForm.value[feeCondKey];
                                nestedRulePushArrayOrig = {
                                  [conditionalChildNested]: insertArry,
                                };
                                console.log(
                                  "RulePushArrayOrig inside fee block",
                                  {
                                    [conditionalChild]: nestedRulePushArrayOrig,
                                  }
                                );
                                nestedRulePushArrayOrig1.push(
                                  nestedRulePushArrayOrig
                                );
                              } else if (
                                ruleEngForm.value.ruleFor == "Eligibility"
                              ) {
                                nestedRulePushArrayOrig = {
                                  [conditionalChildNested]: insertArry,
                                };

                                console.log(
                                  "nested rule array after push validation",
                                  JSON.stringify(nestedRulePushArrayOrig)
                                );
                                nestedRulePushArrayOrig1.push(
                                  nestedRulePushArrayOrig
                                );
                              } else if (
                                ruleEngForm.value.ruleFor == "Conditional"
                              ) {
                                console.log("inside conditional", insertArry);
                                console.log(
                                  "nested RulePushArrayOrig inside conditional block",
                                  { [conditionalChildNested]: insertArry }
                                );
                                console.log(
                                  "old RulePushArrayOrig",
                                  JSON.stringify(RulePushArrayOrig)
                                );
                                console.log(
                                  "nested rule array before push",
                                  JSON.stringify(nestedRulePushArrayOrig)
                                );
                                nestedRulePushArrayOrig = {
                                  [conditionalChildNested]: insertArry,
                                };
                                console.log(
                                  "nested rule array after push",
                                  JSON.stringify(nestedRulePushArrayOrig)
                                );

                                nestedRulePushArrayOrig1.push(
                                  nestedRulePushArrayOrig
                                );

                                console.log(
                                  "New RulePushArrayOrig is===",
                                  JSON.stringify(RulePushArrayOrig)
                                );
                              } else if (
                                ruleEngForm.value.ruleFor == "Concatination" ||
                                ruleEngForm.value.ruleFor == "mapValue"
                              ) {
                                nestedRulePushArrayOrig = {
                                  [conditionalChildNested]: insertArry,
                                };
                                console.log(
                                  "RulePushArrayOrig inside concatination block",
                                  {
                                    [conditionalChild]: nestedRulePushArrayOrig,
                                  }
                                );
                                nestedRulePushArrayOrig1.push(
                                  nestedRulePushArrayOrig
                                );
                              } else if (
                                ruleEngForm.value.ruleFor == "alert" ||
                                ruleEngForm.value.ruleFor == "alert"
                              ) {
                                // console.log("Iam in alert field::::::::::::::");
                                nestedRulePushArrayOrig = {
                                  [conditionalChildNested]: insertArry,
                                };
                                console.log(
                                  "RulePushArrayOrig inside alert block",
                                  {
                                    [conditionalChild]: nestedRulePushArrayOrig,
                                  }
                                );
                                nestedRulePushArrayOrig1.push(
                                  nestedRulePushArrayOrig
                                );
                              }
                            }

                            nestedRulePushArrayOrig = [];
                          }

                          console.log("nestedRulePushArrayOrig1 outside loop ", nestedRulePushArrayOrig1);
                          console.log("RulePushArrayOrig out", JSON.stringify(RulePushArrayOrig));

                          if (ruleEngForm.value.ruleFor == 'Fee') {
                            RulePushArrayOrig.push({ [conditionalChild]: nestedRulePushArrayOrig1 }, feeAmt);
                          } else {
                            RulePushArrayOrig.push({ [conditionalChild]: nestedRulePushArrayOrig1 });
                            console.log("final RulePushArrayOrig in else", JSON.stringify(RulePushArrayOrig));

                          }

                          nestedRulePushArrayOrig1 = [];
                          console.log(
                            "Number(valueR['rules'].length) % 2???>>>>>",
                            Number(valueR["rules"].length) % 2
                          );
                          even++;
                          console.log(
                            "valueR['rules'].length in if ",
                            Number(valueR["rules"].length) - 1
                          );
                          if (even === Number(valueR["rules"].length) - 1) {
                            console.log("inside cond");
                            nestedFlag = true;
                          }
                        }
                      }
                    }
                  } else {
                    var insertArryc = new Array();
                    var OperatorAdd = valueR.operator;
                    if (OperatorAdd == "=") OperatorAdd = "==";
                    operatorList.push(OperatorAdd);
                    /*Start for datagrid*/
                    console.log("am i in else part");

                    console.log("valueR.field>>>>>", valueR.field)
                    dopVariable.push(valueR.field);
                    var valueRFieldVal = "data." + valueR.field;
                    var valueRSameValueVal = "data." + valueR.sameValue;
                    var valueRCompareValueVal = "data." + valueR.compareValue;
                    //var valueRaddYear = "data."+valueR.addYear;
                    var valueRDependValueVal = "data." + valueR.dependValue;
                    var valueRMapValueVal = "data." + valueR.mapValue;

                    var condition = "";
                    if (conditionList[0] == "and") {
                      condition = "&&";
                      jsCondition.push(condition);
                    } else if (conditionList[0] == "or") {
                      condition = "||";
                      jsCondition.push(condition);
                    }

                    alertMassageData.push(
                      valueRFieldVal,
                      OperatorAdd,
                      valueR.value,
                      condition
                    );
                    if (configArrJson[valueR.field]["layoutComp"] == "datagrid")
                      valueRFieldVal = "row." + valueR.field;
                    if (
                      configArrJson[valueR.sameValue] &&
                      configArrJson[valueR.sameValue]["layoutComp"] ==
                      "datagrid"
                    )
                      valueRSameValueVal = "row." + valueR.sameValue;
                    if (
                      configArrJson[valueR.compareValue] &&
                      configArrJson[valueR.compareValue]["layoutComp"] ==
                      "datagrid"
                    )
                      valueRCompareValueVal = "row." + valueR.compareValue;
                    //if(configArrJson[valueR.addYear] && configArrJson[valueR.addYear]['layoutComp'] == 'datagrid') valueRaddYear = "row."+valueR.addYear;
                    if (
                      configArrJson[valueR.dependValue] &&
                      configArrJson[valueR.dependValue]["layoutComp"] ==
                      "datagrid"
                    )
                      valueRDependValueVal = "row." + valueR.dependValue;
                    if (
                      configArrJson[valueR.dependValue] &&
                      configArrJson[valueR.dependValue]["layoutComp"] ==
                      "datagrid"
                    )
                      valueRMapValueVal = "row." + valueR.mapValue;

                    /*End for datagrid*/

                    //console.log(OperatorAdd);
                    //insertArryc = {[OperatorAdd]: [{"var": "data."+valueR.field},valueR.value]};
                    /* if(OperatorAdd == 'equal')
                      RulePushArrayOrig.push({["=="]: [{"var": "data."+valueR.field},{"var":"data."+valueR.value}]}); */

                    if (OperatorAdd == "sameLetterFields") {
                      var cmpVal = valueR.value;
                      var cmpValField = valueR.sameValue;
                      if (cmpVal == "=") cmpVal = "==";
                      RulePushArrayOrig.push({
                        [cmpVal]: [
                          { var: valueRFieldVal },
                          { var: valueRSameValueVal },
                        ],
                      });
                      // console.log("RulePushArrayOrig:::::", RulePushArrayOrig);
                    } else if (OperatorAdd == "compareFields") {
                      var cmpVal = valueR.value;
                      var cmpValField = valueR.compareValue;
                      var addYear = valueR.addYear;
                      if (cmpVal == "=") cmpVal = "==";

                      //For Date Fields
                      if (
                        configArrJson[valueR.field]["type"] == "date" &&
                        configArrJson[valueR.compareValue]["type"] == "date"
                      ) {
                        if (addYear != "" && addYear !== null) {
                          RulePushArrayOrig.push({
                            ["checkDOP"]: [
                              { var: valueRFieldVal },
                              { var: valueRCompareValueVal },
                              addYear,
                              cmpVal,
                            ],
                          });
                        } else if (addYear == "" || addYear === null) {
                          RulePushArrayOrig.push({
                            ["DateComparisonFnOperator"]: [
                              { var: valueRFieldVal },
                              { var: valueRCompareValueVal },
                              cmpVal,
                            ],
                          });
                        }
                      } else {
                        RulePushArrayOrig.push({
                          [cmpVal]: [
                            { var: valueRFieldVal },
                            { var: valueRCompareValueVal },
                          ],
                        });
                      }
                    } else if (OperatorAdd == "startsWith") {
                      /* var cmpVal = valueR2.value; */
                      var cmpValField = valueR.desiredValue;
                      var cmpValFieldArr = cmpValField.split(",");
                      //if(cmpVal == '=') cmpVal = '==';

                      //RulePushArrayOrig.push({['in']: [{['substr']:[{"var": "data."+valueR2.field},valueR2.value]},cmpValFieldArr]});
                      RulePushArrayOrig.push({
                        ["in"]: [
                          {
                            ["substr"]: [
                              { var: valueRFieldVal },
                              parseInt(valueR.value),
                              parseInt(valueR.lengthValue),
                            ],
                          },
                          cmpValFieldArr,
                        ],
                      });
                      //insertArry[keyR2] = {['substr']: [{"var": "data."+valueR2.field},{"var":"data."+valueR2.desiredValue}]};
                    } else if (OperatorAdd == "map") {
                      // console.log("inside second map:")
                      var dependVal = valueR.dependValue;
                      var mapVal = valueR.mapValue;
                      var targetVal = valueR.field;
                      //console.log(targetVal);
                      var logicArr = [];

                      //RulePushArrayOrig.push({"if" : [ {"==": [{"var":"data."+valueR.dependValue}, true] }, {"var":"data."+valueR.mapValue}, ""]});
                      //RulePushArrayOrig.push({"if" :[ {"and": [{"==": [{"var":"data."+valueR.dependValue}, true] }, {"==": [{"var":"data."+valueR.mapValue}, {"var":"data."+valueR.field}] }]}]});
                      RulePushArrayOrig.push({
                        if: [
                          {
                            or: [
                              {
                                and: [
                                  {
                                    "==": [{ var: valueRDependValueVal }, true],
                                  },
                                  {
                                    "==": [
                                      { var: valueRMapValueVal },
                                      { var: valueRFieldVal },
                                    ],
                                  },
                                ],
                              },
                              { "==": [{ var: valueRDependValueVal }, false] },
                            ],
                          },
                        ],
                      });

                      var logicObj = [
                        {
                          name: "same as correspondence",
                          trigger: {
                            type: "simple",
                            simple: { show: true, when: dependVal, eq: "true" },
                          },
                          actions: [
                            {
                              name: "set permanent address",
                              type: "value",
                              value: "value = " + mapVal + "",
                            },
                          ],
                        },
                      ];

                      logicArr.push(logicObj);
                      //insertArry[keyR2] = {"if" : [ {"==": [{"var":"data."+valueR2.dependValue}, true] }, {"var":"data."+valueR2.mapValue}, ""]}
                    } else if (OperatorAdd == "validationRule") {
                      var REValidt = valueR.value;
                      var patternStr = "";
                      for (let keyVRule in REValidt) {
                        var ValueREValidt = REValidt[keyVRule];
                        if (ValueREValidt == "Alpha")
                          patternStr += "A-Za-z"; //"^[A-Za-z]+$";
                        else if (ValueREValidt == "Numeric")
                          patternStr += "0-9"; //"^[A-Za-z]+$";
                        else if (ValueREValidt == "Special character") {
                          var specValidt = valueR.specialValue;
                          //console.log(specValidt);
                          for (let keySpecRule in specValidt) {
                            var ValueSpecValidt = specValidt[keySpecRule];
                            var patternStrAdd = ValueSpecValidt;
                            if (ValueSpecValidt == "s") patternStrAdd = "\\s";
                            patternStr += patternStrAdd;
                          }
                        }
                      }

                      // console.log("patternStr:::::",patternStr);
                      if (patternStr != "") {
                        var patternFinalStr = "^[" + patternStr + "]+$";
                        RulePushArrayOrig.push({
                          ["regexp_matches"]: [
                            patternFinalStr,
                            { var: valueRFieldVal },
                          ],
                        });
                        // console.log("RulePushArrayOrig::"+JSON.stringify(RulePushArrayOrig))
                      }
                    } else if (OperatorAdd == "concat") {
                      var REValidt = valueR.concatValue;
                      var arrLength = REValidt.length;
                      var concatArr = [];
                      var spaceAdd = " ";
                      //console.log("innnnnnnnnnnnnnn");
                      //console.log(REValidt);
                      for (var keyVRule in REValidt) {
                        /* if (keyVRule != arrLength) {
                          spaceAdd = " ";
                        }
                        if (keyVRule != arrLength-1) {
                          //spaceAdd = " ";
                          var concatVal = {"var": "data."+REValidt[keyVRule]+" "};
                        } else {
                          var concatVal = {"var": "data."+REValidt[keyVRule]};
                        } */
                        var REValidtVal = "data." + REValidt[keyVRule];
                        if (
                          configArrJson[REValidt[keyVRule]]["layoutComp"] ==
                          "datagrid"
                        )
                          REValidtVal = "row." + REValidt[keyVRule];
                        var concatVal = { var: REValidtVal };

                        concatArr.push(concatVal);
                        concatArr.push(spaceAdd);
                      }
                      //console.log('start');
                      //console.log(concatArr);
                      //insertArry[keyR2] = {["cat"]: concatArr};
                      RulePushArrayOrig.push({ ["cat"]: concatArr });
                    } else if (OperatorAdd == "notZeros") {
                      RulePushArrayOrig.push({
                        ["notZeros"]: { var: valueRFieldVal },
                      });
                    } else if (OperatorAdd == "matchArray") {
                      arrayVal = valueR.value;
                      arrayField = valueR.field;
                      console.log("arrayval is", arrayVal);
                      console.log("arrayField is ", arrayField);
                      operatorListData = OperatorAdd;
                      console.log("Updated array is", operatorListData);
                    } else if (OperatorAdd == "arrayLength") {
                      var arrayLengVal = valueR.value;
                      var cmparrayLengVal = valueR.compareValue;
                      var reqLeng = valueR.addYear;
                      if (arrayLengVal == "=") arrayLengVal = "==";
                      operatorListDataLength = OperatorAdd;
                    } else {
                      if (OperatorAdd == "WorkExpvalidationDate") {
                        let dataGridData =
                          "data." +
                          configArrJson[valueR.field]["layoutCompKey"];
                        RulePushArrayOrig.push({
                          ["WorkExpvalidationRule"]: [
                            valueR.field,
                            { var: "rowIndex" },
                            configArrJson[valueR.field]["layoutCompKey"],
                            {
                              var:
                                "data." +
                                configArrJson[valueR.field]["layoutCompKey"],
                            },
                            valueR.ToWokExpDate,
                          ],
                        });
                      } else if (
                        configArrJson[valueR.field]["type"] == "date" &&
                        valueR.value != ""
                      ) {
                        RulePushArrayOrig.push({
                          ["DateComparisonFnOperator"]: [
                            { var: valueRFieldVal },
                            valueR.value,
                          ],
                          OperatorAdd,
                        });
                      } else {
                        RulePushArrayOrig.push({
                          [OperatorAdd]: [
                            { var: valueRFieldVal },
                            valueR.value,
                          ],
                        });

                        variableKey.push(valueRFieldVal);
                      }
                    }
                  }
                }
              } else {
                console.log("inside else>>>><<<><>>M");

                var insertArryc = new Array();
                var OperatorAdd = valueR.operator;
                if (OperatorAdd == "=") OperatorAdd = "==";
                operatorList.push(OperatorAdd);
                dopVariable.push(valueR.field);
                /*Start for datagrid*/
                var valueRFieldVal = "data." + valueR.field;
                var valueRSameValueVal = "data." + valueR.sameValue;
                var valueRCompareValueVal = "data." + valueR.compareValue;
                //var valueRaddYear = "data."+valueR.addYear;
                var valueRDependValueVal = "data." + valueR.dependValue;
                var valueRMapValueVal = "data." + valueR.mapValue;

                var condition = "";
                if (conditionList[0] == "and") {
                  condition = "&&";
                  jsCondition.push(condition);
                } else if (conditionList[0] == "or") {
                  condition = "||";
                  jsCondition.push(condition);
                }

                alertMassageData.push(
                  valueRFieldVal,
                  OperatorAdd,
                  valueR.value,
                  condition
                );
                if (configArrJson[valueR.field]["layoutComp"] == "datagrid")
                  valueRFieldVal = "row." + valueR.field;
                if (
                  configArrJson[valueR.sameValue] &&
                  configArrJson[valueR.sameValue]["layoutComp"] == "datagrid"
                )
                  valueRSameValueVal = "row." + valueR.sameValue;
                if (
                  configArrJson[valueR.compareValue] &&
                  configArrJson[valueR.compareValue]["layoutComp"] == "datagrid"
                )
                  valueRCompareValueVal = "row." + valueR.compareValue;
                //if(configArrJson[valueR.addYear] && configArrJson[valueR.addYear]['layoutComp'] == 'datagrid') valueRaddYear = "row."+valueR.addYear;
                if (
                  configArrJson[valueR.dependValue] &&
                  configArrJson[valueR.dependValue]["layoutComp"] == "datagrid"
                )
                  valueRDependValueVal = "row." + valueR.dependValue;
                if (
                  configArrJson[valueR.dependValue] &&
                  configArrJson[valueR.dependValue]["layoutComp"] == "datagrid"
                )
                  valueRMapValueVal = "row." + valueR.mapValue;

                /*End for datagrid*/

                //console.log(OperatorAdd);
                //insertArryc = {[OperatorAdd]: [{"var": "data."+valueR.field},valueR.value]};
                /* if(OperatorAdd == 'equal')
                  RulePushArrayOrig.push({["=="]: [{"var": "data."+valueR.field},{"var":"data."+valueR.value}]}); */

                if (OperatorAdd == "sameLetterFields") {
                  var cmpVal = valueR.value;
                  var cmpValField = valueR.sameValue;
                  if (cmpVal == "=") cmpVal = "==";
                  RulePushArrayOrig.push({
                    [cmpVal]: [
                      { var: valueRFieldVal },
                      { var: valueRSameValueVal },
                    ],
                  });
                  // console.log("RulePushArrayOrig:::::", RulePushArrayOrig);
                } else if (OperatorAdd == "compareFields") {
                  var cmpVal = valueR.value;
                  var cmpValField = valueR.compareValue;
                  var addYear = valueR.addYear;
                  if (cmpVal == "=") cmpVal = "==";

                  //For Date Fields
                  if (
                    configArrJson[valueR.field]["type"] == "date" &&
                    configArrJson[valueR.compareValue]["type"] == "date"
                  ) {
                    if (addYear != "" && addYear !== null) {
                      RulePushArrayOrig.push({
                        ["checkDOP"]: [
                          { var: valueRFieldVal },
                          { var: valueRCompareValueVal },
                          addYear,
                          cmpVal,
                        ],
                      });
                    } else if (addYear == "" || addYear === null) {
                      RulePushArrayOrig.push({
                        ["DateComparisonFnOperator"]: [
                          { var: valueRFieldVal },
                          { var: valueRCompareValueVal },
                          cmpVal,
                        ],
                      });
                    }
                  } else {
                    RulePushArrayOrig.push({
                      [cmpVal]: [
                        { var: valueRFieldVal },
                        { var: valueRCompareValueVal },
                      ],
                    });
                  }
                } else if (OperatorAdd == "startsWith") {
                  /* var cmpVal = valueR2.value; */
                  var cmpValField = valueR.desiredValue;
                  var cmpValFieldArr = cmpValField.split(",");
                  //if(cmpVal == '=') cmpVal = '==';

                  //RulePushArrayOrig.push({['in']: [{['substr']:[{"var": "data."+valueR2.field},valueR2.value]},cmpValFieldArr]});
                  RulePushArrayOrig.push({
                    ["in"]: [
                      {
                        ["substr"]: [
                          { var: valueRFieldVal },
                          parseInt(valueR.value),
                          parseInt(valueR.lengthValue),
                        ],
                      },
                      cmpValFieldArr,
                    ],
                  });
                  //insertArry[keyR2] = {['substr']: [{"var": "data."+valueR2.field},{"var":"data."+valueR2.desiredValue}]};
                } else if (OperatorAdd == "map") {
                  // console.log("inside second map:")
                  var dependVal = valueR.dependValue;
                  var mapVal = valueR.mapValue;
                  var targetVal = valueR.field;
                  //console.log(targetVal);
                  var logicArr = [];

                  //RulePushArrayOrig.push({"if" : [ {"==": [{"var":"data."+valueR.dependValue}, true] }, {"var":"data."+valueR.mapValue}, ""]});
                  //RulePushArrayOrig.push({"if" :[ {"and": [{"==": [{"var":"data."+valueR.dependValue}, true] }, {"==": [{"var":"data."+valueR.mapValue}, {"var":"data."+valueR.field}] }]}]});
                  RulePushArrayOrig.push({
                    if: [
                      {
                        or: [
                          {
                            and: [
                              { "==": [{ var: valueRDependValueVal }, true] },
                              {
                                "==": [
                                  { var: valueRMapValueVal },
                                  { var: valueRFieldVal },
                                ],
                              },
                            ],
                          },
                          { "==": [{ var: valueRDependValueVal }, false] },
                        ],
                      },
                    ],
                  });

                  var logicObj = [
                    {
                      name: "same as correspondence",
                      trigger: {
                        type: "simple",
                        simple: { show: true, when: dependVal, eq: "true" },
                      },
                      actions: [
                        {
                          name: "set permanent address",
                          type: "value",
                          value: "value = " + valueRMapValueVal + "",
                        },
                      ],
                    },
                  ];

                  logicArr.push(logicObj);
                  //insertArry[keyR2] = {"if" : [ {"==": [{"var":"data."+valueR2.dependValue}, true] }, {"var":"data."+valueR2.mapValue}, ""]}
                } else if (OperatorAdd == "validationRule") {
                  var REValidt = valueR.value;
                  var patternStr = "";
                  for (let keyVRule in REValidt) {
                    var ValueREValidt = REValidt[keyVRule];
                    if (ValueREValidt == "Alpha")
                      patternStr += "A-Za-z"; //"^[A-Za-z]+$";
                    else if (ValueREValidt == "Numeric")
                      patternStr += "0-9"; //"^[A-Za-z]+$";
                    else if (ValueREValidt == "Special character") {
                      var specValidt = valueR.specialValue;
                      //console.log(specValidt);
                      for (let keySpecRule in specValidt) {
                        var ValueSpecValidt = specValidt[keySpecRule];
                        var patternStrAdd = ValueSpecValidt;
                        if (ValueSpecValidt == "s") patternStrAdd = "\\s";
                        patternStr += patternStrAdd;
                      }
                    }
                  }

                  // console.log("patternStr:::::",patternStr);
                  if (patternStr != "") {
                    var patternFinalStr = "^[" + patternStr + "]+$";
                    RulePushArrayOrig.push({
                      ["regexp_matches"]: [
                        patternFinalStr,
                        { var: valueRFieldVal },
                      ],
                    });
                    // console.log("RulePushArrayOrig::"+JSON.stringify(RulePushArrayOrig))
                  }
                } else if (OperatorAdd == "concat") {
                  var REValidt = valueR.concatValue;
                  var arrLength = REValidt.length;
                  var concatArr = [];
                  var spaceAdd = " ";
                  //console.log("innnnnnnnnnnnnnn");
                  //console.log(REValidt);
                  for (var keyVRule in REValidt) {
                    /* if (keyVRule != arrLength) {
                      spaceAdd = " ";
                    }
                    if (keyVRule != arrLength-1) {
                      //spaceAdd = " ";
                      var concatVal = {"var": "data."+REValidt[keyVRule]+" "};
                    } else {
                      var concatVal = {"var": "data."+REValidt[keyVRule]};
                    } */
                    var REValidtVal = "data." + REValidt[keyVRule];
                    if (
                      configArrJson[REValidt[keyVRule]]["layoutComp"] ==
                      "datagrid"
                    )
                      REValidtVal = "row." + REValidt[keyVRule];
                    var concatVal = { var: REValidtVal };

                    concatArr.push(concatVal);
                    concatArr.push(spaceAdd);
                  }
                  //console.log('start');
                  //console.log(concatArr);
                  //insertArry[keyR2] = {["cat"]: concatArr};
                  RulePushArrayOrig.push({ ["cat"]: concatArr });
                } else if (OperatorAdd == "notZeros") {
                  RulePushArrayOrig.push({
                    ["notZeros"]: { var: valueRFieldVal },
                  });
                } else if (OperatorAdd == "matchArray") {
                  arrayVal = valueR.value;
                  arrayField = valueR.field;
                  console.log("arrayval is", arrayVal);
                  console.log("arrayField is ", arrayField);
                  operatorListData = OperatorAdd;
                  console.log("Updated array is", operatorListData);
                } else {
                  if (OperatorAdd == "WorkExpvalidationDate") {
                    let dataGridData =
                      "data." + configArrJson[valueR.field]["layoutCompKey"];
                    RulePushArrayOrig.push({
                      ["WorkExpvalidationRule"]: [
                        valueR.field,
                        { var: "rowIndex" },
                        configArrJson[valueR.field]["layoutCompKey"],
                        {
                          var:
                            "data." +
                            configArrJson[valueR.field]["layoutCompKey"],
                        },
                        valueR.ToWokExpDate,
                      ],
                    });
                  } else if (
                    configArrJson[valueR.field]["type"] == "date" &&
                    valueR.value != ""
                  ) {
                    RulePushArrayOrig.push({
                      ["DateComparisonFnOperator"]: [
                        { var: valueRFieldVal },
                        valueR.value,
                      ],
                      OperatorAdd,
                    });
                  } else {
                    RulePushArrayOrig.push({
                      [OperatorAdd]: [{ var: valueRFieldVal }, valueR.value],
                    });

                    variableKey.push(valueRFieldVal);
                  }
                }
              }
            }
            if (ruleEngForm.value.ruleFor == "Fee") {
              RulePushArrayOrig.push("NIL");
            }
          }
          var RulePushArrayOrigV1 = new Array();
          var conditionalChildV1 = JsonRuleVal["condition"];
          var logicArray = [];
          if (ruleEngForm.value.ruleFor == "Fee") {
            jsonConvertedValue.push({ if: RulePushArrayOrig });
          } else if (
            ruleEngForm.value.ruleFor ==
            "Conditional" /* || ruleEngForm.value.ruleFor == 'mapValue' */
          ) {
            console.log("Inside second conditional else", RulePushArrayOrig);
            console.log("length of  multiple rules", RulePushArrayOrig.length);
            if (RulePushArrayOrig.length > 1) {
              let modifiedJson = [];
              let operator = conditionList[0];
              console.log("operator is========", operator);
              modifiedJson.push({ [operator]: RulePushArrayOrig });
              console.log("modified json is====", modifiedJson);
              jsonConvertedValue = modifiedJson[0];
              console.log("inside length if", jsonConvertedValue);
            } else {
              jsonConvertedValue = RulePushArrayOrig;
              console.log(typeof jsonConvertedValue);
            }
          } else if (ruleEngForm.value.ruleFor == "Concatination") {
            jsonConvertedValue = RulePushArrayOrig;
          } else {
            console.log("inside another else");
            jsonConvertedValue.push({
              if: [
                { [conditionalChildV1]: RulePushArrayOrig },
                true,
                alertmsgstrDisp,
              ],
            });
          }
        }
      }
      //pincode
      if (ruleEngForm.value.ruleFor == "pincode") {
        var fieldToAppedPage = inputSelectInsertVal.split("-");
        var pincodeToString = pincodeStringGenerator(
          dopVariable,
          fieldToAppedPage
        );
        this.arrayLengthString = pincodeToString;
      }
      //minmax  minmax
      if (ruleEngForm.value.ruleFor == "minmax") {
        //if(fieldToAppedPage[1] == 'detailsOfChildren'){
        console.log("dopVariable>>>>", dopVariable);
        var minmaxScriptToString = minmaxStringGenerator(dopVariable);
        this.arrayLengthString = minmaxScriptToString;
        //}
      }

      //pincodeStringGenerator
      function pincodeStringGenerator(dopVariable, fieldToAppedPage) {
        var pincodeString =
          "var stateList1 = " + environment.stateListForTwoSlice + ";"; //2
        pincodeString +=
          "var stateList2 =" + environment.stateListForThreeSlice + ";"; //3
        pincodeString += "var pincode = data." + fieldToAppedPage[1] + ";";
        pincodeString += "var state = data." + dopVariable + ";";
        pincodeString += "var string = pincode.toString();";
        pincodeString += "var st;";
        pincodeString +=
          "if(stateList1.indexOf(state) !== -1){ st = Number(string.slice(0,2));}";
        pincodeString +=
          "else if(stateList2.indexOf(state) !== -1) {st = Number(string.slice(0,3));}";
        pincodeString += "switch(state){";
        pincodeString +=
          'case "andhraPradesh": var listOfPincode = ' +
          environment.andhraPradeshList +
          '; if(listOfPincode.indexOf(st) !== -1){ valid=true;} else { valid="Pincode should start with 50,51,52,53";}break;';
        pincodeString +=
          'case "arunachalPradesh": var listOfPincode = ' +
          environment.arunachalPradeshList +
          '; if(listOfPincode.indexOf(st) !== -1){ valid=true;} else {valid="Pincode should start with 79"; }break;';
        pincodeString +=
          'case "assam": var listOfPincode = ' +
          environment.assamList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 78";} break;';
        pincodeString +=
          'case "bihar": var listOfPincode = ' +
          environment.biharList +
          '; if(listOfPincode.indexOf(st) !== -1){ valid=true; }else {valid="Pincode should start with 80,81,82,83,84,85";} break;';
        pincodeString +=
          'case "chandigarh": var listOfPincode = ' +
          environment.chandigarhList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 49";} break;';
        pincodeString +=
          'case "delhi": var listOfPincode = ' +
          environment.delhiList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 11";} break;';
        pincodeString +=
          'case "goa": var listOfPincode = ' +
          environment.goaList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else{valid="Pincode should start with 40";} break;';
        pincodeString +=
          'case "gujarat": var listOfPincode = ' +
          environment.gujaratList +
          '; if(listOfPincode.indexOf(st) !== -1){valid=true;} else {valid="Pincode should start with 36,37,38,39";} break;';
        pincodeString +=
          'case "haryana": var listOfPincode = ' +
          environment.haryanaList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 12,13";} break;';
        pincodeString +=
          'case "himachalPradesh": var listOfPincode = ' +
          environment.himachalPradeshList +
          '; if(listOfPincode.indexOf(st) !== -1){valid=true;} else{valid="Pincode should start with 17";} break;';
        pincodeString +=
          'case "jammuKashmir": var listOfPincode = ' +
          environment.jammuKashmirList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 18,19";} break;';
        pincodeString +=
          'case "jharkhand": var listOfPincode = ' +
          environment.jammuKashmirList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 80,81,82,83,84,85,93";} break;';
        pincodeString +=
          'case "karnataka": var listOfPincode = ' +
          environment.karnatakaList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 56,57,58,59"; }break;';
        pincodeString +=
          'case "kerala": var listOfPincode = ' +
          environment.keralaList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 67,68,69";} break;';
        pincodeString +=
          'case "madhyaPradesh": var listOfPincode = ' +
          environment.madhyaPradeshList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else{ valid="Pincode should start with 45,46,47,48";} break;';
        pincodeString +=
          'case "maharashtra": var listOfPincode = ' +
          environment.maharashtraList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true; }else{ valid="Pincode should start with 40,41,42,43,44";} break;';
        pincodeString +=
          'case "manipur": var listOfPincode = ' +
          environment.manipurList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 795";} break;';
        pincodeString +=
          'case "mizoram": var listOfPincode = ' +
          environment.mizoramList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 796";} break;';
        pincodeString +=
          'case "nagaland": var listOfPincode = ' +
          environment.nagalandList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 79";} break;';
        pincodeString +=
          'case "odisha": var listOfPincode = ' +
          environment.odishaList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 75,76,77";} break;';
        pincodeString +=
          'case "puducherry": var listOfPincode = ' +
          environment.puducherryList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 60,67,53";} break;';
        pincodeString +=
          'case "punjab": var listOfPincode = ' +
          environment.punjabList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 14,15,16";} break;';
        pincodeString +=
          'case "rajasthan": var listOfPincode = ' +
          environment.rajasthanList +
          '; if(listOfPincode.indexOf(st) !== -1){ valid=true;} else {valid="Pincode should start with 30,31,32,33,34";} break;';
        pincodeString +=
          'case "sikkim": var listOfPincode = ' +
          environment.sikkimList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 73";} break;';
        pincodeString +=
          'case "tamilNadu": var listOfPincode = ' +
          environment.tamilNaduList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 60,61,62,63,64";} break;';
        pincodeString +=
          'case "tripura": var listOfPincode = ' +
          environment.tripuraList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 799";} break;';
        pincodeString +=
          'case "uttarPradesh": var listOfPincode = ' +
          environment.uttarPradeshList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 20,21,22,23,24,25,26,27,28";} break;';
        pincodeString +=
          'case "uttarakhand": var listOfPincode = ' +
          environment.uttarakhandList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 20,21,22,23,24,25,26,27,28";} break;';
        pincodeString +=
          'case "meghalaya": var listOfPincode = ' +
          environment.meghalayaList +
          '; st = Number(string.slice(0,2)); if(st=79){ var threeslice=Number(string.slice(0,3)); if(listOfPincode.indexOf(threeslice) !== -1) {valid=true;} else {valid="Pincode should start with 793,794,783123";} } if(st=78){ var sixslice=Number(string.slice(0,6)); if(listOfPincode.indexOf(sixslice) !== -1) {valid=true;} else {valid="Pincode should start with 793,794,783123"; }} break;';
        pincodeString +=
          'case "westBengal": var listOfPincode = ' +
          environment.westBengalList +
          '; if(listOfPincode.indexOf(st) !== -1) {valid=true;} else {valid="Pincode should start with 70,71,72,73,74,744";} break;';
        pincodeString += "}";

        return pincodeString;
      }

      //minmaxStringGenerator
      function minmaxStringGenerator(dopVariable) {
        var fieldToAppedPage = inputSelectInsertVal.split("-");
        //fieldToAppedPage
        var minmaxString = "valid = true;";
        minmaxString +=
          "if(data." +
          fieldToAppedPage[1] +
          ".length === data." +
          dopVariable[0] +
          "){ valid = true; }";
        minmaxString += "else{ valid =" + '"' + alertmsgstrDisp + '"' + "}";

        console.log("minmaxString>>>>", minmaxString);
        return minmaxString;
      }

      //DOP
      if (ruleEngForm.value.ruleFor == "dop") {
        console.log("dopVariable>>>>>>>>>", dopVariable);
        var fieldToAppedPage = inputSelectInsertVal.split("-");
        console.log("appendField>>>>>>>>>", fieldToAppedPage[1]);
        if (fieldToAppedPage[1] == "from") {
          var convertedScriptToString = dopJsStringGenerator(dopVariable);
          this.arrayLengthString = convertedScriptToString;
        }
        if (fieldToAppedPage[1] == "to") {
          //code for to
          var stringForToResult = stringForTo();
          this.arrayLengthString = stringForToResult;
        }
      }
      //string For TO:
      function stringForTo() {
        var toString =
          'valid = true; var from = row["from"]; var to = row["to"]; ';
        var conditonString =
          'if (from && to) { var fromDate = new Date(from); var toDate = new Date(to); let date1 = fromDate.toLocaleDateString("en-GB"); let date2 = toDate.toLocaleDateString("en-GB");';
        conditonString +=
          "var fDate = convertDateFormat(date1); var tDate = convertDateFormat(date2); if (fDate.getTime() < tDate.getTime()) {";
        conditonString +=
          'valid = true} else { valid = "to date should be greater than from date"; } }';
        var convertDateFormat =
          'function convertDateFormat(dateToConvert) { var newdate = dateToConvert.split("/").reverse().join("-"); ';
        convertDateFormat +=
          "var birthDate = new Date(newdate); var convertedDate = new Date(birthDate); return convertedDate; }";

        toString += conditonString + convertDateFormat;

        return toString;
      }

      if (operatorListData === "matchArray") {
        let i = 0;
        let totalValues = [];
        for (i = 0; i < arrayVal.length; i++) {
          console.log("inside matcharray", arrayVal);
          let modifiedarrayValue = '"' + arrayVal[i] + '"';
          console.log(modifiedarrayValue);
          totalValues.push(modifiedarrayValue);
        }
        console.log(totalValues);
        var javascriptlogic =
          "let valuesArray=[];valuesArray= data." +
          arrayField +
          ";console.log(valuesArray);let rulesArray=[];rulesArray = [" +
          totalValues +
          "];function findCommonElement(valuesArray, rulesArray) { for(let i = 0; i < valuesArray.length; i++) {for(let j = 0; j < rulesArray.length; j++) {if(valuesArray[i] === rulesArray[j]) { show = true; return true; }} } show = false;return false; } console.log(findCommonElement(valuesArray, rulesArray));";
        console.log("the formatted js logic", javascriptlogic);

        this.arrayMatchString = javascriptlogic;
      }
      if (operatorListDataLength === "arrayLength") {
        var javascriptvalidationlogic =
          "value =data." +
          cmparrayLengVal +
          ";lenght=value.length;if(lenght>" +
          reqLeng +
          '){valid=true; }else{valid="' +
          alertmsgstrDisp +
          '";}';

        this.arrayLengthString = javascriptvalidationlogic;
      }

      if (ruleEngForm.value.ruleFor == "alert") {
        console.log("variableValue::", variableValue);
        console.log("variableKey::", variableKey);
        console.log("operatorList::", operatorList);

        if (operatorList.includes("in")) {
          var multiCheckPopup = popUpWithAndIN(
            variableKey,
            variableValue,
            operatorList,
            jsCondition,
            alertmsgstrDisp
          );
          logicArray = createSimpleLogicJs(multiCheckPopup);
        } else {
          var jstring = stringCondition(
            variableKey,
            variableValue,
            operatorList,
            jsCondition,
            alertmsgstrDisp
          );
          logicArray = createSimpleLogicJs(jstring);
          console.log("logicArray>>>", logicArray);
        }
      }

      function stringCondition(
        variableKey,
        variableValue,
        operatorArray,
        jsCondition,
        alertmsgstrDisp
      ) {
        let i = 0;
        var jstring = "if(";
        var jsStringValue = "";
        var elseIfCheck = "";
        var randomString = generateString(5);

        for (i = 0; i < variableKey.length; i++) {
          if (i + 1 == variableKey.length) {
            jsStringValue +=
              variableKey[i] +
              " " +
              operatorArray[i] +
              " " +
              '"' +
              variableValue[i] +
              '"';
            elseIfCheck +=
              variableKey[i] + " " + "!==" + " " + '"' + variableValue[i] + '"';
          } else {
            jsStringValue +=
              variableKey[i] +
              " " +
              operatorArray[i] +
              " " +
              '"' +
              variableValue[i] +
              '"' +
              " " +
              jsCondition[i] +
              " ";
            elseIfCheck +=
              variableKey[i] +
              " " +
              "!==" +
              " " +
              '"' +
              variableValue[i] +
              '"' +
              " " +
              "||" +
              " ";
          }
        }

        jstring +=
          jsStringValue +
          " && !data." +
          randomString +
          '){alert("' +
          alertmsgstrDisp +
          '");data.' +
          randomString +
          " = true;}else if(" +
          elseIfCheck +
          ")" +
          "{data." +
          randomString +
          " = false;}";

        return jstring;
      }

      function popUpWithAndIN(
        variableKey,
        variableValue,
        operatorArray,
        jsCondition,
        alertmsgstrDisp
      ) {
        let i = 0;
        let j = 0;
        var jsStringValue = "if(";
        var flagString = "{switch(" + variableKey[1] + ") {";
        var onlyInflag = "{switch(" + variableKey[0] + ") {";
        var flagtrueFalse = "";
        var elseIfCheck = "";
        var randomString = generateString(5);
        var dependentString = variableValue[0];
        var listOfCheck = variableValue[1];

        var flagArray = [];
        if (operatorList.length == 1 && operatorList.includes("in")) {
          //console.log('variable value:::', variableValue[0])

          for (i = 0; i < dependentString.length; i++) {
            var flag = generateString(5);
            flagArray.push(flag);

            if (i + 1 == dependentString.length) {
              jsStringValue +=
                "(" +
                variableKey[0] +
                " " +
                "===" +
                ' "' +
                dependentString[i] +
                '"' +
                " " +
                "&&" +
                " " +
                "!data." +
                flag +
                ")";
            } else {
              jsStringValue +=
                "(" +
                variableKey[0] +
                " " +
                "===" +
                ' "' +
                dependentString[i] +
                '"' +
                " " +
                "&&" +
                " " +
                "!data." +
                flag +
                ") ||";
            }
          }

          for (i = 0; i < dependentString.length; i++) {
            onlyInflag +=
              " case " +
              "'" +
              dependentString[i] +
              "'" +
              ': alert("' +
              alertmsgstrDisp +
              '");';
            flagtrueFalse = "";
            for (j = 0; j < dependentString.length; j++) {
              if (flagArray[i] == flagArray[j]) {
                console.log("result:::", flagArray[i] + " - " + flagArray[j]);

                flagtrueFalse += "data." + flagArray[j] + "= true;";
              } else {
                flagtrueFalse += "data." + flagArray[j] + "= false;";
              }
            }

            onlyInflag += flagtrueFalse + " break;";
          }

          onlyInflag += "}}";
          jsStringValue += ")" + onlyInflag;
        } else {
          for (i = 0; i < listOfCheck.length; i++) {
            var flag = generateString(5);
            flagArray.push(flag);

            if (i + 1 == listOfCheck.length) {
              jsStringValue +=
                "(" +
                variableKey[0] +
                " " +
                operatorArray[0] +
                " " +
                '"' +
                dependentString +
                '"' +
                " " +
                jsCondition[0] +
                " " +
                variableKey[1] +
                " " +
                operatorArray[0] +
                ' "' +
                listOfCheck[i] +
                '"' +
                " " +
                jsCondition[0] +
                " " +
                "!data." +
                flag +
                ")";
            } else {
              jsStringValue +=
                "(" +
                variableKey[0] +
                " " +
                operatorArray[0] +
                " " +
                '"' +
                dependentString +
                '"' +
                " " +
                jsCondition[0] +
                " " +
                variableKey[1] +
                " " +
                operatorArray[0] +
                ' "' +
                listOfCheck[i] +
                '"' +
                " " +
                jsCondition[0] +
                " " +
                "!data." +
                flag +
                ") ||";
            }
          }

          //console.log("flagArray::", flagArray);
          for (i = 0; i < listOfCheck.length; i++) {
            flagString +=
              " case " +
              "'" +
              listOfCheck[i] +
              "'" +
              ': alert("' +
              alertmsgstrDisp +
              '");';
            flagtrueFalse = "";
            for (j = 0; j < listOfCheck.length; j++) {
              if (flagArray[i] == flagArray[j]) {
                console.log("result:::", flagArray[i] + " - " + flagArray[j]);

                flagtrueFalse += "data." + flagArray[j] + "= true;";
              } else {
                flagtrueFalse += "data." + flagArray[j] + "= false;";
              }
            }

            flagString += flagtrueFalse + " break;";
          }
          flagString += "}}";
          jsStringValue += ")" + flagString;
        }

        console.log("jsStringValue:::", jsStringValue);

        return jsStringValue;
      }

      function generateString(length) {
        const characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
        let result = " ";
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
          result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
          );
        }

        return result;
      }

      //dop js code
      function dopJsStringGenerator(dopVariable) {
        var dopString = "valid = true;";
        var appData = " var appData = {";
        var queryString =
          " var queryString = Object.keys(appData).map(key => key + '=' + appData[key]).join('&'); ";
        var apiCallString =
          "if (from && post !== undefined  && yearsOfExperienceInMonthTestGrid != 0){ ";
        var dateString = "function giveMeDates(from, responseDate) {";
        for (let item = 0; item < dopVariable.length; item++) {
          dopString +=
            " var " +
            dopVariable[item] +
            " = " +
            "data." +
            dopVariable[item] +
            ";";

          if (item + 1 === dopVariable.length) {
            console.log("inside if:::", dopVariable[item]);

            appData += dopVariable[item] + " : " + dopVariable[item];
          } else {
            appData += dopVariable[item] + " : " + dopVariable[item] + ", ";
          }
        }
        dopString += appData + "}; " + queryString;

        apiCallString +=
          'var theUrl = "http://223.30.223.183/application_api/api/application/getProjectRuleData?"+queryString; ';
        apiCallString += ' xmlhttp.open("GET", theUrl, false);';
        apiCallString +=
          "xmlhttp.onload = function () { var parse = JSON.parse(xmlhttp.responseText);";
        apiCallString +=
          'if (parse.status == 200) { var responseDate = parse.data;  console.log("fromDate:::", from); console.log("responseDate:::", responseDate);';
        apiCallString +=
          ' if (giveMeDates(from, responseDate)) { valid = "from date should be greater than all other dates"} else { valid = true; }';
        apiCallString +=
          ' if (parse.status == 400) { valid = "please check the form details"; } } xmlhttp.send(); } }';

        dateString +=
          "var fromDate = new Date(from); var checkDate = new Date(responseDate);";
        dateString += "if (fDate.getYear() <= cDate.getYear()) {";
        dateString += "return true;} else {return false;}}";

        dopString += apiCallString + " " + " " + dateString;
        console.log("dopString>>>", dopString);

        return dopString;
      }

      console.log("logicArray>>>", logicArray);

      if (logicArray) {
        var logicArrVal = logicArray;
        this.logicString = logicArrVal.map(function (e) {
          return JSON.stringify(e);
        });
      }

      function createSimpleLogicJs(jstring) {
        let logic = [];

        let fldLogic = {
          name: "popup",
          trigger: {
            type: "javascript",
            javascript: jstring,
          },
          actions: [],
        };
        logic.push(fldLogic);

        return logic;
      }
      console.log("ruleEngForm.value.ruleFor>>>", ruleEngForm.value.ruleFor);

      if (
        ruleEngForm.value.ruleFor == "Conditional" &&
        RulePushArrayOrig.length > 1
      ) {
        console.log("inside new if cond", jsonConvertedValue);
        var datastringCondn = jsonConvertedValue;

        var stringified = JSON.stringify(datastringCondn);
        this.jsonConvertedString = stringified;
      } else {
        console.log("inside else");
        console.log("jsonConvertedValue:::::", jsonConvertedValue);
        jsonConvertedValue = jsonConvertedValue.map(function (e) {
          return JSON.stringify(e);
        });

        console.log("outside condn", jsonConvertedValue);

        var dataString = jsonConvertedValue.join(",");
        console.log("the jsonconverted string is", dataString);

        // var staticjson = {
        //   "and": [{
        //     "==": [{
        //       "var": "data.post1"
        //     }, "juniorEngineer"]
        //   }, {
        //     "==": [{
        //       "var": "data.selectOne"
        //     }, null]
        //   }]
        // };
        // var stringified = JSON.stringify(staticjson);
        this.jsonConvertedString = dataString;
        // this.jsonConvertedString = stringified;
        console.log(
          "the type of Jsonconvertedstring is",
          typeof this.jsonConvertedString
        );
      }
      //   jsonConvertedValue = jsonConvertedValue.map(function (e) {
      //     return JSON.stringify(e);
      //   });

      //   console.log("outside condn", jsonConvertedValue);

      //   var dataString = jsonConvertedValue.join(",");
      //   console.log("the jsonconverted string is", dataString);

      //   // var staticjson = {
      //   //   "and": [{
      //   //     "==": [{
      //   //       "var": "data.post1"
      //   //     }, "juniorEngineer"]
      //   //   }, {
      //   //     "==": [{
      //   //       "var": "data.selectOne"
      //   //     }, null]
      //   //   }]
      //   // };
      //   // var stringified = JSON.stringify(staticjson);
      //   this.jsonConvertedString = dataString;
      // // this.jsonConvertedString = stringified;
      //   console.log("the type of Jsonconvertedstring is", typeof(this.jsonConvertedString));
      console.log("logicArr>>>", logicArr);

      if (logicArr) {
        var logicArrVal = logicArr;
        this.logicString = logicArrVal.map(function (e) {
          return JSON.stringify(e);
        });
      }

      var obj = JSON.parse(JSON.stringify(this.QueryBuilderConfigOrigArr));
      // console.log("obj>>>", obj);
      var inputSelectInsertArr = inputSelectInsertVal.split("-");
      var indexPageVal = inputSelectInsertArr[0]; // page1
      console.log("indexPageVal>>>", indexPageVal);
      var compIndexPageVal = inputSelectInsertArr[1]; //firtsName
      console.log("compIndexPageVal>>>", compIndexPageVal);

      if (
        ruleEngForm.value.ruleFor == "Fee" ||
        ruleEngForm.value.ruleFor == "Concatination"
      ) {
        obj = this.jsonAppendComponent_Fee(
          obj,
          indexPageVal,
          compIndexPageVal,
          "update"
        );
      } else if (ruleEngForm.value.ruleFor == "Conditional") {
        obj = this.jsonAppendComponent_cnd(
          obj,
          indexPageVal,
          compIndexPageVal,
          "update"
        );
      } else if (ruleEngForm.value.ruleFor == "mapValue") {
        obj = this.jsonAppendComponent_map(
          obj,
          indexPageVal,
          compIndexPageVal,
          "update"
        );
      } else if (ruleEngForm.value.ruleFor == "alert") {
        obj = this.jsonAppendComponent_alert(
          obj,
          indexPageVal,
          compIndexPageVal,
          "update"
        );
      } else {
        console.log("inside validate");
        obj = this.jsonAppendComponent(
          obj,
          indexPageVal,
          compIndexPageVal,
          "update"
        );
        console.log("obj>>>", obj);
      }

      this.QueryBuilderConfigOrigArr = obj;
      var Jsonapplncomp: Object = {
        components: this.QueryBuilderConfigOrigArr,
        display: "wizard",
      };

      ruleEngForm.value.accountName = this.model.accountName;
      ruleEngForm.value.projectName = this.model.projectName;

      ruleEngForm.value.appendField = inputSelectInsertVal;
      ruleEngForm.value.appendFieldLabel = compIndexPageVal;
      ruleEngForm.value.querybuiderconfig = this.config;
      ruleEngForm.value.query = this.query;
      //  ruleEngForm.value.rulesJsonLogic = this.jsonConvertedString;
      if (operatorListData === "matchArray") {
        console.log("the json converted string is", this.arrayMatchString);
        ruleEngForm.value.rulesJsonLogic = this.arrayMatchString;
        console.log("Rule engine value is", ruleEngForm.value.rulesJsonLogic);
      } else {
        console.log("inside else", typeof this.jsonConvertedString);
        //  var stringified = JSON.stringify(this.jsonConvertedString);
        ruleEngForm.value.rulesJsonLogic = JSON.parse(this.jsonConvertedString);
        // ruleEngForm.value.rulesJsonLogic = JSON.parse(stringified);
      }

      // ruleEngForm.value.rulesJsonLogic = JSON.parse(this.jsonConvertedString);
      this.applicationService
        .appSubmit(ruleEngForm.value, Jsonapplncomp)
        .subscribe((res) => {
          if (res.success == true) {
            this.ruleengineService
              .ruleAppSubmit(ruleEngForm.value)
              .subscribe((ruleres) => {
                this.unSaveData = false;
                if (ruleres.success == true) {
                  this.getRuleDet();

                  ruleEngForm.reset();
                  this.query = Object.assign({}, this.queryInitVal);
                  this.btnSubmission = true;
                  this.showCRRule = false;

                  this.toastr.success(ruleres.message);
                } else {
                  this.toastr.error("Error in Creation...");
                  console.log("inside first if");
                }
              });
          } else {
            console.log("inside second if");
            this.toastr.error("Error in Creation...");
          }
        });
    }
  }

  convertJsonQuery1() {
    /* console.log('this.myForm modelid');*/
    console.log("fanta;;", this.myForm.value);
    this.loading = true;
    this.myForm.value.PID = this.model.projectName;
    this.myForm.value.AID = this.model.accountName;
    // let formFieldsOptions = this.myForm.value.formFields;
    let dependtentONOptions = this.myForm.value.dependenton;
    let relaxFieldsOptions = this.myForm.value.relaxFields;

    if (this.fieldListArr[relaxFieldsOptions].hasOwnProperty("options")) {
      let toSaveFormRel = this.myForm.value;
      let relListCount = this.relaxationlistcount.length;
      var filtered = [];
      var filtered_tot = [];
      for (let i = 1; i <= relListCount; i++) {
        let fld = "rel" + i;
        filtered = toSaveFormRel[fld].filter(function (el) {
          return el.relaxFormField != "";
        });
        this.myForm.value[fld] = filtered;
      }
      this.ruleengineService
        .saveAgeRulesManage(this.myForm.value, this.formJsonEdit_id)
        .subscribe((res) => {
          this.unSaveData = false;
          if (res.success == true) {
            //if(res.data.formVal.ageDep == 'Y') {

            let ageDependentFieldName = res.data.formVal.dependenton;
            let ageRelaxtionFieldName = res.data.formVal.relaxFields; //"Relaxation On" field value (category)

            let ageRelaxtionFieldValue = [];
            let ageDependentFieldValue = [];
            let minDate = [];
            let maxDate = [];
            let minAge = [];
            let maxAge = [];
            let maxAgeRelLimit = [];
            let ageRelaxation = [];
            let asOnAge = [];

            // if (res.data.formVal.ageDep == 'Y') {
            // "Dependent On" field value (postAppliedFor) loop
            // for (let optionObj of this.fieldListArr[ageDependentFieldName]['options']) {
            //   ageDependentFieldValue.push(optionObj.value);
            // }
            // }

            // "Relaxation On" field value (category) loop
            for (let optionObj of this.fieldListArr[ageRelaxtionFieldName][
              "options"
            ]) {
              ageRelaxtionFieldValue.push(optionObj.value);
            }

            //age config loop count
            let configCount = Object.keys(res.genFormJSON).length;
            let fieldLevelRelaxation = [];

            let data = res.data.formVal;

            for (var c = 1; c <= configCount; c++) {
              let ageConfigMap = res.data.genRelaxAgeJSON[c].ageConfig;
              let ageConfigVal = res.genFormJSON[ageConfigMap];

              let ageDependentFieldValue = [];
              let ageDependentFieldValueMax = [];

              for (let i = 0; i < ageDependentFieldName.length; i++) {
                let key = "ageDependentFields" + (c - 1) + i;
                ageDependentFieldValue.push({
                  "==": [
                    { var: "data." + ageDependentFieldName[i].formFields },
                    data[key],
                  ],
                });
              }

              console.log("ageDependentFieldValue::", ageDependentFieldValue);

              let fieldName = "ageDependentFields" + (c - 1) + "0";

              let relFieldName = "rel" + c;

              if (
                res.data.formVal.hasOwnProperty(fieldName) &&
                res.data.formVal.hasOwnProperty(relFieldName)
              ) {
                let ageConfigfieldVal = res.data.formVal[fieldName]; //ageDependentFields0

                if (res.data.formVal.ageDep == "Y") {
                  minDate.push({ and: ageDependentFieldValue });
                  minDate.push(ageConfigVal["ageMinDate"]);

                  maxDate.push({ and: ageDependentFieldValue });
                  maxDate.push(ageConfigVal["ageMaxDate"]);

                  minAge.push({ and: ageDependentFieldValue });
                  minAge.push(ageConfigVal["ageMin"]);

                  maxAge.push({ and: ageDependentFieldValue });
                  maxAge.push(ageConfigVal["ageMax"]);

                  maxAgeRelLimit.push({ and: ageDependentFieldValue });
                  maxAgeRelLimit.push(parseInt(ageConfigVal["ageRel"]) * 12);

                  asOnAge.push({ and: ageDependentFieldValue });
                  asOnAge.push(ageConfigVal["ageAsonDate"]);
                } else {
                  var minDateVal = ageConfigVal["ageMinDate"];
                  var maxDateVal = ageConfigVal["ageMaxDate"];
                  var minAgeVal = ageConfigVal["ageMin"];
                  var maxAgeVal = ageConfigVal["ageMax"];
                  var maxAgeRelLimitVal = parseInt(ageConfigVal["ageRel"]) * 12;
                  var asOnAgeVal = ageConfigVal["ageAsonDate"];
                }

                let relFieldsCount = res.data.formVal[relFieldName].length;
                for (let relObj of res.data.formVal[relFieldName]) {
                  let basicRelaxation = [];
                  let object = {};

                  for (let relVal of ageRelaxtionFieldValue) {
                    console.log("relVal::", relVal);
                    let basicCond = [];
                    let cValue: number = 0;
                    let genderfield = relObj["genderFormField_first"];
                    console.log("genderfield::", genderfield);
                    let genderValue = relObj["genderFormField_sec"];
                    console.log("genderValue::", genderValue);
                    if (res.data.formVal.ageDep == "Y") {
                      ageDependentFieldValueMax = [];
                      for (let i = 0; i < ageDependentFieldName.length; i++) {
                        let key = "ageDependentFields" + (c - 1) + i;
                        ageDependentFieldValueMax.push({
                          "==": [
                            {
                              var:
                                "data." + ageDependentFieldName[i].formFields,
                            },
                            data[key],
                          ],
                        });
                      }
                      ageDependentFieldValueMax.push({
                        "==": [
                          { var: "data." + ageRelaxtionFieldName },
                          relVal,
                        ],
                      });

                      if (
                        relObj["genderFormField_first"] != "" &&
                        relObj["genderFormField_sec"] != ""
                      ) {
                        ageDependentFieldValueMax.push({
                          "==": [{ var: "data." + genderfield }, genderValue],
                        });
                      }

                      basicCond.push({ and: ageDependentFieldValueMax });
                    }

                    //  object={"and":ageDependentFieldValueMax };

                    cValue = parseInt(relObj[relVal]) * 12;
                    let relaxationField = relObj["relaxFormField"];
                    let relaxationFieldOpt =
                      this.getRelaxationFieldOptions(relaxationField);
                    var addService = 0;
                    if (
                      relObj["relaxFormField"] != ageRelaxtionFieldName &&
                      relObj["relaxFormField"] != "" &&
                      ((relObj["relaxFormField_sec"] != "" &&
                        relObj["relaxFormField_sec"] !=
                        relObj["relaxFormField"]) ||
                        relObj["relaxFormField_sec"] == "")
                    ) {
                      let optYes;
                      if (relaxationFieldOpt.indexOf("Yes") >= 0)
                        optYes = relaxationFieldOpt.indexOf("Yes");
                      else if (relaxationFieldOpt.indexOf("yes") >= 0)
                        optYes = relaxationFieldOpt.indexOf("yes");

                      if (optYes !== "")
                        basicCond.push({
                          "==": [
                            { var: "data." + relaxationField },
                            relaxationFieldOpt[optYes],
                          ],
                        });
                      // object={ "==": [{ "var": "data." + relaxationField }, relaxationFieldOpt[optYes]] };
                    }
                    if (
                      relObj["relaxFormField_sec"] != "" &&
                      relObj["relaxFormField_third"] != ""
                    ) {
                      basicCond.push({
                        "==": [
                          { var: "data." + relObj["relaxFormField_sec"] },
                          relObj["relaxFormField_third"],
                        ],
                      });
                      // object={ "==": [{ "var": "data." + relObj['relaxFormField_sec'] }, relObj['relaxFormField_third']] };
                    } /* else if(relObj['relaxFormField_sec']!=''){
										addService = 1;
									}  */

                    if (relObj["relaxFormFieldAvail"] != "") {
                      addService = 1; //basicCond.push({"==":[{"var":"data."+relObj['relaxFormFieldAvail']},relObj['relaxFormFieldAvail_sec']]});
                    }
                    console.log("basicCond::", basicCond);
                    basicRelaxation.push({ and: basicCond });
                    console.log("cValue::", cValue);

                    if (addService == 0) basicRelaxation.push(cValue);
                    if (addService == 1) {
                      //For Period of service
                      let periodOfService =
                        relObj["relaxFormFieldAvail_sec"] != ""
                          ? parseInt(relObj["relaxFormFieldAvail_sec"]) * 12
                          : 0;
                      console.log("periodOfService::", periodOfService);
                      basicRelaxation.push({
                        if: [
                          {
                            "<": [
                              {
                                "+": [
                                  {
                                    if: [
                                      {
                                        "<=": [
                                          {
                                            var:
                                              "data." +
                                              relObj["relaxFormFieldAvail"],
                                          },
                                          "0",
                                        ],
                                      },
                                      "0",
                                      {
                                        var:
                                          "data." +
                                          relObj["relaxFormFieldAvail"],
                                      },
                                    ],
                                  },
                                  cValue,
                                ],
                              },
                              periodOfService,
                            ],
                          },
                          {
                            "+": [
                              {
                                if: [
                                  {
                                    "<=": [
                                      {
                                        var:
                                          "data." +
                                          relObj["relaxFormFieldAvail"],
                                      },
                                      "0",
                                    ],
                                  },
                                  "0",
                                  {
                                    var:
                                      "data." + relObj["relaxFormFieldAvail"],
                                  },
                                ],
                              },
                              cValue,
                            ],
                          },
                          periodOfService,
                        ],
                      });
                    }
                  }
                  basicRelaxation.push("0");
                  console.log("basicRelaxation::", basicRelaxation);
                  fieldLevelRelaxation.push({ if: basicRelaxation });
                }
              }
            }
            let ageLimitFn = [];
            let ageLimit = [];
            let ageLimitCondition = "";
            let ageLimitConditionOR = "";
            let ageLimitConditionIF = [];

            if (res.data.formVal.ageDep == "Y") {
              ageLimitFn.push({ if: minDate });
              ageLimitFn.push({ if: maxDate });
              ageLimitFn.push({ if: minAge });
              ageLimitFn.push({ if: maxAge });
              ageLimitFn.push({ if: maxAgeRelLimit });
            } else {
              ageLimitFn.push(minDateVal);
              ageLimitFn.push(maxDateVal);
              ageLimitFn.push(minAgeVal);
              ageLimitFn.push(maxAgeVal);
              ageLimitFn.push(maxAgeRelLimitVal);
            }
            console.log("fieldLevelRelaxation::", fieldLevelRelaxation);
            ageLimitFn.push({ max: fieldLevelRelaxation });
            ageLimitFn.push({ var: "data.dob" });
            let orArray = [];
            orArray.push({ ageLimit: ageLimitFn });
            let ifArray = [];
            let jsonConvertedValueAge = [];
            let jsonConvertedValueAgeCalc = [];
            ifArray.push({ or: orArray });
            ifArray.push(true);
            ifArray.push("invalid age");
            ageLimitConditionIF.push({ if: ifArray });

            jsonConvertedValueAge = ageLimitConditionIF.map(function (e) {
              return JSON.stringify(e);
            });
            var dataString = jsonConvertedValueAge.join(",");
            this.jsonConvertedStringAge = dataString;

            var obj = JSON.parse(
              JSON.stringify(this.QueryBuilderConfigOrigArr)
            );

            var inputSelectInsertArr = res.data.formVal.dobVal.split("-");
            var indexPageVal = inputSelectInsertArr[0]; // page1
            var compIndexPageVal = inputSelectInsertArr[1]; //firtsName
            //console.log(this.jsonConvertedStringAge);
            obj = this.jsonAppendComponent(
              obj,
              indexPageVal,
              compIndexPageVal,
              "ageFn"
            );

            let ageCalFn = [];
            if (res.data.formVal.ageDep == "Y") ageCalFn.push({ if: asOnAge });
            else ageCalFn.push(asOnAgeVal);
            ageCalFn.push({ var: "data.dob" });
            let ageCal = [];
            ageCal.push({ ageCalculation: ageCalFn });
            jsonConvertedValueAgeCalc = ageCal.map(function (e) {
              return JSON.stringify(e);
            });
            var dataString1 = jsonConvertedValueAgeCalc.join(",");
            this.jsonConvertedStringAgeClc = dataString1;

            var inputSelectInsertArr1 = res.data.formVal.ageVal.split("-");
            var indexPageVal1 = inputSelectInsertArr1[0]; // page1
            var compIndexPageVal1 = inputSelectInsertArr1[1]; //firtsName
            obj = this.jsonAppendComponent_Fee(obj, indexPageVal1, compIndexPageVal1, 'ageFn');

            this.QueryBuilderConfigOrigArr = (obj);
            console.log("this.QueryBuilderConfigOrigArr is", this.QueryBuilderConfigOrigArr);
            var Jsonapplncomp: Object = {
              components: this.QueryBuilderConfigOrigArr,
              display: "wizard",
            };
            var ruleEngWork;

            ruleEngWork = {
              accountName: this.model.accountName,
              projectName: this.model.projectName,
            };

            this.applicationService
              .appSubmit(ruleEngWork, Jsonapplncomp)
              .subscribe((res) => {
                this.loading = false;
                if (res.success == true) {
                  //this.resetAgeEng();
                  //alert(aletMsg);
                  this.toastr.success("Age config created Successfully...");
                } else {
                  this.toastr.error("Error in Creation...");
                }
              });
            //}

            this.formJsonEdit_id = res.data._id;
            this.getRuleDet();
          }
        });
    } else {
      this.loading = false;
      this.toastr.error(
        "Please select valid value in Dependent On and Relaxation On"
      );
    }
  }

  deleteAgeRelax() {
    //console.log(this.myForm.value)
    this.jsonConvertedStringAge = "";
    var obj = JSON.parse(JSON.stringify(this.QueryBuilderConfigOrigArr));
    var inputSelectInsertArr = this.myForm.value.dobVal.split("-");
    var indexPageVal = inputSelectInsertArr[0]; // page1
    var compIndexPageVal = inputSelectInsertArr[1]; //firtsName
    obj = this.jsonAppendComponent(
      obj,
      indexPageVal,
      compIndexPageVal,
      "ageFn"
    );

    this.jsonConvertedStringAgeClc = "";
    var inputSelectInsertArr1 = this.myForm.value.ageVal.split("-");
    var indexPageVal1 = inputSelectInsertArr1[0]; // page1
    var compIndexPageVal1 = inputSelectInsertArr1[1]; //firtsName
    obj = this.jsonAppendComponent_Fee(
      obj,
      indexPageVal1,
      compIndexPageVal1,
      "ageFn"
    );
  }

  getRelaxationFieldOptions(relaxFld) {
    let relaxFldValue = [];
    if (this.fieldListArr[relaxFld]["options"]) {
      if (this.fieldListArr[relaxFld]["options"].length > 0) {
        for (let optionObj of this.fieldListArr[relaxFld]["options"]) {
          relaxFldValue.push(optionObj.value);
        }
      }
    }
    return relaxFldValue;
  }

  DelRuleField(fieldName: String, ruleID: String, typeStr: String) {
    //console.log("ommm "+ruleID);
    if (confirm("Are you sure want to delete this rule?")) {
      var obj = JSON.parse(JSON.stringify(this.QueryBuilderConfigOrigArr));
      var inputSelectInsertArr = fieldName.split("-");
      var indexPageVal = inputSelectInsertArr[0]; // page1
      var compIndexPageVal = inputSelectInsertArr[1]; //firtsName
      /* console.log(indexPageVal);
      console.log(compIndexPageVal); */

      if (typeStr == "Eligibility")
        var obj = this.jsonAppendComponent(
          obj,
          indexPageVal,
          compIndexPageVal,
          "delete"
        );
      else if (typeStr == "Fee" || typeStr == "Concatination")
        var obj = this.jsonAppendComponent_Fee(
          obj,
          indexPageVal,
          compIndexPageVal,
          "delete"
        );
      else if (typeStr == "Conditional")
        var obj = this.jsonAppendComponent_cnd(
          obj,
          indexPageVal,
          compIndexPageVal,
          "delete"
        );
      else if (typeStr == "mapValue")
        var obj = this.jsonAppendComponent_map(
          obj,
          indexPageVal,
          compIndexPageVal,
          "delete"
        );
      else if (typeStr == "alert")
        var obj = this.jsonAppendComponent_alert(
          obj,
          indexPageVal,
          compIndexPageVal,
          "delete"
        );
      else {
        console.log("inside validate delete");
        obj = this.jsonAppendComponent(
          obj,
          indexPageVal,
          compIndexPageVal,
          "delete"
        );
      }

      //console.log(obj);
      //console.log("ommm");

      this.ruleengineService
        .deleteRule(
          fieldName,
          this.model.accountName,
          this.model.projectName,
          obj,
          ruleID,
          typeStr
        )
        .subscribe((res) => {
          if (res.success == true) {
            this.getRuleDet();
            this.showCRRule = false;
          }
        });
    }
  }

  EditRuleField(ruleID: String) {
    this.ruleengineService.getRulesById(ruleID).subscribe((res) => {
      if (res.success == true) {
        // window.scroll(0,0);
        window.scroll({top: 200, behavior: 'smooth'});
        this.formTouchedFlag = false;
        this.query = res["data"][0]["query"];
        this.inputSelectInsert = res["data"][0]["appendField"];
        this.alertmsgstr = res["data"][0]["alertmsgstr"];
        this.showCRRule = true;
        this.showEditRule = true;
        this.ruleFor = res["data"][0]["ruleFor"];
        let rulecount = res["data"][0]["query"]["rules"].length;

        /* this.feeCond1 = res['data'][0]['feeCond1'];
        this.feeVal1 = res['data'][0]['feeVal1'];
        this.feeCond2 = res['data'][0]['feeCond2'];
        this.feeVal2 = res['data'][0]['feeVal2']; */
        for (var i = 1; i <= rulecount; i++) {
          this.feeCond["feeCond" + i] = res["data"][0]["feeCond" + i];
          this.feeCond["feeVal" + i] = res["data"][0]["feeVal" + i];
          // eval("feeCond" + i + " =res['data'][0]['query']['feeCond"+i+"']");
          // eval("feeVal" + i + " =res['data'][0]['query']['feeVal"+i+"']");
          /* window["feeCond"+i] = res['data'][0]['query']['feeCond'+i];
          window["feeVal"+i] = res['data'][0]['query']['feeVal'+i];
          console.log(window.feeCond1); */
        }
        //console.log(this.feeCond);
      }
    });
    /*For Edit Rule Engine*/
    /* this.query = {
      "condition": "or",
      "rules": [
      {
        "field": "firstName",
        "operator": "=",
        "value": "asas"
      }
      ]
    }; */
  }

  jsonAppendComponent(
    obj,
    indexPageVal: String,
    compIndexPageVal: String,
    updateStr: String
  ) {
    var pageIndex = "";
    var compIndex = "";
    var dataString = this.jsonConvertedString;
    var arrayLengthJs = this.arrayLengthString;
    var columnIndex = "";
    var columnSIndex = "";
    var rowsIndex = "";
    var rowsSIndex = "";
    var rowsSSIndex = "";
    var tabIndex = "";
    var tabSIndex = "";
    var tabSSIndex = "";
    var panelIndex = "";
    var panelSIndex = "";
    var rowsSRRIndex = "";
    var columnSRIndex = "";
    var gridIndex = "";
    var gridSIndex = "";
    console.log("updateStr>>>", updateStr);
    if (updateStr == "delete") {
      console.log("inside delete arrayLengthJs");
      dataString = "";
      arrayLengthJs = "";
    } else if (updateStr == "ageFn") dataString = this.jsonConvertedStringAge;

    obj.filter(function (element, index) {
      if (element.key === indexPageVal) {
        pageIndex = index;
      }
      // return res = (element.key === "page1");
    });

    if (typeof obj[pageIndex] !== "undefined") {
      obj[pageIndex]["components"].filter(function (element, index) {
        if (element.key === compIndexPageVal) {
          compIndex = index;
        }
        //return res= (element.key === "firstName");
      });
      //console.log(compIndex);

      console.log("arrayLengthJs>>>>", arrayLengthJs);

      //if(compIndex=='' && parseInt(compIndex)!=0)
      //	this.getElementSection(obj, pageIndex, compIndex, compIndexPageVal, dataString)

      if (compIndex == "" && parseInt(compIndex) != 0) {
        obj[pageIndex]["components"].filter(function (element, index) {
          if (element.type == "datagrid") {
            //datagrid
            console.log("inside datagrid>>>>");

            if (index != "" || parseInt(index) >= 0) {
              if (obj[pageIndex]["components"][index]["components"]) {
                obj[pageIndex]["components"][index]["components"].filter(
                  function (element, indexC) {
                    if (element["key"] == compIndexPageVal) {
                      gridIndex = index;
                      gridSIndex = indexC;
                      console.log("gridIndex>>>", gridIndex);
                      console.log("gridSIndex>>>", gridSIndex);
                    }
                  }
                );
              }
            }
          } else if (element.type == "columns") {
            //COLUMN Layout
            if (index != "" || parseInt(index) >= 0) {
              if (obj[pageIndex]["components"][index]["columns"]) {
                obj[pageIndex]["components"][index]["columns"].filter(function (
                  element,
                  indexC
                ) {
                  element["components"].filter(function (element, indexRRR) {
                    if (element["key"] == compIndexPageVal) {
                      columnIndex = index;
                      columnSIndex = indexC;
                      columnSRIndex = indexRRR;
                    }
                  });
                });
              }
            }
          } else if (element.type == "table") {
            //TABLE LAYOUT

            if (index != "" || parseInt(index) >= 0) {
              if (obj[pageIndex]["components"][index]["rows"]) {
                obj[pageIndex]["components"][index]["rows"].filter(function (
                  element,
                  indexR
                ) {
                  if (obj[pageIndex]["components"][index]["rows"][indexR]) {
                    obj[pageIndex]["components"][index]["rows"][indexR].filter(
                      function (element, indexRR) {
                        element["components"].filter(function (
                          element,
                          indexRRR
                        ) {
                          //console.log(element);
                          if (element["key"] == compIndexPageVal) {
                            rowsSIndex = indexRRR;
                            rowsIndex = index;
                            rowsSSIndex = indexR;
                            rowsSRRIndex = indexRR;
                          }
                        });
                      }
                    );
                  }
                });
              }
            }
          } else if (element.type == "tabs") {
            //tab LAYOUT
            if (index != "" || parseInt(index) >= 0) {
              //console.log(obj[pageIndex]['components'][index]['components']);
              if (obj[pageIndex]["components"][index]["components"]) {
                obj[pageIndex]["components"][index]["components"].filter(
                  function (element, indexT) {
                    if (element["components"]) {
                      element["components"].filter(function (element, indexTT) {
                        //console.log(element['key']);
                        if (element["key"] == compIndexPageVal) {
                          tabSSIndex = indexTT;
                          tabSIndex = indexT;
                          tabIndex = index;
                        }
                      });
                    }
                  }
                );
              }
            }
          } else if (element.type == "panel" || element.type == "fieldset") {
            //Panel Layout & Fieldset Layout
            console.log("inside panel");
            if (index != "" || parseInt(index) >= 0) {
              if (obj[pageIndex]["components"][index]["components"]) {
                obj[pageIndex]["components"][index]["components"].filter(
                  function (element, indexT) {
                    if (element["key"] == compIndexPageVal) {
                      panelSIndex = indexT;
                      panelIndex = index;
                    }
                  }
                );
              }
            }
          }
          //if(element.key === compIndexPageVal) compIndex = index;
          //return res= (element.key === "firstName");
        });
      }
      var dataStringJson = dataString;

      if (dataString != "") {
        dataStringJson = JSON.parse(dataString);
      }

      if (gridSIndex != "" || parseInt(gridSIndex) >= 0) {
        //Datagrid
        if (
          obj[pageIndex]["components"][gridIndex]["components"][gridSIndex][
          "validate"
          ]
        ) {
          var ValidateArr = new Array();
          if (arrayLengthJs != "") {
            obj[pageIndex]["components"][gridIndex]["components"][gridSIndex][
              "validate"
            ] = { custom: arrayLengthJs };
          }
          ValidateArr =
            obj[pageIndex]["components"][gridIndex]["components"][gridSIndex][
            "validate"
            ];
          if (dataString != "") ValidateArr["json"] = JSON.parse(dataString);
          else ValidateArr["json"] = dataString;
          obj[pageIndex]["components"][gridIndex]["components"][gridSIndex][
            "validate"
          ] = ValidateArr;
        } else {
          console.log("inside else of datagrid");
          obj[pageIndex]["components"][gridIndex]["components"][gridSIndex][
            "validate"
          ] = { json: dataStringJson };
        }
      } else if (columnSRIndex != "" || parseInt(columnSRIndex) >= 0) {
        //COLUMN Layout
        if (
          obj[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
          "components"
          ][columnSRIndex]["validate"]
        ) {
          var ValidateArr = new Array();
          ValidateArr =
            obj[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
            "components"
            ][columnSRIndex]["validate"];
          if (dataString != "") ValidateArr["json"] = JSON.parse(dataString);
          else ValidateArr["json"] = dataString;
          obj[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
            "components"
          ][columnSRIndex]["validate"] = ValidateArr;
        } else {
          obj[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
            "components"
          ][columnSRIndex]["validate"] = { json: dataStringJson };
        }
      } else if (rowsSIndex != "" || parseInt(rowsSIndex) >= 0) {
        //TABLE Layout;
        if (
          obj[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
          rowsSRRIndex
          ]["components"][rowsSIndex]["validate"]
        ) {
          var ValidateArr = new Array();
          ValidateArr =
            obj[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
            rowsSRRIndex
            ]["components"][rowsSIndex]["validate"];
          if (dataString != "") ValidateArr["json"] = JSON.parse(dataString);
          else ValidateArr["json"] = dataString;

          obj[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
            rowsSRRIndex
          ]["components"][rowsSIndex]["validate"] = ValidateArr;
        } else {
          obj[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
            rowsSRRIndex
          ]["components"][rowsSIndex]["validate"] = { json: dataStringJson };
        }
      } else if (tabSIndex != "" || parseInt(tabSIndex) >= 0) {
        //TAB LAYOUT
        //console.log(obj[pageIndex]['components'][tabIndex]['components'][tabSIndex]['components'][tabSSIndex]);
        if (
          obj[pageIndex]["components"][tabIndex]["components"][tabSIndex][
          "components"
          ][tabSSIndex]["validate"]
        ) {
          var ValidateArr = new Array();
          ValidateArr =
            obj[pageIndex]["components"][tabIndex]["components"][tabSIndex][
            "components"
            ][tabSSIndex]["validate"];
          if (dataString != "") ValidateArr["json"] = JSON.parse(dataString);
          else ValidateArr["json"] = dataString;
          obj[pageIndex]["components"][tabIndex]["components"][tabSIndex][
            "components"
          ][tabSSIndex]["validate"] = ValidateArr;
        } else {
          obj[pageIndex]["components"][tabIndex]["components"][tabSIndex][
            "components"
          ][tabSSIndex]["validate"] = { json: dataStringJson };
        }
      } else if (panelSIndex != "" || parseInt(panelSIndex) >= 0) {
        //Panel Layout & Fieldset Layout
        console.log("dataStringJson>>>>", dataString);
        if (
          obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
          "validate"
          ]
        ) {
          var ValidateArr = new Array();
          ValidateArr =
            obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
            "validate"
            ];
          console.log("ValidateArr>>", ValidateArr);
          if (dataString != "") ValidateArr["json"] = JSON.parse(dataString);
          else ValidateArr["json"] = dataString;
          obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
            "validate"
          ] = ValidateArr;
        } else {
          obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
            "validate"
          ] = { json: dataStringJson };
        }
        if (arrayLengthJs != "") {
          var objJSON = JSON.parse(
            JSON.stringify(this.QueryBuilderConfigOrigArr)
          );
          var jsonData =
            objJSON[pageIndex]["components"][panelIndex]["components"][
              panelSIndex
            ]["validate"].json;
          obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
            "validate"
          ] = { custom: arrayLengthJs, json: jsonData };
        } else if (arrayLengthJs == "" && dataString == "") {
          var objJSON = JSON.parse(
            JSON.stringify(this.QueryBuilderConfigOrigArr)
          );
          var jsonData =
            objJSON[pageIndex]["components"][panelIndex]["components"][
              panelSIndex
            ]["validate"].json;
          obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
            "validate"
          ] = { custom: "", json: jsonData };
        }
      } else {
        if (compIndex != "" || parseInt(compIndex) >= 0) {
          if (obj[pageIndex]["components"][compIndex]["validate"]) {
            var ValidateArr = new Array();
            ValidateArr = obj[pageIndex]["components"][compIndex]["validate"];
            if (dataString != "") ValidateArr["json"] = JSON.parse(dataString);
            else ValidateArr["json"] = dataString;
            obj[pageIndex]["components"][compIndex]["validate"] = ValidateArr;
          } else {
            obj[pageIndex]["components"][compIndex]["validate"] = {
              json: dataStringJson,
            };
          }
        }
        if (arrayLengthJs != "") {
          console.log("inside arrayLengthJs");
          obj[pageIndex]["components"][compIndex]["validate"] = {
            custom: arrayLengthJs,
          };
        }
      }
    }
    return obj;
  }

  getElementSection(
    obj,
    pageIndex,
    compIndex,
    compIndexPageVal,
    elementParent,
    dataString,
    replaceSection = "validate",
    replaceType = "update"
  ) {
    obj[pageIndex]["components"].filter((element, index) => {
      if (
        element.type == "datagrid" &&
        elementParent == element.type &&
        (index != "" || parseInt(index) >= 0)
      ) {
        //datagrid
        element = obj[pageIndex]["components"][index]["components"]
          ? this.getGridIndex(
            obj,
            pageIndex,
            compIndex,
            compIndexPageVal,
            dataString,
            replaceSection,
            replaceType
          )
          : element;
      } else if (
        element.type == "columns" &&
        elementParent == element.type &&
        (index != "" || parseInt(index) >= 0)
      ) {
        element = obj[pageIndex]["components"][index]["columns"]
          ? this.getColumnIndex(
            obj,
            pageIndex,
            compIndex,
            compIndexPageVal,
            dataString,
            replaceSection,
            replaceType
          )
          : element;
      } else if (
        element.type == "table" &&
        elementParent == element.type &&
        (index != "" || parseInt(index) >= 0)
      ) {
        element = obj[pageIndex]["components"][index]["rows"]
          ? this.getRowIndex(
            obj,
            pageIndex,
            compIndex,
            compIndexPageVal,
            dataString,
            replaceSection,
            replaceType
          )
          : element;
      } else if (
        element.type == "tabs" &&
        elementParent == element.type &&
        (index != "" || parseInt(index) >= 0)
      ) {
        element = obj[pageIndex]["components"][index]["components"]
          ? this.getTabIndex(
            obj,
            pageIndex,
            compIndex,
            compIndexPageVal,
            dataString,
            replaceSection,
            replaceType
          )
          : element;
      } else if (
        (element.type == "panel" || element.type == "fieldset") &&
        elementParent == element.type &&
        (index != "" || parseInt(index) >= 0)
      ) {
        element = obj[pageIndex]["components"][index]["components"]
          ? this.getPanelIndex(
            obj,
            pageIndex,
            compIndex,
            compIndexPageVal,
            dataString,
            replaceSection,
            replaceType
          )
          : element;
      } else {
        //let replaceSection = 'validate';
        let indexes = {};
        element = this.updateJson(
          obj[pageIndex]["components"][compIndex],
          dataString,
          replaceSection,
          replaceType,
          indexes
        );
      }
    });

    return obj;
  }

  getGridIndex(
    components,
    pageIndex,
    index,
    compIndexPageVal,
    dataString,
    replaceSection,
    replaceType
  ) {
    let gridIndex,
      gridSIndex = "";
    components[pageIndex]["components"][index]["components"].filter(
      (element, indexC) => {
        if (element["key"] == compIndexPageVal) {
          gridIndex = index;
          gridSIndex = indexC;
        }
      }
    );
    //let replaceSection = 'validate';
    let indexes = {
      gridIndex: gridIndex,
      gridSIndex: gridSIndex,
      pageIndex: pageIndex,
    };
    components = this.updateJson(
      components[pageIndex]["components"][gridIndex]["components"][gridSIndex],
      dataString,
      replaceSection,
      replaceType,
      indexes
    );
    return components;
  }

  getColumnIndex(
    components,
    pageIndex,
    index,
    compIndexPageVal,
    dataString,
    replaceSection,
    replaceType
  ) {
    let columnIndex,
      columnSIndex,
      columnSRIndex = "";
    components[pageIndex]["components"][index]["columns"].filter(
      (element, indexC) => {
        element["components"].filter((element, indexRRR) => {
          if (element["key"] == compIndexPageVal) {
            columnIndex = index;
            columnSIndex = indexC;
            columnSRIndex = indexRRR;
          }
        });
      }
    );
    //let replaceSection = 'validate';
    let indexes = {
      columnIndex: columnIndex,
      columnSIndex: columnSIndex,
      columnSRIndex: columnSRIndex,
      pageIndex: pageIndex,
    };
    components = this.updateJson(
      components[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
      "components"
      ][columnSRIndex],
      dataString,
      replaceSection,
      replaceType,
      indexes
    );
    return components;
  }

  getRowIndex(
    components,
    pageIndex,
    index,
    compIndexPageVal,
    dataString,
    replaceSection,
    replaceType
  ) {
    let rowsSIndex,
      rowsIndex,
      rowsSSIndex,
      rowsSRRIndex = "";
    components[pageIndex]["components"][index]["rows"].filter(
      (element, indexR) => {
        if (components[pageIndex]["components"][index]["rows"][indexR]) {
          components[pageIndex]["components"][index]["rows"][indexR].filter(
            (element, indexRR) => {
              element["components"].filter((element, indexRRR) => {
                if (element["key"] == compIndexPageVal) {
                  rowsSIndex = indexRRR;
                  rowsIndex = index;
                  rowsSSIndex = indexR;
                  rowsSRRIndex = indexRR;
                }
              });
            }
          );
        }
      }
    );
    //let replaceSection = 'validate';
    let indexes = {
      rowsSIndex: rowsSIndex,
      rowsIndex: rowsIndex,
      rowsSSIndex: rowsSSIndex,
      rowsSRRIndex: rowsSRRIndex,
      pageIndex: pageIndex,
    };
    components = this.updateJson(
      components[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
      rowsSRRIndex
      ]["components"][rowsSIndex],
      dataString,
      replaceSection,
      replaceType,
      indexes
    );
    return components;
  }

  getTabIndex(
    components,
    pageIndex,
    index,
    compIndexPageVal,
    dataString,
    replaceSection,
    replaceType
  ) {
    let tabSSIndex,
      tabSIndex,
      tabIndex = "";
    components[pageIndex]["components"][index]["components"].filter(
      (element, indexT) => {
        if (element["components"]) {
          element["components"].filter((element, indexTT) => {
            if (element["key"] == compIndexPageVal) {
              tabSSIndex = indexTT;
              tabSIndex = indexT;
              tabIndex = index;
            }
          });
        }
      }
    );
    //let replaceSection = 'validate';
    let indexes = {
      tabSSIndex: tabSSIndex,
      tabSIndex: tabSIndex,
      tabIndex: tabIndex,
      pageIndex: pageIndex,
    };
    components = this.updateJson(
      components[pageIndex]["components"][tabIndex]["components"][tabSIndex][
      "components"
      ][tabSSIndex],
      dataString,
      replaceSection,
      replaceType,
      indexes
    );
    return components;
  }

  getPanelIndex(
    components,
    pageIndex,
    index,
    compIndexPageVal,
    dataString,
    replaceSection,
    replaceType
  ) {
    let panelSIndex,
      panelIndex = "";
    components[pageIndex]["components"][index]["components"].filter(
      (element, indexT) => {
        if (element["key"] == compIndexPageVal) {
          panelSIndex = indexT;
          panelIndex = index;
        }
      }
    );
    //let replaceSection = 'validate';
    let indexes = {
      panelSIndex: panelSIndex,
      panelIndex: panelIndex,
      pageIndex: pageIndex,
    };

    components = this.updateJson(
      components[pageIndex]["components"][panelIndex]["components"][
      panelSIndex
      ],
      dataString,
      replaceSection,
      replaceType,
      indexes
    );
    return components;
  }

  updateJson(fldSection, dataString, replaceSection, replaceType, indexes) {
    var dataStringJson = dataString;

    if (replaceSection == "validate") {
      if (dataString != "") dataStringJson = JSON.parse(dataString);
      if (fldSection[replaceSection]) {
        var ValidateArr = new Array();
        ValidateArr = fldSection[replaceSection];
        if (dataString != "") ValidateArr["json"] = JSON.parse(dataString);
        else ValidateArr["json"] = dataString;
        fldSection[replaceSection] = replaceType == "update" ? ValidateArr : "";
      } else {
        fldSection[replaceSection] =
          replaceType == "update" ? { json: dataStringJson } : { json: "" };
      }
    } else if (replaceSection == "logic") {
      let dataStringParsed =
        replaceType == "update" ? dataStringJson.map((e) => JSON.parse(e)) : "";
      if (fldSection[replaceSection]) {
        var ValidateArr = new Array();
        ValidateArr = fldSection[replaceSection];
        if (dataString.length > 0) ValidateArr = dataStringParsed;
        else ValidateArr = dataString;
        fldSection[replaceSection] = replaceType == "update" ? ValidateArr : "";
      } else {
        fldSection[replaceSection] =
          replaceType == "update" ? dataStringParsed : "";
      }
    }

    return fldSection;
  }

  jsonAppendComponent_Fee(
    obj,
    indexPageVal: String,
    compIndexPageVal: String,
    updateStr: String
  ) {
    var compIndex = "";
    var pageIndex = "";
    var compIndex = "";
    var dataString = this.jsonConvertedString;
    var columnIndex = "";
    var columnSIndex = "";
    var rowsIndex = "";
    var rowsSIndex = "";
    var rowsSSIndex = "";
    var tabIndex = "";
    var tabSIndex = "";
    var tabSSIndex = "";
    var panelIndex = "";
    var panelSIndex = "";
    var columnSRIndex = "";
    var rowsSRRIndex = "";
    var gridIndex = "";
    var gridSIndex = "";

    if (updateStr == "delete") dataString = "";
    else if (updateStr == "updateWorkExp")
      dataString = this.jsonConvertedStrWorkExp;
    else if (updateStr == "ageFn") dataString = this.jsonConvertedStringAgeClc;

    //console.log(obj);
    var dataStringJson = dataString;
    if (dataString != "") dataStringJson = JSON.parse(dataString);
    //console.log(indexPageVal);
    obj.filter(function (element, index) {
      if (element.key === indexPageVal) pageIndex = index;
      // return res = (element.key === "page1");
    });
    if (typeof obj[pageIndex] !== "undefined") {
      obj[pageIndex]["components"].filter(function (element, index) {
        if (element.key === compIndexPageVal) compIndex = index;
        //return res= (element.key === "firstName");
      });
    }

    if (compIndex == "" && parseInt(compIndex) != 0) {
      if (typeof obj[pageIndex] !== "undefined") {
        obj[pageIndex]["components"].filter(function (element, index) {
          if (element.type == "datagrid") {
            //datagrid Layout
            if (index != "" || parseInt(index) >= 0) {
              if (obj[pageIndex]["components"][index]["components"]) {
                obj[pageIndex]["components"][index]["components"].filter(
                  function (element, indexC) {
                    if (element["key"] == compIndexPageVal) {
                      gridIndex = index;
                      gridSIndex = indexC;
                    }
                  }
                );
              }
            }
          } else if (element.type == "columns") {
            //COLUMN Layout
            if (index != "" || parseInt(index) >= 0) {
              if (obj[pageIndex]["components"][index]["columns"]) {
                obj[pageIndex]["components"][index]["columns"].filter(function (
                  element,
                  indexC
                ) {
                  element["components"].filter(function (element, indexRRR) {
                    if (element["key"] == compIndexPageVal) {
                      columnIndex = index;
                      columnSIndex = indexC;
                      columnSRIndex = indexRRR;
                    }
                  });
                });
              }
            }
          } else if (element.type == "table") {
            //TABLE LAYOUT

            if (index != "" || parseInt(index) >= 0) {
              if (obj[pageIndex]["components"][index]["rows"]) {
                obj[pageIndex]["components"][index]["rows"].filter(function (
                  element,
                  indexR
                ) {
                  if (obj[pageIndex]["components"][index]["rows"][indexR]) {
                    obj[pageIndex]["components"][index]["rows"][indexR].filter(
                      function (element, indexRR) {
                        element["components"].filter(function (
                          element,
                          indexRRR
                        ) {
                          //console.log(element);
                          if (element["key"] == compIndexPageVal) {
                            rowsSIndex = indexRRR;
                            rowsIndex = index;
                            rowsSSIndex = indexR;
                            rowsSRRIndex = indexRR;
                          }
                        });
                      }
                    );
                  }
                });
              }
            }
          } else if (element.type == "tabs") {
            //tab LAYOUT
            if (index != "" || parseInt(index) >= 0) {
              //console.log(obj[pageIndex]['components'][index]['components']);
              if (obj[pageIndex]["components"][index]["components"]) {
                obj[pageIndex]["components"][index]["components"].filter(
                  function (element, indexT) {
                    if (element["components"]) {
                      element["components"].filter(function (element, indexTT) {
                        //console.log(element['key']);
                        if (element["key"] == compIndexPageVal) {
                          tabSSIndex = indexTT;
                          tabSIndex = indexT;
                          tabIndex = index;
                        }
                      });
                    }
                  }
                );
              }
            }
          } else if (element.type == "panel" || element.type == "fieldset") {
            //Panel Layout & Fieldset Layout
            if (index != "" || parseInt(index) >= 0) {
              if (obj[pageIndex]["components"][index]["components"]) {
                obj[pageIndex]["components"][index]["components"].filter(
                  function (element, indexT) {
                    //console.log(element['key']);
                    if (element["key"] == compIndexPageVal) {
                      panelSIndex = indexT;
                      panelIndex = index;
                    }
                  }
                );
              }
            }
          }
          //if(element.key === compIndexPageVal) compIndex = index;
          //return res= (element.key === "firstName");
        });
      }
    }

    /*if(gridSIndex!='' || parseInt(gridSIndex)>=0){//Datagrid
      if(obj[pageIndex]['components'][gridIndex]['components'][gridSIndex]['validate']){
        var ValidateArr = new Array();
        ValidateArr = obj[pageIndex]['components'][gridIndex]['components'][gridSIndex]['validate'];
        if(dataString!='') ValidateArr['json'] = JSON.parse(dataString);
        else ValidateArr['json'] = dataString;
        obj[pageIndex]['components'][gridIndex]['components'][gridSIndex]['validate'] =  ValidateArr;
      }else{
        obj[pageIndex]['components'][gridIndex]['components'][gridSIndex]['validate'] =  {'json':dataStringJson};
      }
      }*/

    if (gridSIndex != "" || parseInt(gridSIndex) >= 0) {
      //Datagrid
      obj[pageIndex]["components"][gridIndex]["components"][gridSIndex][
        "calculateValue"
      ] = dataStringJson;
    } else if (columnSIndex != "" || parseInt(columnSIndex) >= 0) {
      //COLUMN Layout
      obj[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
        "components"
      ][columnSRIndex]["calculateValue"] = dataStringJson;
    } else if (rowsSIndex != "" || parseInt(rowsSIndex) >= 0) {
      //TABLE Layout;
      obj[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
        rowsSRRIndex
      ]["components"][rowsSIndex]["calculateValue"] = dataStringJson;
    } else if (tabSIndex != "" || parseInt(tabSIndex) >= 0) {
      //TAB LAYOUT
      obj[pageIndex]["components"][tabIndex]["components"][tabSIndex][
        "components"
      ][tabSSIndex]["calculateValue"] = dataStringJson;
    } else if (panelSIndex != "" || parseInt(panelSIndex) >= 0) {
      //Panel Layout & Fieldset Layout
      obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
        "calculateValue"
      ] = dataStringJson;
    } else {
      if (compIndex != "") {
        obj[pageIndex]["components"][compIndex]["calculateValue"] =
          dataStringJson;
      }
    }
    return obj;
  }

  jsonAppendComponent_map(
    obj,
    indexPageVal: String,
    compIndexPageVal: String,
    updateStr: String
  ) {
    var pageIndex = "";

    var compIndex = "";
    var pageIndex = "";
    var compIndex = "";
    var dataString = this.jsonConvertedString;
    //var dataString = "";
    var logicVal = this.logicString;
    var columnIndex = "";
    var columnSIndex = "";
    var rowsIndex = "";
    var rowsSIndex = "";
    var rowsSSIndex = "";
    var tabIndex = "";
    var tabSIndex = "";
    var tabSSIndex = "";
    var panelIndex = "";
    var panelSIndex = "";
    var columnSRIndex = "";
    var rowsSRRIndex = "";

    if (updateStr == "delete") {
      dataString = "";
      logicVal = "";
    } else if (updateStr == "updateWorkExp")
      dataString = this.jsonConvertedStrWorkExp;
    else if (updateStr == "ageFn") dataString = this.jsonConvertedStringAgeClc;

    //console.log(dataString);
    var dataStringJson = dataString;
    if (dataString != "") dataStringJson = JSON.parse(dataString);

    //console.log(logicVal);
    var logicStringJson = logicVal;
    if (logicVal != "") logicStringJson = JSON.parse(logicVal);

    obj.filter(function (element, index) {
      if (element.key === indexPageVal) pageIndex = index;
      // return res = (element.key === "page1");
    });
    obj[pageIndex]["components"].filter(function (element, index) {
      if (element.key === compIndexPageVal) compIndex = index;
      //return res= (element.key === "firstName");
    });

    if (compIndex == "" && parseInt(compIndex) != 0) {
      //COLUMN Layout
      obj[pageIndex]["components"].filter(function (element, index) {
        if (element.type == "columns") {
          if (index != "" || parseInt(index) >= 0) {
            if (obj[pageIndex]["components"][index]["columns"]) {
              obj[pageIndex]["components"][index]["columns"].filter(function (
                element,
                indexC
              ) {
                element["components"].filter(function (element, indexRRR) {
                  if (element["key"] == compIndexPageVal) {
                    columnIndex = index;
                    columnSIndex = indexC;
                    columnSRIndex = indexRRR;
                  }
                });
              });
            }
          }
        } else if (element.type == "table") {
          //TABLE LAYOUT

          if (index != "" || parseInt(index) >= 0) {
            if (obj[pageIndex]["components"][index]["rows"]) {
              obj[pageIndex]["components"][index]["rows"].filter(function (
                element,
                indexR
              ) {
                if (obj[pageIndex]["components"][index]["rows"][indexR]) {
                  obj[pageIndex]["components"][index]["rows"][indexR].filter(
                    function (element, indexRR) {
                      element["components"].filter(function (
                        element,
                        indexRRR
                      ) {
                        //console.log(element);
                        if (element["key"] == compIndexPageVal) {
                          rowsSIndex = indexRRR;
                          rowsIndex = index;
                          rowsSSIndex = indexR;
                          rowsSRRIndex = indexRR;
                        }
                      });
                    }
                  );
                }
              });
            }
          }
        } else if (element.type == "tabs") {
          //tab LAYOUT
          if (index != "" || parseInt(index) >= 0) {
            //console.log(obj[pageIndex]['components'][index]['components']);
            if (obj[pageIndex]["components"][index]["components"]) {
              obj[pageIndex]["components"][index]["components"].filter(
                function (element, indexT) {
                  if (element["components"]) {
                    element["components"].filter(function (element, indexTT) {
                      //console.log(element['key']);
                      if (element["key"] == compIndexPageVal) {
                        tabSSIndex = indexTT;
                        tabSIndex = indexT;
                        tabIndex = index;
                      }
                    });
                  }
                }
              );
            }
          }
        } else if (element.type == "panel" || element.type == "fieldset") {
          //Panel Layout & Fieldset Layout
          if (index != "" || parseInt(index) >= 0) {
            if (obj[pageIndex]["components"][index]["components"]) {
              obj[pageIndex]["components"][index]["components"].filter(
                function (element, indexT) {
                  //console.log(element['key']);
                  if (element["key"] == compIndexPageVal) {
                    panelSIndex = indexT;
                    panelIndex = index;
                  }
                }
              );
            }
          }
        }
        //if(element.key === compIndexPageVal) compIndex = index;
        //return res= (element.key === "firstName");
      });
    }

    if (columnSIndex != "" || parseInt(columnSIndex) >= 0) {
      //COLUMN Layout
      obj[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
        "components"
      ][columnSRIndex]["logic"] = logicStringJson;
    } else if (rowsSIndex != "" || parseInt(rowsSIndex) >= 0) {
      //TABLE Layout;
      obj[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
        rowsSRRIndex
      ]["components"][rowsSIndex]["logic"] = logicStringJson;
    } else if (tabSIndex != "" || parseInt(tabSIndex) >= 0) {
      //TAB LAYOUT
      obj[pageIndex]["components"][tabIndex]["components"][tabSIndex][
        "components"
      ][tabSSIndex]["logic"] = logicStringJson;
    } else if (panelSIndex != "" || parseInt(panelSIndex) >= 0) {
      //Panel Layout & Fieldset Layout
      obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
        "logic"
      ] = logicStringJson;
    } else {
      if (compIndex != "") {
        obj[pageIndex]["components"][compIndex]["logic"] = logicStringJson;
      }
    }

    if (columnSRIndex != "" || parseInt(columnSRIndex) >= 0) {
      //COLUMN Layout
      if (
        obj[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
        "components"
        ][columnSRIndex]["validate"]
      ) {
        var ValidateArr = new Array();
        ValidateArr =
          obj[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
          "components"
          ][columnSRIndex]["validate"];
        if (dataString != "") ValidateArr["json"] = JSON.parse(dataString);
        else ValidateArr["json"] = dataString;
        obj[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
          "components"
        ][columnSRIndex]["validate"] = ValidateArr;
      } else {
        obj[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
          "components"
        ][columnSRIndex]["validate"] = { json: dataStringJson };
      }
    } else if (rowsSIndex != "" || parseInt(rowsSIndex) >= 0) {
      //TABLE Layout;
      if (
        obj[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
        rowsSRRIndex
        ]["components"][rowsSIndex]["validate"]
      ) {
        var ValidateArr = new Array();
        ValidateArr =
          obj[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
          rowsSRRIndex
          ]["components"][rowsSIndex]["validate"];
        if (dataString != "") ValidateArr["json"] = JSON.parse(dataString);
        else ValidateArr["json"] = dataString;

        obj[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
          rowsSRRIndex
        ]["components"][rowsSIndex]["validate"] = ValidateArr;
      } else {
        obj[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
          rowsSRRIndex
        ]["components"][rowsSIndex]["validate"] = { json: dataStringJson };
      }
    } else if (tabSIndex != "" || parseInt(tabSIndex) >= 0) {
      //TAB LAYOUT
      //console.log(obj[pageIndex]['components'][tabIndex]['components'][tabSIndex]['components'][tabSSIndex]);
      if (
        obj[pageIndex]["components"][tabIndex]["components"][tabSIndex][
        "components"
        ][tabSSIndex]["validate"]
      ) {
        var ValidateArr = new Array();
        ValidateArr =
          obj[pageIndex]["components"][tabIndex]["components"][tabSIndex][
          "components"
          ][tabSSIndex]["validate"];
        if (dataString != "") ValidateArr["json"] = JSON.parse(dataString);
        else ValidateArr["json"] = dataString;
        obj[pageIndex]["components"][tabIndex]["components"][tabSIndex][
          "components"
        ][tabSSIndex]["validate"] = ValidateArr;
      } else {
        obj[pageIndex]["components"][tabIndex]["components"][tabSIndex][
          "components"
        ][tabSSIndex]["validate"] = { json: dataStringJson };
      }
    } else if (panelSIndex != "" || parseInt(panelSIndex) >= 0) {
      //Panel Layout & Fieldset Layout
      if (
        obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
        "validate"
        ]
      ) {
        var ValidateArr = new Array();
        ValidateArr =
          obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
          "validate"
          ];
        if (dataString != "") ValidateArr["json"] = JSON.parse(dataString);
        else ValidateArr["json"] = dataString;
        obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
          "validate"
        ] = ValidateArr;
      } else {
        obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
          "validate"
        ] = { json: dataStringJson };
      }
    } else {
      if (compIndex != "") {
        if (obj[pageIndex]["components"][compIndex]["validate"]) {
          var ValidateArr = new Array();
          ValidateArr = obj[pageIndex]["components"][compIndex]["validate"];
          if (dataString != "") ValidateArr["json"] = JSON.parse(dataString);
          else ValidateArr["json"] = dataString;
          obj[pageIndex]["components"][compIndex]["validate"] = ValidateArr;
        } else {
          obj[pageIndex]["components"][compIndex]["validate"] = {
            json: dataStringJson,
          };
        }
      }
    }

    return obj;
  }

  jsonAppendComponent_alert(
    obj,
    indexPageVal: String,
    compIndexPageVal: String,
    updateStr: String
  ) {
    var pageIndex = "";

    var compIndex = "";
    var pageIndex = "";
    var compIndex = "";
    var dataString = this.jsonConvertedString;
    //var dataString = "";
    var logicVal = this.logicString;
    var columnIndex = "";
    var columnSIndex = "";
    var rowsIndex = "";
    var rowsSIndex = "";
    var rowsSSIndex = "";
    var tabIndex = "";
    var tabSIndex = "";
    var tabSSIndex = "";
    var panelIndex = "";
    var panelSIndex = "";
    var columnSRIndex = "";
    var rowsSRRIndex = "";

    if (updateStr == "delete") {
      dataString = "";
      logicVal = [];
    } else if (updateStr == "updateWorkExp")
      dataString = this.jsonConvertedStrWorkExp;
    else if (updateStr == "ageFn") dataString = this.jsonConvertedStringAgeClc;

    //console.log(dataString);
    var dataStringJson = dataString;
    if (dataString != "") dataStringJson = JSON.parse(dataString);

    //console.log(logicVal);
    var logicStringJson = logicVal;
    if (logicVal != "") logicStringJson = JSON.parse(logicVal);

    obj.filter(function (element, index) {
      if (element.key === indexPageVal) pageIndex = index;
      // return res = (element.key === "page1");
    });
    if (typeof obj[pageIndex] !== "undefined") {
      obj[pageIndex]["components"].filter(function (element, index) {
        if (element.key === compIndexPageVal) compIndex = index;
        //return res= (element.key === "firstName");
      });
    }

    if (compIndex == "" && parseInt(compIndex) != 0) {
      //COLUMN Layout
      obj[pageIndex]["components"].filter(function (element, index) {
        console.log("am I here>>>");

        if (element.type == "columns") {
          if (index != "" || parseInt(index) >= 0) {
            if (obj[pageIndex]["components"][index]["columns"]) {
              obj[pageIndex]["components"][index]["columns"].filter(function (
                element,
                indexC
              ) {
                element["components"].filter(function (element, indexRRR) {
                  if (element["key"] == compIndexPageVal) {
                    columnIndex = index;
                    columnSIndex = indexC;
                    columnSRIndex = indexRRR;
                  }
                });
              });
            }
          }
        } else if (element.type == "table") {
          //TABLE LAYOUT

          if (index != "" || parseInt(index) >= 0) {
            if (obj[pageIndex]["components"][index]["rows"]) {
              obj[pageIndex]["components"][index]["rows"].filter(function (
                element,
                indexR
              ) {
                if (obj[pageIndex]["components"][index]["rows"][indexR]) {
                  obj[pageIndex]["components"][index]["rows"][indexR].filter(
                    function (element, indexRR) {
                      element["components"].filter(function (
                        element,
                        indexRRR
                      ) {
                        //console.log(element);
                        if (element["key"] == compIndexPageVal) {
                          rowsSIndex = indexRRR;
                          rowsIndex = index;
                          rowsSSIndex = indexR;
                          rowsSRRIndex = indexRR;
                        }
                      });
                    }
                  );
                }
              });
            }
          }
        } else if (element.type == "tabs") {
          //tab LAYOUT
          if (index != "" || parseInt(index) >= 0) {
            //console.log(obj[pageIndex]['components'][index]['components']);
            if (obj[pageIndex]["components"][index]["components"]) {
              obj[pageIndex]["components"][index]["components"].filter(
                function (element, indexT) {
                  if (element["components"]) {
                    element["components"].filter(function (element, indexTT) {
                      //console.log(element['key']);
                      if (element["key"] == compIndexPageVal) {
                        tabSSIndex = indexTT;
                        tabSIndex = indexT;
                        tabIndex = index;
                      }
                    });
                  }
                }
              );
            }
          }
        } else if (element.type == "panel" || element.type == "fieldset") {
          //Panel Layout & Fieldset Layout
          if (index != "" || parseInt(index) >= 0) {
            if (obj[pageIndex]["components"][index]["components"]) {
              obj[pageIndex]["components"][index]["components"].filter(
                function (element, indexT) {
                  //console.log(element['key']);
                  if (element["key"] == compIndexPageVal) {
                    panelSIndex = indexT;
                    panelIndex = index;
                  }
                }
              );
            }
          }
        }
      });
    }

    if (columnSIndex != "" || parseInt(columnSIndex) >= 0) {
      //COLUMN Layout

      obj[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
        "components"
      ][columnSRIndex]["logic"] = logicStringJson;
    } else if (rowsSIndex != "" || parseInt(rowsSIndex) >= 0) {
      //TABLE Layout;

      obj[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
        rowsSRRIndex
      ]["components"][rowsSIndex]["logic"] = logicStringJson;
    } else if (tabSIndex != "" || parseInt(tabSIndex) >= 0) {
      //TAB LAYOUT

      obj[pageIndex]["components"][tabIndex]["components"][tabSIndex][
        "components"
      ][tabSSIndex]["logic"] = logicStringJson;
    } else if (panelSIndex != "" || parseInt(panelSIndex) >= 0) {
      //Panel Layout & Fieldset Layout

      obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
        "logic"
      ] = logicStringJson;
    } else {
      if (compIndex != "" || parseInt(columnSIndex) != 0) {
        for (
          var i = obj[pageIndex]["components"][compIndex]["logic"].length - 1;
          i >= 0;
          i--
        ) {
          if (
            obj[pageIndex]["components"][compIndex]["logic"][i].name === "popup"
          ) {
            obj[pageIndex]["components"][compIndex]["logic"].splice(i, 1);
          }
        }
        obj[pageIndex]["components"][compIndex]["logic"].push(logicStringJson);
      }
    }

    if (columnSRIndex != "" || parseInt(columnSRIndex) >= 0) {
      //COLUMN Layout
      if (
        obj[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
        "components"
        ][columnSRIndex]["validate"]
      ) {
        var ValidateArr = new Array();
        ValidateArr =
          obj[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
          "components"
          ][columnSRIndex]["validate"];
        if (dataString != "") ValidateArr["json"] = JSON.parse(dataString);
        else ValidateArr["json"] = dataString;
        obj[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
          "components"
        ][columnSRIndex]["validate"] = ValidateArr;
      } else {
        obj[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
          "components"
        ][columnSRIndex]["validate"] = { json: dataStringJson };
      }
    } else if (rowsSIndex != "" || parseInt(rowsSIndex) >= 0) {
      //TABLE Layout;
      if (
        obj[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
        rowsSRRIndex
        ]["components"][rowsSIndex]["validate"]
      ) {
        var ValidateArr = new Array();
        ValidateArr =
          obj[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
          rowsSRRIndex
          ]["components"][rowsSIndex]["validate"];
        if (dataString != "") ValidateArr["json"] = JSON.parse(dataString);
        else ValidateArr["json"] = dataString;

        obj[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
          rowsSRRIndex
        ]["components"][rowsSIndex]["validate"] = ValidateArr;
      } else {
        obj[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
          rowsSRRIndex
        ]["components"][rowsSIndex]["validate"] = { json: dataStringJson };
      }
    } else if (tabSIndex != "" || parseInt(tabSIndex) >= 0) {
      //TAB LAYOUT
      //console.log(obj[pageIndex]['components'][tabIndex]['components'][tabSIndex]['components'][tabSSIndex]);
      if (
        obj[pageIndex]["components"][tabIndex]["components"][tabSIndex][
        "components"
        ][tabSSIndex]["validate"]
      ) {
        var ValidateArr = new Array();
        ValidateArr =
          obj[pageIndex]["components"][tabIndex]["components"][tabSIndex][
          "components"
          ][tabSSIndex]["validate"];
        if (dataString != "") ValidateArr["json"] = JSON.parse(dataString);
        else ValidateArr["json"] = dataString;
        obj[pageIndex]["components"][tabIndex]["components"][tabSIndex][
          "components"
        ][tabSSIndex]["validate"] = ValidateArr;
      } else {
        obj[pageIndex]["components"][tabIndex]["components"][tabSIndex][
          "components"
        ][tabSSIndex]["validate"] = { json: dataStringJson };
      }
    } else if (panelSIndex != "" || parseInt(panelSIndex) >= 0) {
      //Panel Layout & Fieldset Layout
      if (
        obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
        "validate"
        ]
      ) {
        var ValidateArr = new Array();
        ValidateArr =
          obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
          "validate"
          ];
        if (dataString != "") ValidateArr["json"] = JSON.parse(dataString);
        else ValidateArr["json"] = dataString;
        obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
          "validate"
        ] = ValidateArr;
      } else {
        obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
          "validate"
        ] = { json: dataStringJson };
      }
    }
    return obj;
  }

  jsonAppendComponent_cnd(
    obj,
    indexPageVal: String,
    compIndexPageVal: String,
    updateStr: String
  ) {
    var pageIndex = "";

    var compIndex = "";
    var pageIndex = "";
    var compIndex = "";
    var dataString = this.jsonConvertedString;
    var customCondition = this.arrayMatchString;
    var columnIndex = "";
    var columnSIndex = "";
    var rowsIndex = "";
    var rowsSIndex = "";
    var rowsSSIndex = "";
    var tabIndex = "";
    var tabSIndex = "";
    var tabSSIndex = "";
    var panelIndex = "";
    var panelSIndex = "";
    var columnSRIndex = "";
    var rowsSRRIndex = "";
    var staticJson = "";

    if (updateStr == "delete") dataString = "";
    //else if(updateStr == 'update') dataString = this.jsonConvertedStrWorkExp;
    //else if(updateStr == 'ageFn') dataString = this.jsonConvertedStringAgeClc;

    // staticJson= {
    //   "and": [{
    //     "==": [{
    //       "var": "data.post"
    //     }, "creditOfficersJmgsI"]
    //   }, {
    //     "==": [{
    //       "var": "data.appPassed"
    //     }, "passed"]
    //   }]
    // };
    //  var dataStringNew = JSON.stringify(staticJson);
    console.log("datastring value is", typeof dataString);
    //  console.log("staticjson is", staticJson );

    //  console.log("New datastring is", typeof(dataStringNew));

    var dataStringJson = dataString;
    if (dataString != "") dataStringJson = JSON.parse(dataString);
    // dataStringJson = JSON.parse(dataStringNew);

    obj.filter(function (element, index) {
      if (element.key === indexPageVal) pageIndex = index;
      // return res = (element.key === "page1");
    });
    obj[pageIndex]["components"].filter(function (element, index) {
      if (element.key === compIndexPageVal) compIndex = index;
      //return res= (element.key === "firstName");
    });

    if (compIndex == "" && parseInt(compIndex) != 0) {
      //COLUMN Layout
      obj[pageIndex]["components"].filter(function (element, index) {
        if (element.type == "columns") {
          if (index != "" || parseInt(index) >= 0) {
            if (obj[pageIndex]["components"][index]["columns"]) {
              obj[pageIndex]["components"][index]["columns"].filter(function (
                element,
                indexC
              ) {
                element["components"].filter(function (element, indexRRR) {
                  if (element["key"] == compIndexPageVal) {
                    columnIndex = index;
                    columnSIndex = indexC;
                    columnSRIndex = indexRRR;
                  }
                });
              });
            }
          }
        } else if (element.type == "table") {
          //TABLE LAYOUT

          if (index != "" || parseInt(index) >= 0) {
            if (obj[pageIndex]["components"][index]["rows"]) {
              obj[pageIndex]["components"][index]["rows"].filter(function (
                element,
                indexR
              ) {
                if (obj[pageIndex]["components"][index]["rows"][indexR]) {
                  obj[pageIndex]["components"][index]["rows"][indexR].filter(
                    function (element, indexRR) {
                      element["components"].filter(function (
                        element,
                        indexRRR
                      ) {
                        //console.log(element);
                        if (element["key"] == compIndexPageVal) {
                          rowsSIndex = indexRRR;
                          rowsIndex = index;
                          rowsSSIndex = indexR;
                          rowsSRRIndex = indexRR;
                        }
                      });
                    }
                  );
                }
              });
            }
          }
        } else if (element.type == "tabs") {
          //tab LAYOUT
          if (index != "" || parseInt(index) >= 0) {
            //console.log(obj[pageIndex]['components'][index]['components']);
            if (obj[pageIndex]["components"][index]["components"]) {
              obj[pageIndex]["components"][index]["components"].filter(
                function (element, indexT) {
                  if (element["components"]) {
                    element["components"].filter(function (element, indexTT) {
                      //console.log(element['key']);
                      if (element["key"] == compIndexPageVal) {
                        tabSSIndex = indexTT;
                        tabSIndex = indexT;
                        tabIndex = index;
                      }
                    });
                  }
                }
              );
            }
          }
        } else if (element.type == "panel" || element.type == "fieldset") {
          //Panel Layout & Fieldset Layout
          if (index != "" || parseInt(index) >= 0) {
            if (obj[pageIndex]["components"][index]["components"]) {
              obj[pageIndex]["components"][index]["components"].filter(
                function (element, indexT) {
                  //console.log(element['key']);
                  if (element["key"] == compIndexPageVal) {
                    panelSIndex = indexT;
                    panelIndex = index;
                  }
                }
              );
            }
          }
        }
        //if(element.key === compIndexPageVal) compIndex = index;
        //return res= (element.key === "firstName");
      });
    }

    if (columnSIndex != "" || parseInt(columnSIndex) >= 0) {
      //COLUMN Layout
      obj[pageIndex]["components"][columnIndex]["columns"][columnSIndex][
        "components"
      ][columnSRIndex]["conditional"]["json"] = dataStringJson;
    } else if (rowsSIndex != "" || parseInt(rowsSIndex) >= 0) {
      //TABLE Layout;
      obj[pageIndex]["components"][rowsIndex]["rows"][rowsSSIndex][
        rowsSRRIndex
      ]["components"][rowsSIndex]["conditional"]["json"] = dataStringJson;
    } else if (tabSIndex != "" || parseInt(tabSIndex) >= 0) {
      //TAB LAYOUT
      // console.log("inside else if Tab layout", dataStringNew);
      obj[pageIndex]["components"][tabIndex]["components"][tabSIndex][
        "components"
      ][tabSSIndex]["conditional"]["json"] = dataStringJson;
    } else if (panelSIndex != "" || parseInt(panelSIndex) >= 0) {
      //Panel Layout & Fieldset Layout
      obj[pageIndex]["components"][panelIndex]["components"][panelSIndex][
        "conditional"
      ]["json"] = dataStringJson;
    } else {
      if (compIndex != "") {
        obj[pageIndex]["components"][compIndex]["conditional"]["json"] =
          dataStringJson;
        //  console.log("inside else if datasrting", dataStringNew);
        //  obj[pageIndex]['components'][compIndex]['conditional']['json'] =dataStringNew;
      }
      if (customCondition != "") {
        obj[pageIndex]["components"][compIndex]["customConditional"] =
          customCondition;
      }
    }

    return obj;
  }

  jsonpreviewView(jsonLogicDisp, showParam) {
    console.log("jsonLogicDisp", jsonLogicDisp);
    if (showParam == "show") {
      this.displayPrevJson = true;
      this.displayPrevJsonVal = jsonLogicDisp;
    } else {
      this.displayPrevJson = false;
    }
  }

  resetRuleEng() {
    let chkFlag = true;
    if (
      (typeof this.ruleengineform !== "undefined" &&
        this.ruleengineform.dirty) ||
      (typeof this.myForm !== "undefined" && this.myForm.dirty) ||
      (typeof this.myFormworkexp !== "undefined" && this.myFormworkexp.dirty)
    ) {
      if (
        confirm(
          "You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes."
        )
      ) {
        chkFlag = true;
        this.formTouchedFlag = false;
      } else {
        chkFlag = false;
      }
    }
    if (chkFlag) {
      this.query = Object.assign({}, this.queryInitVal);
      this.inputSelectInsert = "";
      this.alertmsgstr = "";
      this.showCRRule = true;
      this.showAge = false;
      this.showEditRule = false;
      this.showWorkexpRuleManagement = true;
      this.showWorkexpRule = false;
      this.showRuleng = true;
      this.showDependent = false;
      this.showPreference = false;
      this.formTouchedFlag = false;
      this.showGridMandatorySec = false;
      this.showUploadSecPref = false;
    }
  }

  resetDependentFld() {
    this.showAge = false;
    this.showCRRule = false;
    this.showWorkexpRule = false;
    this.showWorkexpRuleManagement = false;
    this.showRuleng = false;
    this.showUploadSecPref = false;
    this.showDependent = true;
    this.showPreference = false;
  }

  resetPreferenceFld() {
    this.showAge = false;
    this.showCRRule = false;
    this.showWorkexpRule = false;
    this.showWorkexpRuleManagement = false;
    this.showRuleng = false;
    this.showPreference = true;
    this.showDependent = false;
    this.showUploadSecPref = false;
    this.showGridMandatorySec = false;
  }

  // work exp start
  resetWorkexpEng() {
    let chkFlag = true;
    if (
      this.unSaveData &&
      ((typeof this.ruleengineform !== "undefined" &&
        this.ruleengineform.dirty) ||
        (typeof this.myForm !== "undefined" && this.myForm.dirty) ||
        (typeof this.myFormworkexp !== "undefined" &&
          this.myFormworkexp.dirty) ||
        (typeof this.myFormworkexpArmedForces !== "undefined" &&
          this.myFormworkexpArmedForces.dirty) ||
        (typeof this.myDynFormworkexp !== "undefined" &&
          this.myDynFormworkexp.dirty) ||
        (typeof this.myPostbasedFormworkexp !== "undefined" &&
          this.myPostbasedFormworkexp.dirty))
    ) {
      if (
        confirm(
          "You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes."
        )
      ) {
        chkFlag = true;
        this.formTouchedFlag = false;
      } else {
        chkFlag = false;
      }
    }
    if (chkFlag) {
      this.query = Object.assign({}, this.queryInitVal);
      this.inputSelectInsert = "";
      this.alertmsgstr = "";
      this.showWorkexpRule = true;
      this.showWorkexpRuleManagement = false;
      this.showAge = false;
      this.showCRRule = false;
      this.showRuleng = false;
      this.showDependent = false;
      this.showPreference = false;
      this.showUploadSecPref = false;
      this.showGridMandatorySec = false;
      this.Workexpservice.workexpConfigEdit(
        this.model.projectName,
        this.model.accountName,
        "0"
      ).subscribe((res) => {
        console.log("inside reset function result", res);
        this.loading = false;
        if (res["success"] == true) {
          this.myFormworkexp = this._fb.group({
            totexp: [""],
            //CalcAppendField:[''],
            workexp: this._fb.array([
              //this.initwork(),
            ]),
          });

          if (res["data"] && res["data"] != "") {
            this.worExpData = res["data"];
            //this.model = res['data'];

            /* this.myFormworkexp = this._fb.group({
                totexp:[res['data'].totexp]
              }); */
            this.myFormworkexp = this._fb.group({
              totexp: [res["data"]["totexp"]],
              //	CalcAppendField:[res['data']['CalcAppendField']],
              workexp: this._fb.array([
                //this.initwork(),
              ]),
            });

            for (let i = 0; i < res["data"].workExpArrayCount; i++) {
              this.AddWorkexpcol(res["data"].formJSON[i]);
            }
          } else {
            this.AddWorkexpcol("");
          }
        }
      });

      this.Workexpservice.workexpConfigEdit(
        this.model.projectName,
        this.model.accountName,
        "3"
      ).subscribe((res) => {
        this.loading = false;
        if (res["success"] == true) {
          this.myPostbasedFormworkexp = this._fb.group({
            postbasedtotexp: [""],
            postbasedworkexp: this._fb.array([
              //this.initwork(),
            ]),
          });

          if (res["data"] && res["data"] != "") {
            this.postBasedWorkExpData = res["data"];
            //this.model = res['data'];

            /* this.myFormworkexp = this._fb.group({
                totexp:[res['data'].totexp]
              }); */
            this.myFormworkexp = this._fb.group({
              totexp: [res["data"]["totexp"]],
              //CalcAppendField:[res['data']['CalcAppendField']],
              workexp: this._fb.array([
                //this.initwork(),
              ]),
            });

            this.myFormworkexpArmedForces = this._fb.group({
              totexparmed: [res["data"]["totexparmed"]],
              workexpArmedContainer: this._fb.array([]),
            });
            for (let i = 0; i < res["data"].workExpArrayCount; i++) {
              this.AddWorkexpcol(res["data"].formJSON[i]);
            }
          } else {
            this.AddWorkexpcol("");
          }
        }
      });

      this.Workexpservice.workexpConfigEdit(
        this.model.projectName,
        this.model.accountName,
        "2"
      ).subscribe((res) => {
        this.loading = false;
        console.log("Outside if the result is", res);
        if (res["success"] == true) {
          this.myFormworkexpArmedForces = this._fb.group({
            totexparmed: [""],
            workexpArmedContainer: this._fb.array([]),
          });

          if (res["data"] && res["data"] != "") {
            console.log("the result of data is", res["data"]["totexp"]);

            this.armedForcesWorkExpData = res["data"];
            //this.model = res['data'];

            /* this.myFormworkexp = this._fb.group({
                totexp:[res['data'].totexp]
              }); */
            this.myFormworkexpArmedForces = this._fb.group({
              totexparmed: [res["data"]["totexp"]],
              workexpArmedContainer: this._fb.array([]),
            });
            for (let i = 0; i < res["data"].workExpArrayCount; i++) {
              this.AddArmedForceWorkexpcol(res["data"].formJSON[i]);
            }
          } else {
            this.AddArmedForceWorkexpcol("");
          }
        }
      });

      this.Workexpservice.workexpConfigEdit(
        this.model.projectName,
        this.model.accountName,
        "1"
      ).subscribe((res) => {
        this.loading = false;
        if (res["success"] == true) {
          this.myDynFormworkexp = this._fb.group({
            dyntotexp: [""],
            dynworkexp: this._fb.array([
              //this.initwork(),
            ]),
          });

          if (res["data"] && res["data"] != "") {
            this.DynworExpData = res["data"];
            //this.model = res['data'];

            /* this.myFormworkexp = this._fb.group({
                totexp:[res['data'].totexp]
              }); */
            this.myDynFormworkexp = this._fb.group({
              dyntotexp: [res["data"]["totexp"]],
              dynworkexp: this._fb.array([
                //this.initwork(),
              ]),
            });
            for (let i = 0; i < res["data"].workExpArrayCount; i++) {
              this.AddDynWorkexpcol(res["data"].formJSON[i]);
            }
          } else {
            this.AddDynWorkexpcol("");
          }
        }
      });
    }
  }

  resetDataGridEng() {
    let chkFlag = true;
    if (
      (typeof this.ruleengineform !== "undefined" &&
        this.ruleengineform.dirty) ||
      (typeof this.myForm !== "undefined" && this.myForm.dirty) ||
      (typeof this.myFormGridCheck !== "undefined" &&
        this.myFormGridCheck.dirty)
    ) {
      if (
        confirm(
          "You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes."
        )
      ) {
        chkFlag = true;
        this.formTouchedFlag = false;
      } else {
        chkFlag = false;
      }
    }
    if (chkFlag) {
      this.query = Object.assign({}, this.queryInitVal);
      this.showAge = false;
      this.showCRRule = false;
      this.showWorkexpRule = false;
      this.showWorkexpRuleManagement = false;
      this.showRuleng = false;
      this.showPreference = false;
      this.showDependent = false;
      this.showUploadSecPref = false;
      this.showGridMandatorySec = true;

      console.log("this.inputFiledSel::::::", this.inputFiledSel);

      this.ruleengineService
        .getGridCheckData(this.model.projectName)
        .subscribe((res) => {
          console.log("inside grid data get", res);
          this.loading = false;
          if (res["success"] == true) {
            this.myFormGridCheck = this._fb.group({
              gridcomp: "",
              chooseone: "",
              gridval: [],
            });

            if (res["data"] && res["data"] != "") {
              this.gridCheckData = res["data"]["gridCheck"];
              console.log("gridCheckData", this.gridCheckData);
              this.myFormGridCheck = this._fb.group({
                gridcomp: [res["data"]["gridCheck"]["gridcomp"]],
                chooseone: [res["data"]["gridCheck"]["chooseone"]],
                //gridval: [res['data']['gridCheck']['gridval']],
              });
              this.getGridDataFlag = true;
              this.gridvaluesObj = res["data"]["gridCheck"]["gridval"];
              console.log("get response keys", Object.keys(this.gridvaluesObj));
              this.fetchedGridValues = Object.keys(this.gridvaluesObj);
              setTimeout(() => {
                this.isEnabled();
              }, 100);
            } else {
              this.getGridDataFlag = false;
            }
          }
        });
    }
  }

  isEnabled() {
    console.log("get response values", this.gridvaluesObj);

    for (var prop in this.gridvaluesObj) {
      if (this.gridvaluesObj.hasOwnProperty(prop)) {
        if (this.gridvaluesObj[prop] === true) {
          var gotelemnet = document.getElementById(prop);
          console.log("gotelemnet", gotelemnet);
          document.getElementById(prop).setAttribute("checked", "true");
        } else {
          document.getElementById(prop).removeAttribute("checked");
        }
      }
    }
  }
  initwork(workDt) {
    return this._fb.group({
      fromdate: [workDt.fromdate],
      todate: [workDt.todate],
      CalcAppendField: [workDt.CalcAppendField],
    });
  }
  initDependentOn(workDt) {
    return this._fb.group({
      formFields: [workDt.formFields],
    });
  }

  initArmedForcework(workDt) {
    console.log("inside armed init");

    return this._fb.group({
      fromdatearmed: [workDt.fromdatearmed],
      todatearmed: [workDt.todatearmed],
      CalcAppendFieldarmed: [workDt.CalcAppendFieldarmed],
    });
  }

  initDynwork(workDt) {
    return this._fb.group({
      dynfromdate: [workDt.dynfromdate],
      dyntodate: [workDt.dyntodate],
      dynCalcAppendField: [workDt.dynCalcAppendField],
    });
  }

  initPostBasedWorkDynwork(workDt) {
    return this._fb.group({
      dynfromdate: [workDt.dynfromdate],
      dyntodate: [workDt.dyntodate],
      WorkcalcAppendField: [workDt.WorkcalcAppendField],
    });
  }

  // initGridCheck(workDt) {
  //   console.log("workDT Inside initgrid", workDt);
  //   return this._fb.group({
  //     fieldname: [workDt.fieldname]
  //   });
  // }

  AddWorkexpcol(workDt) {
    const control = <FormArray>this.myFormworkexp.controls["workexp"];
    control.push(this.initwork(workDt));
  }

  AddDependentOn(workDt) {
    const control = <FormArray>this.myForm.controls["dependenton"];
    control.push(this.initDependentOn(workDt));
  }
  AddArmedForceWorkexpcol(workDt) {
    const control = <FormArray>(
      this.myFormworkexpArmedForces.controls["workexpArmedContainer"]
    );
    control.push(this.initArmedForcework(workDt));
  }

  AddDynWorkexpcol(workDt) {
    const control = <FormArray>this.myDynFormworkexp.controls["dynworkexp"];
    control.push(this.initDynwork(workDt));
  }

  AddPostBasedWorkexpcol(workDt) {
    const control = <FormArray>(
      this.myPostbasedFormworkexp.controls["postbasedworkexp"]
    );
    control.push(this.initDynwork(workDt));
  }
  removeSection_depententon(i: number) {
    const control = <FormArray>this.myForm.controls["dependenton"];
    control.removeAt(i);
  }

  removeSection_workexp(i: number) {
    //console.log('ggggg');
    const control = <FormArray>this.myFormworkexp.controls["workexp"];
    control.removeAt(i);
  }

  // removeSection_GridCheck(i: number) {
  //   const control = <FormArray>this.myFormGridCheck.controls['gridCheck'];
  //   control.removeAt(i);
  // }
  onSubmitAge(modelid) {
    this.loading = true;
    console.log("form value of age ruleengine", this.myFormAge.value.age);
    let ageconfiglen = this.myFormAge.value.age.length;
    let i = 0;
    let ageconfig = this.myFormAge.value.age;
    for (i = 0; i < ageconfiglen; i++) {

      //  console.log("toLocaleDateString", ageconfig[i].ageAsonDate.toLocaleDateString('en-GB'));

      ageconfig[i].ageAsonDate = ageconfig[i].ageAsonDate.toLocaleDateString();
      ageconfig[i].ageMaxDate = ageconfig[i].ageMaxDate.toLocaleDateString();
      ageconfig[i].ageMinDate = ageconfig[i].ageMinDate.toLocaleDateString();

    }

    console.log("the modified ageconfig", ageconfig);


    this.ruleengineService.ageConfigStore(ageconfig, this.model.projectName, this.model.accountName, modelid)
      .subscribe(res => {
        console.log("response::", res)
        this.loading = false;
        this.unSaveData = false;
        if (res["success"] == true) {
          this.toastr.success(res["message"]);
          this.deletebtn = true;
          this.resetAgeEng();
        } else {
          this.toastr.error("Error in Creation...");
        }
      });
  }

  onSubmit() {
    //console.log('----------testingnnn start-------------');
    this.loading = true;
    this.Workexpservice.workexpConfigStore(
      this.myFormworkexp.value,
      this.model.projectName,
      this.model.accountName,
      this.worExpData["_id"],
      0
    ).subscribe((res) => {
      if (res["success"] == true) {
        var aletMsg =
          "Work Exp Calculation settings has been added successfully...";

        if (this.worExpData["_id"] && this.worExpData["_id"] != "") {
          aletMsg =
            "Work Exp Calculation settings has been updated successfully...";
        }
        var obj = JSON.parse(JSON.stringify(this.QueryBuilderConfigOrigArr));

        let JsonWorkExp = this.worExpData["formJSON"];

        for (let keyWork in JsonWorkExp) {
          var valueW = JsonWorkExp[keyWork];

          var inputSelectInsertArr1 = valueW["CalcAppendField"].split("-");

          var indexPageVal1 = inputSelectInsertArr1[0]; // page1
          var compIndexPageVal1 = inputSelectInsertArr1[1]; //firtsName

          obj = this.jsonAppendComponent_Fee(
            obj,
            indexPageVal1,
            compIndexPageVal1,
            "delete"
          );
        }
        //console.log("out");
        let JsonWorkExpForm = this.myFormworkexp.value.workexp;
        var RulePushArrWorkTot = [];
        var RulePushArrWorkTotStr = "";
        RulePushArrWorkTot = [];
        var counter = 0;
        for (let keyWorkFrm in JsonWorkExpForm) {
          var RulePushArrWork = [];
          var jsonConvertedValue = new Array();
          var valueW = JsonWorkExpForm[keyWorkFrm];
          var inputSelectInsertArr = valueW["CalcAppendField"].split("-");
          var fromdateArr = valueW["fromdate"].split("-");
          var todateArr = valueW["todate"].split("-");
          var indexPageVal = inputSelectInsertArr[0]; // page1
          var compIndexPageVal = inputSelectInsertArr[1]; //firtsName
          RulePushArrWork.push({
            ["date_calc_diff_year"]: [
              { var: "data." + fromdateArr[1] },
              { var: "data." + todateArr[1] },
            ],
          });
          jsonConvertedValue = RulePushArrWork.map(function (e) {
            return JSON.stringify(e);
          });
          //console.log('----------jsonConvertedValue value------------');
          //console.log(jsonConvertedValue);
          var dataString = jsonConvertedValue.join(",");
          this.jsonConvertedStrWorkExp = dataString;
          //console.log(indexPageVal);
          //console.log(compIndexPageVal);
          //console.log('----------jsonConvertedStrWorkExp value------------');
          //console.log(this.jsonConvertedStrWorkExp);

          obj = this.jsonAppendComponent_Fee(
            obj,
            indexPageVal,
            compIndexPageVal,
            "updateWorkExp"
          );

          /* RulePushArrWorkTotStr = '{"var":\"data.'+fromdateArr[1]+'\"},{"var":\"data.'+todateArr[1]+'\"}';
            RulePushArrWorkTot.push(RulePushArrWorkTotStr); */
          RulePushArrWorkTot.push([
            { var: "data." + fromdateArr[1] },
            { var: "data." + todateArr[1] },
          ]);
          //console.log('----------obj value------------');
          //console.log(obj);
          counter++;
        }

        //Total Experience
        var RulePushArrWorkTotP = new Array();
        var jsonConvertedValueTot = new Array();

        //console.log(RulePushArrWorkTot);
        var dataStringTotV = [];
        dataStringTotV.push({ date_calc_diff_totalmonth: RulePushArrWorkTot });

        //console.log(dataStringTotV);
        jsonConvertedValueTot = dataStringTotV.map(function (e) {
          return JSON.stringify(e);
        });
        var dataString = jsonConvertedValueTot.join(",");
        //console.log(dataString);
        this.jsonConvertedStrWorkExp = dataString;

        //this.jsonConvertedStrWorkExp = dataStringTotV;
        let Jsontotexp = this.worExpData["totexp"];
        let totexp = this.myFormworkexp.value.totexp;

        if (Jsontotexp && Jsontotexp != totexp) {
          var inputSelectInsertArrTotJ = Jsontotexp.split("-");
          var indexPageValTotJ = inputSelectInsertArrTotJ[0]; // page1
          var compIndexPageValTotJ = inputSelectInsertArrTotJ[1]; //firtsName
          obj = this.jsonAppendComponent_Fee(
            obj,
            indexPageValTotJ,
            compIndexPageValTotJ,
            "delete"
          );
        }

        var inputSelectInsertArrTot = totexp.split("-");
        var indexPageValTot = inputSelectInsertArrTot[0]; // page1
        var compIndexPageValTot = inputSelectInsertArrTot[1]; //firtsName
        obj = this.jsonAppendComponent_Fee(
          obj,
          indexPageValTot,
          compIndexPageValTot,
          "updateWorkExp"
        );
        //console.log(obj);

        this.QueryBuilderConfigOrigArr = obj;
        var Jsonapplncomp: Object = {
          components: this.QueryBuilderConfigOrigArr,
          display: "wizard",
        };
        var ruleEngWork;

        ruleEngWork = {
          accountName: this.model.accountName,
          projectName: this.model.projectName,
        };

        this.applicationService
          .appSubmit(ruleEngWork, Jsonapplncomp)
          .subscribe((res) => {
            if (res.success == true) {
              this.unSaveData = false;
              this.resetWorkexpEng();
              //alert(aletMsg);
              this.toastr.success(aletMsg);
            } else {
              this.toastr.error("Error in Creation...");
            }
          });
      }
    });
  }

  onWorkExpSubmit() {
    //console.log('----------testingnnn start-------------');
    this.loading = true;
    this.Workexpservice.workexpConfigStore(
      this.myFormworkexp.value,
      this.model.projectName,
      this.model.accountName,
      this.postBasedWorkExpData["_id"],
      2
    ).subscribe((res) => {
      if (res["success"] == true) {
        var aletMsg =
          "Work Exp Calculation settings has been added successfully...";

        if (
          this.postBasedWorkExpData["_id"] &&
          this.postBasedWorkExpData["_id"] != ""
        ) {
          aletMsg =
            "Work Exp Calculation settings has been updated successfully...";
        }
        var obj = JSON.parse(JSON.stringify(this.QueryBuilderConfigOrigArr));

        let JsonWorkExp = this.postBasedWorkExpData["formJSON"];

        console.log("JsonWorkExp -->", JsonWorkExp);
        for (let keyWork in JsonWorkExp) {
          var valueW = JsonWorkExp[keyWork];

          var inputSelectInsertArr1 = valueW["WorkcalcAppendField"].split("-");

          var indexPageVal1 = inputSelectInsertArr1[0]; // page1
          var compIndexPageVal1 = inputSelectInsertArr1[1]; //firtsName

          obj = this.jsonAppendComponent_Fee(
            obj,
            indexPageVal1,
            compIndexPageVal1,
            "delete"
          );
        }
        //console.log("out");
        let JsonWorkExpForm = this.myFormworkexp.value.workexp;
        var RulePushArrWorkTot = [];
        var RulePushArrWorkTotStr = "";
        RulePushArrWorkTot = [];
        var counter = 0;
        for (let keyWorkFrm in JsonWorkExpForm) {
          var RulePushArrWork = [];
          var jsonConvertedValue = new Array();
          var valueW = JsonWorkExpForm[keyWorkFrm];
          var inputSelectInsertArr = valueW["WorkcalcAppendField"].split("-");
          var fromdateArr = valueW["fromdate"].split("-");
          var todateArr = valueW["todate"].split("-");
          var indexPageVal = inputSelectInsertArr[0]; // page1
          var compIndexPageVal = inputSelectInsertArr[1]; //firtsName
          RulePushArrWork.push({
            ["date_calc_diff_year"]: [
              { var: "data." + fromdateArr[1] },
              { var: "data." + todateArr[1] },
            ],
          });
          jsonConvertedValue = RulePushArrWork.map(function (e) {
            return JSON.stringify(e);
          });
          //console.log('----------jsonConvertedValue value------------');
          //console.log(jsonConvertedValue);
          var dataString = jsonConvertedValue.join(",");
          this.jsonConvertedStrWorkExp = dataString;
          //console.log(indexPageVal);
          //console.log(compIndexPageVal);
          //console.log('----------jsonConvertedStrWorkExp value------------');
          //console.log(this.jsonConvertedStrWorkExp);

          obj = this.jsonAppendComponent_Fee(
            obj,
            indexPageVal,
            compIndexPageVal,
            "updateWorkExp"
          );

          /* RulePushArrWorkTotStr = '{"var":\"data.'+fromdateArr[1]+'\"},{"var":\"data.'+todateArr[1]+'\"}';
            RulePushArrWorkTot.push(RulePushArrWorkTotStr); */
          RulePushArrWorkTot.push([
            { var: "data." + fromdateArr[1] },
            { var: "data." + todateArr[1] },
          ]);
          //console.log('----------obj value------------');
          //console.log(obj);
          counter++;
        }

        //Total Experience
        var RulePushArrWorkTotP = new Array();
        var jsonConvertedValueTot = new Array();

        //console.log(RulePushArrWorkTot);
        var dataStringTotV = [];
        dataStringTotV.push({ date_calc_diff_totalmonth: RulePushArrWorkTot });

        //console.log(dataStringTotV);
        jsonConvertedValueTot = dataStringTotV.map(function (e) {
          return JSON.stringify(e);
        });
        var dataString = jsonConvertedValueTot.join(",");
        //console.log(dataString);
        this.jsonConvertedStrWorkExp = dataString;

        //this.jsonConvertedStrWorkExp = dataStringTotV;
        let Jsontotexp = this.postBasedWorkExpData["totexp"];
        let totexp = this.myFormworkexp.value.totexp;

        if (Jsontotexp && Jsontotexp != totexp) {
          var inputSelectInsertArrTotJ = Jsontotexp.split("-");
          var indexPageValTotJ = inputSelectInsertArrTotJ[0]; // page1
          var compIndexPageValTotJ = inputSelectInsertArrTotJ[1]; //firtsName
          obj = this.jsonAppendComponent_Fee(
            obj,
            indexPageValTotJ,
            compIndexPageValTotJ,
            "delete"
          );
        }

        var inputSelectInsertArrTot = totexp.split("-");
        var indexPageValTot = inputSelectInsertArrTot[0]; // page1
        var compIndexPageValTot = inputSelectInsertArrTot[1]; //firtsName
        obj = this.jsonAppendComponent_Fee(
          obj,
          indexPageValTot,
          compIndexPageValTot,
          "updateWorkExp"
        );
        //console.log(obj);

        this.QueryBuilderConfigOrigArr = obj;
        var Jsonapplncomp: Object = {
          components: this.QueryBuilderConfigOrigArr,
          display: "wizard",
        };
        var ruleEngWork;

        ruleEngWork = {
          accountName: this.model.accountName,
          projectName: this.model.projectName,
        };

        this.applicationService
          .appSubmit(ruleEngWork, Jsonapplncomp)
          .subscribe((res) => {
            if (res.success == true) {
              this.unSaveData = false;
              this.resetWorkexpEng();
              //alert(aletMsg);
              this.toastr.success(aletMsg);
            } else {
              this.toastr.error("Error in Creation...");
            }
          });
      }
    });
  }

  //Armed Forces work experience submit

  armedForcesSubmit() {
    this.loading = true;
    this.Workexpservice.workexpConfigStore(
      this.myFormworkexpArmedForces.value,
      this.model.projectName,
      this.model.accountName,
      this.armedForcesWorkExpData["_id"],
      "2"
    ).subscribe((res) => {
      if (res["success"] == true) {
        var aletMsg =
          "Work Exp Calculation settings has been added successfully...";

        if (
          this.armedForcesWorkExpData["_id"] &&
          this.armedForcesWorkExpData["_id"] != ""
        ) {
          aletMsg =
            "Work Exp Calculation settings has been updated successfully...";
        }
        var obj = JSON.parse(JSON.stringify(this.QueryBuilderConfigOrigArr));

        let JsonWorkExp = this.armedForcesWorkExpData["formJSON"];
        for (let keyWork in JsonWorkExp) {
          var valueW = JsonWorkExp[keyWork];
          console.log("the value inside armedforce submit is", valueW);
          var inputSelectInsertArr1 = valueW["CalcAppendFieldarmed"].split("-");

          var indexPageVal1 = inputSelectInsertArr1[0]; // page1
          var compIndexPageVal1 = inputSelectInsertArr1[1]; //firtsName

          obj = this.jsonAppendComponent_Fee(
            obj,
            indexPageVal1,
            compIndexPageVal1,
            "delete"
          );
        }
        let JsonWorkExpForm =
          this.myFormworkexpArmedForces.value.workexpArmedContainer;
        var RulePushArrWorkTot = [];
        var RulePushArrWorkTotStr = "";
        RulePushArrWorkTot = [];
        var counter = 0;
        var configArrJson = JSON.parse(this.configPushArrayOrigStr);
        for (let keyWorkFrm in JsonWorkExpForm) {
          var RulePushArrWork = [];
          var jsonConvertedValue = new Array();
          var valueW = JsonWorkExpForm[keyWorkFrm];
          var inputSelectInsertArr = valueW["CalcAppendFieldarmed"].split("-");
          var fromdateArr = valueW["fromdatearmed"].split("-");
          var todateArr = valueW["todatearmed"].split("-");
          var indexPageVal = inputSelectInsertArr[0]; // page1
          var compIndexPageVal = inputSelectInsertArr[1]; //firtsName
          RulePushArrWork.push({
            ["date_calc_diff_year"]: [
              { var: "row." + fromdateArr[1] },
              { var: "row." + todateArr[1] },
            ],
          });
          jsonConvertedValue = RulePushArrWork.map(function (e) {
            return JSON.stringify(e);
          });

          var dataString = jsonConvertedValue.join(",");
          this.jsonConvertedStrWorkExp = dataString;
          obj = this.jsonAppendComponent_Fee(
            obj,
            indexPageVal,
            compIndexPageVal,
            "updateWorkExp"
          );
          //  if(typeof todateArr[1]!== 'undefined' && typeof configArrJson[todateArr[1]]['layoutCompKey'] !== 'undefined')
          // 	 RulePushArrWorkTot.push(fromdateArr[1],todateArr[1],{"var":"data."+configArrJson[todateArr[1]]['layoutCompKey']});
          RulePushArrWorkTot.push([
            { var: "data." + fromdateArr[1] },
            { var: "data." + todateArr[1] },
          ]);
          counter++;
        }

        //Total Experience
        var RulePushArrWorkTotP = new Array();
        var jsonConvertedValueTot = new Array();

        console.log(RulePushArrWorkTot);
        var dataStringTotV = [];
        dataStringTotV.push({ date_calc_diff_totalmonth: RulePushArrWorkTot });

        console.log("in armedforce function", dataStringTotV);
        jsonConvertedValueTot = dataStringTotV.map(function (e) {
          return JSON.stringify(e);
        });
        var dataString = jsonConvertedValueTot.join(",");
        //console.log(dataString);
        this.jsonConvertedStrWorkExp = dataString;

        //this.jsonConvertedStrWorkExp = dataStringTotV;
        let Jsontotexp = this.armedForcesWorkExpData["totexparmed"];
        let totexp = this.myFormworkexpArmedForces.value.totexparmed;

        if (Jsontotexp && Jsontotexp != totexp) {
          var inputSelectInsertArrTotJ = Jsontotexp.split("-");
          var indexPageValTotJ = inputSelectInsertArrTotJ[0]; // page1
          var compIndexPageValTotJ = inputSelectInsertArrTotJ[1]; //firtsName
          obj = this.jsonAppendComponent_Fee(
            obj,
            indexPageValTotJ,
            compIndexPageValTotJ,
            "delete"
          );
        }

        var inputSelectInsertArrTot = totexp.split("-");
        var indexPageValTot = inputSelectInsertArrTot[0]; // page1
        var compIndexPageValTot = inputSelectInsertArrTot[1]; //firtsName
        obj = this.jsonAppendComponent_Fee(
          obj,
          indexPageValTot,
          compIndexPageValTot,
          "updateWorkExp"
        );
        //console.log(obj);

        this.QueryBuilderConfigOrigArr = obj;
        var Jsonapplncomp: Object = {
          components: this.QueryBuilderConfigOrigArr,
          display: "wizard",
        };
        var ruleEngWork;

        ruleEngWork = {
          accountName: this.model.accountName,
          projectName: this.model.projectName,
        };

        this.applicationService
          .appSubmit(ruleEngWork, Jsonapplncomp)
          .subscribe((res) => {
            if (res.success == true) {
              this.unSaveData = false;
              this.resetWorkexpEng();
              //alert(aletMsg);
              this.toastr.success(aletMsg);
            } else {
              this.toastr.error("Error in Creation...");
            }
          });
      }
    });
  }

  DynWorkExpSubmit() {
    //console.log('----------testingnnn start-------------');
    this.loading = true;
    this.Workexpservice.workexpConfigStore(
      this.myDynFormworkexp.value,
      this.model.projectName,
      this.model.accountName,
      this.DynworExpData["_id"],
      "1"
    ).subscribe((res) => {
      if (res["success"] == true) {
        var aletMsg =
          "Work Exp Calculation settings has been added successfully...";

        if (this.DynworExpData["_id"] && this.DynworExpData["_id"] != "") {
          aletMsg =
            "Work Exp Calculation settings has been updated successfully...";
        }
        var obj = JSON.parse(JSON.stringify(this.QueryBuilderConfigOrigArr));

        let JsonWorkExp = this.DynworExpData["formJSON"];
        for (let keyWork in JsonWorkExp) {
          var valueW = JsonWorkExp[keyWork];

          var inputSelectInsertArr1 = valueW["dynCalcAppendField"].split("-");

          var indexPageVal1 = inputSelectInsertArr1[0]; // page1
          var compIndexPageVal1 = inputSelectInsertArr1[1]; //firtsName

          obj = this.jsonAppendComponent_Fee(
            obj,
            indexPageVal1,
            compIndexPageVal1,
            "delete"
          );
        }

        let JsonWorkExpForm = this.myDynFormworkexp.value.dynworkexp;
        var RulePushArrWorkTot = [];
        var RulePushArrWorkTotStr = "";
        RulePushArrWorkTot = [];
        var counter = 0;
        var configArrJson = JSON.parse(this.configPushArrayOrigStr);
        for (let keyWorkFrm in JsonWorkExpForm) {
          var RulePushArrWork = [];
          var jsonConvertedValue = new Array();
          var valueW = JsonWorkExpForm[keyWorkFrm];
          var inputSelectInsertArr = valueW["dynCalcAppendField"].split("-");
          var fromdateArr = valueW["dynfromdate"].split("-");
          var todateArr = valueW["dyntodate"].split("-");
          var indexPageVal = inputSelectInsertArr[0]; // page1
          var compIndexPageVal = inputSelectInsertArr[1]; //firtsName
          RulePushArrWork.push({
            ["date_calc_diff_year"]: [
              { var: "row." + fromdateArr[1] },
              { var: "row." + todateArr[1] },
            ],
          });
          jsonConvertedValue = RulePushArrWork.map(function (e) {
            return JSON.stringify(e);
          });
          //console.log('----------jsonConvertedValue value------------');
          //console.log(jsonConvertedValue);
          var dataString = jsonConvertedValue.join(",");
          this.jsonConvertedStrWorkExp = dataString;
          //console.log(indexPageVal);
          //console.log(compIndexPageVal);
          //console.log('----------jsonConvertedStrWorkExp value------------');
          //console.log(this.jsonConvertedStrWorkExp);

          obj = this.jsonAppendComponent_Fee(
            obj,
            indexPageVal,
            compIndexPageVal,
            "updateWorkExp"
          );

          /* RulePushArrWorkTotStr = '{"var":\"data.'+fromdateArr[1]+'\"},{"var":\"data.'+todateArr[1]+'\"}';
            RulePushArrWorkTot.push(RulePushArrWorkTotStr); */
          if (
            typeof todateArr[1] !== "undefined" &&
            typeof configArrJson[todateArr[1]]["layoutCompKey"] !== "undefined"
          )
            RulePushArrWorkTot.push(fromdateArr[1], todateArr[1], {
              var: "data." + configArrJson[todateArr[1]]["layoutCompKey"],
            });
          //console.log('----------obj value------------');
          //console.log(obj);
          counter++;
        }

        //Total Experience
        var RulePushArrWorkTotP = new Array();
        var jsonConvertedValueTot = new Array();

        //console.log(RulePushArrWorkTot);
        var dataStringTotV = [];
        dataStringTotV.push({ WorkExpCalc: RulePushArrWorkTot });

        //console.log(dataStringTotV);
        jsonConvertedValueTot = dataStringTotV.map(function (e) {
          return JSON.stringify(e);
        });
        var dataString = jsonConvertedValueTot.join(",");
        //console.log(dataString);
        this.jsonConvertedStrWorkExp = dataString;

        //this.jsonConvertedStrWorkExp = dataStringTotV;
        let Jsontotexp = this.DynworExpData["dyntotexp"];
        let totexp = this.myDynFormworkexp.value.dyntotexp;

        if (Jsontotexp && Jsontotexp != totexp) {
          var inputSelectInsertArrTotJ = Jsontotexp.split("-");
          var indexPageValTotJ = inputSelectInsertArrTotJ[0]; // page1
          var compIndexPageValTotJ = inputSelectInsertArrTotJ[1]; //firtsName
          obj = this.jsonAppendComponent_Fee(
            obj,
            indexPageValTotJ,
            compIndexPageValTotJ,
            "delete"
          );
        }

        var inputSelectInsertArrTot = totexp.split("-");
        var indexPageValTot = inputSelectInsertArrTot[0]; // page1
        var compIndexPageValTot = inputSelectInsertArrTot[1]; //firtsName
        obj = this.jsonAppendComponent_Fee(
          obj,
          indexPageValTot,
          compIndexPageValTot,
          "updateWorkExp"
        );
        //console.log(obj);

        this.QueryBuilderConfigOrigArr = obj;
        var Jsonapplncomp: Object = {
          components: this.QueryBuilderConfigOrigArr,
          display: "wizard",
        };
        var ruleEngWork;

        ruleEngWork = {
          accountName: this.model.accountName,
          projectName: this.model.projectName,
        };

        this.applicationService
          .appSubmit(ruleEngWork, Jsonapplncomp)
          .subscribe((res) => {
            if (res.success == true) {
              this.unSaveData = false;
              this.resetWorkexpEng();
              //alert(aletMsg);
              this.toastr.success(aletMsg);
            } else {
              this.toastr.error("Error in Creation...");
            }
          });
      }
    });
  }

  gridCheckSubmit() {
    this.myFormGridCheck.value.gridval = this.gridvaluesObj;
    console.log("inside grid mandatory check", this.myFormGridCheck.value);

    this.ruleengineService
      .gridCheckStore(
        this.myFormGridCheck.value,
        this.model.projectName,
        this.model.accountName
      )
      .subscribe((res) => {
        console.log(res);
        var jsLogic;
        let gridCompArr = [];

        if (res.status === 200) {
          var gridValues = res.data.gridCheck.gridval;
          console.log("the fieldname to add logic is", gridValues);
          for (var prop in gridValues) {
            if (gridValues.hasOwnProperty(prop)) {
              if (gridValues[prop] === true) {
                gridCompArr.push(prop);
              }
            }
          }
          var javascriptLogic = [];
          console.log(
            "this.QueryBuilderConfigOrigArr",
            this.QueryBuilderConfigOrigArr
          );
          for (let key in gridCompArr) {
            console.log("keyData", gridCompArr[key]);
            if (key === "0") {
              javascriptLogic.push(
                "(row['" +
                gridCompArr[key] +
                "']===undefined || row['" +
                gridCompArr[key] +
                `'] ===\"\" || row['` +
                gridCompArr[key] +
                `']==="00/00/0000" || row['` +
                gridCompArr[key] +
                "'] === false)"
              );
            } else {
              javascriptLogic.push(
                "&&(row['" +
                gridCompArr[key] +
                "']===undefined || row['" +
                gridCompArr[key] +
                `'] ===\"\" || row['` +
                gridCompArr[key] +
                `']==="00/00/0000" || row['` +
                gridCompArr[key] +
                "'] === false)"
              );
            }
          }
          console.log("javascript logic array is", javascriptLogic);
          var script;
          var resultCon = "";
          //if block Logic
          for (var i = 0; i < javascriptLogic.length; i++) {
            //console.log("javascript::::::", javascriptLogic[i]);
            resultCon = resultCon.concat(javascriptLogic[i]);
          }

          //else Block Logic
          var elseLogic = [];
          console.log("Gridcomp array ", gridCompArr);
          for (let key in gridCompArr) {
            // console.log("keyData", gridCompArr[key]);
            if (key === "0") {
              elseLogic.push(
                "((row['" +
                gridCompArr[key] +
                "']!==undefined) || (row['" +
                gridCompArr[key] +
                "'] === true))"
              );
            } else {
              elseLogic.push(
                "|| ((row['" +
                gridCompArr[key] +
                "']!==undefined)|| (row['" +
                gridCompArr[key] +
                "'] === true))"
              );
            }
          }
          var elseCond = "";
          for (var i = 0; i < elseLogic.length; i++) {
            elseCond = elseCond.concat(elseLogic[i]);
          }
          //null check else block

          var nullCheckLogic = [];

          for (let key in gridCompArr) {
            console.log(" outsidee keyData", gridCompArr[key] + 1);
            if (key === "0") {
              nullCheckLogic.push("(row['" + gridCompArr[key] + '\']==="")');
            } else {
              nullCheckLogic.push("|| (row['" + gridCompArr[key] + '\']==="")');
            }
          }

          console.log("nullCheckLogic condition is", nullCheckLogic);
          var nullElseCond = "";
          for (var i = 0; i < nullCheckLogic.length; i++) {
            nullElseCond = nullElseCond.concat(nullCheckLogic[i]);
          }
          console.log("null condition else block", nullElseCond);
          var ifCond;
          var elseBlockCon;
          var scriptLogic = [];
          var jsstringLogic;
          if (res.data.gridCheck.chooseone === "mandatory") {
            ifCond = "if(" + resultCon + "){ result = false; return result;}";
            console.log("result condition is", ifCond);
            elseBlockCon =
              "else {if(" + elseCond + "){result = true; return result;}}";
            console.log(" Final else block", elseBlockCon);
            var finalLogic = ifCond + elseBlockCon;
            console.log(
              "finalLogic mandatory::::::::::::::::::::::::::::::::",
              finalLogic
            );

            jsstringLogic = {
              name: "mandatory",
              trigger: {
                type: "javascript",
                javascript: finalLogic,
              },
              actions: [
                {
                  name: "mandatory",
                  type: "property",
                  property: {
                    label: "Required",
                    value: "validate.required",
                    type: "boolean",
                  },
                  state: true,
                },
              ],
            };

            scriptLogic.push(jsstringLogic);
            console.log("JSLogic", scriptLogic);
          } else if (res.data.gridCheck.chooseone === "nullcheck") {
            ifCond = "if(" + resultCon + "){ valid= true;}";
            elseBlockCon =
              "else {if(" +
              nullElseCond +
              '){ valid = "You should fill all values in a row";}}';
            var finalLogic = ifCond + elseBlockCon;
            console.log("Final logic for null check", finalLogic);
            jsLogic = finalLogic;
          }
          let JsonConfigOrig = this.QueryBuilderConfigOrigArr;
          for (let key in JsonConfigOrig) {
            var value = JsonConfigOrig[key];

            for (let keyC in value["components"]) {
              var valueC = value["components"][keyC];
              if (valueC["type"] === "datagrid") {
                //DATAGRID LATOUT
                var dataGridvalues = valueC["label"];
                if (res.data.gridCheck.gridcomp === dataGridvalues) {
                  var valueDG = valueC["components"];
                  for (let keyDG in valueDG) {
                    var finalValueDG = valueDG[keyDG];
                    console.log("value final is", finalValueDG);
                    console.log("label of final value dg", finalValueDG.label);
                    // console.log("condin vals are", res.data.gridCheck.gridval);
                    for (var prop in res.data.gridCheck.gridval) {
                      console.log("prop is", prop);

                      if (
                        res.data.gridCheck.gridval[prop] === true &&
                        res.data.gridCheck.chooseone === "mandatory" &&
                        prop === finalValueDG.key
                      ) {
                        finalValueDG["logic"] = scriptLogic;
                        console.log("inside 1st if", finalValueDG["logic"]);
                      } else if (
                        res.data.gridCheck.gridval[prop] === false &&
                        res.data.gridCheck.chooseone === "mandatory" &&
                        prop === finalValueDG.key
                      ) {
                        console.log("inside 1st  elseif");
                        finalValueDG["logic"] = [];
                      }

                      if (
                        res.data.gridCheck.gridval[prop] === true &&
                        res.data.gridCheck.chooseone === "nullcheck" &&
                        prop === finalValueDG.key
                      ) {
                        console.log("inside 2nd if", finalValueDG);
                        finalValueDG["validate"]["custom"] = jsLogic;
                        console.log(
                          "inside 2nd if 2nd con",
                          finalValueDG["custom"]
                        );
                      } else if (
                        res.data.gridCheck.gridval[prop] === false &&
                        res.data.gridCheck.chooseone === "nullcheck" &&
                        prop === finalValueDG.key
                      ) {
                        console.log("inside 2st  elseif");
                        finalValueDG["validate"]["custom"] = "";
                      }
                      console.log("finalValueDG", finalValueDG);
                    }
                  }
                }
              }
            }
          }
          console.log("Modified Final app json is", JsonConfigOrig);
          var Jsonapplncomp: Object = {
            components: JsonConfigOrig,
            display: "wizard",
          };
          let ruleEngForm = {
            value: {
              accountName: this.model.accountName,
              projectName: this.model.projectName,
            },
          };
          this.applicationService
            .appSubmit(ruleEngForm.value, Jsonapplncomp)
            .subscribe((res) => {
              if (res.success == true) {
                this.toastr.success("Grid Data Saved Successfully");
              } else {
                this.toastr.error("Grid Data Failed to save");
              }
            });
        }
      });
  }
  //work exp end
  resetAgeEng() {
    let chkFlag = true;
    if (
      this.unSaveData &&
      ((typeof this.ruleengineform !== "undefined" &&
        this.ruleengineform.dirty) ||
        (typeof this.myForm !== "undefined" && this.myForm.dirty) ||
        (typeof this.myFormAge !== "undefined" && this.myFormAge.dirty) ||
        (typeof this.myFormworkexp !== "undefined" &&
          this.myFormworkexp.dirty) ||
        (typeof this.myDynFormworkexp !== "undefined" &&
          this.myDynFormworkexp.dirty))
    ) {
      if (
        confirm(
          "You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes."
        )
      ) {
        chkFlag = true;
        this.formTouchedFlag = false;
      } else {
        chkFlag = false;
      }
    }
    if (chkFlag) {
      this.showAge = true;
      this.showCRRule = false;
      this.myForm = this._fb.group({
        ageDep: new FormControl(""),
        formFields: new FormControl(""),
        relaxFields: new FormControl(""),
        dobVal: new FormControl(""),
        ageVal: new FormControl(""),
        dependenton: this._fb.array([]),
      });
      this.myFormAge = this._fb.group({
        age: this._fb.array([
          //this.initAge(),
        ]),
      });

      this.getageRelaxationList();

      this.showWorkexpRule = false;
      this.showWorkexpRuleManagement = true;
      this.showRuleng = false;
      this.showDependent = false;
      this.showPreference = false;
      this.showUploadSecPref = false;
      this.showGridMandatorySec = false;
    }
  }
  ageConfigMap() {
    this.ageDependent = {};
    let flag = 0;
    let depArrayName = "depArrayName";
    let AgeConfigDependentField = this.myForm.get("dependenton").value;
    for (var i = 0; i < AgeConfigDependentField.length; i++) {
      let fieldnames = AgeConfigDependentField[i].formFields;
      flag += 1;
      let AgeConfigDependent = this.myForm.get("ageDep").value;
      if (AgeConfigDependent == "Y" && fieldnames != "") {
        this.ageDependent[depArrayName + flag] =
          this.fieldListArr[fieldnames]["options"];
      }
      this.dependentkeys = Object.keys(this.ageDependent);
      this.dependentOnLen = this.dependentkeys.length;

      this.finaldata = this.ageDependent;
    }
  }
  getageRelaxationList() {
    this.ruleengineService
      .getRelaxationList(this.model.accountName, this.model.projectName)
      .subscribe((res) => {
        if (res.genFormStatus == "Success") {
          let jsonData = JSON.parse(res.genFormJSON);
          var arrkey = "rel1";
          let genRelaxAgeJSON = JSON.parse(res.genRelaxAgeJSON);
          this.genRelaxAgeJSONList = genRelaxAgeJSON;

          this.myForm.controls["ageDep"].setValue(
            genRelaxAgeJSON.formVal.ageDep
          );
          this.myForm.controls["formFields"].setValue(
            genRelaxAgeJSON.formVal.formFields
          );
          this.myForm.controls["relaxFields"].setValue(
            genRelaxAgeJSON.formVal.relaxFields
          );
          this.myForm.controls["ageVal"].setValue(
            genRelaxAgeJSON.formVal.ageVal
          );
          this.myForm.controls["dobVal"].setValue(
            genRelaxAgeJSON.formVal.dobVal
          );

          if (genRelaxAgeJSON.formVal.dependenton != "") {
            for (
              let i = 0;
              i < genRelaxAgeJSON.formVal.dependenton.length;
              i++
            ) {
              this.AddDependentOn(genRelaxAgeJSON.formVal.dependenton[i]);
            }
          } else {
            this.AddDependentOn("");
          }

          //this.myForm.controls['ageDependentFields'].setValue(genRelaxAgeJSON.formVal.ageDependentFields);
          this.ageConfigMap();

          let dataKeys = Object.keys(jsonData);
          console.log(dataKeys);
          let listData = [];
          let iteration = 0;
          for (let prop of dataKeys) {
            console.log(jsonData[prop]);
            console.log("inside new array");
            this.RelaxFieldThird[iteration + 1] = new Array();
            this.GenderFieldSecond[iteration + 1] = new Array();
            this.RelaxFieldThirdAvail[iteration + 1] = new Array();
            jsonData[prop].subArr =
              genRelaxAgeJSON.formVal["rel" + (iteration + 1)];
            //console.log(genRelaxAgeJSON.formVal['rel'+(iteration+1)]);
            //console.log(jsonData[prop]);
            listData.push(jsonData[prop]);
            if (
              genRelaxAgeJSON.hasOwnProperty("formVal") &&
              genRelaxAgeJSON.formVal.hasOwnProperty("rel" + (iteration + 1))
            ) {
              if (genRelaxAgeJSON.formVal.dependenton.length > 0) {
                for (
                  let d = 0;
                  d < genRelaxAgeJSON.formVal.dependenton.length;
                  d++
                ) {
                  this.myForm.addControl(
                    "ageDependentFields" + iteration + d,
                    new FormControl(
                      genRelaxAgeJSON.formVal[
                      "ageDependentFields" + iteration + d
                      ]
                    )
                  );
                }
              }
              this.relaxationlistcount[iteration] =
                genRelaxAgeJSON.formVal["rel" + (iteration + 1)].length;
              //console.log("genRelaxAgeJSON.formVal['rel'+(iteration+1)].length");
              //console.log(genRelaxAgeJSON.formVal['rel'+(iteration+1)].length);
              let countVal = this.relaxationlistcount[iteration];
              for (let i = 0; i < countVal; i++) {
                //console.log(genRelaxAgeJSON.formVal['rel'+(iteration+1)]);
                this.showRelaxation(
                  iteration,
                  i,
                  genRelaxAgeJSON.formVal.relaxFields,
                  genRelaxAgeJSON.formVal["rel" + (iteration + 1)][i]
                );
              }
            } else {
              if (genRelaxAgeJSON.formVal.dependenton.length > 0) {
                for (
                  let d = 0;
                  d < genRelaxAgeJSON.formVal.dependenton.length;
                  d++
                ) {
                  this.myForm.addControl(
                    "ageDependentFields" + iteration + d,
                    new FormControl(
                      genRelaxAgeJSON.formVal[
                      "ageDependentFields" + iteration + d
                      ]
                    )
                  );
                }
              }
              this.relaxationlistcount[iteration] = 0;
            }
            iteration++;
          }
          //console.log(this.relaxationlistcount);
          this.ageRelaxationList = listData;
          this.deletebtn = true;
        } else if (res.genFormStatus == "update") {
          console.log("inside update");
          let genRelaxAgeJSON = res.genRelaxAgeJSON;
          let jsonData = JSON.parse(res.genFormJSON);
          let dataKeys = Object.keys(jsonData);
          let listData = [];
          let iteration = 0;
          for (let prop of dataKeys) {
            //console.log(jsonData[prop]);
            //console.log(genRelaxAgeJSON.formVal['rel'+(iteration+1)]);
            //console.log(jsonData[prop]);
            listData.push(jsonData[prop]);
            for (var d = 0; d < 5; d++) {
              this.myForm.addControl(
                "ageDependentFields" + iteration + d,
                new FormControl("")
              );
            }
            this.relaxationlistcount[iteration] = 0;
            iteration++;
          }

          this.deletebtn = false;
          this.ageRelaxationList = listData;
        }
      });

    this.ruleengineService
      .getAgeCofigDetails(this.model.projectName, this.model.accountName)
      .subscribe((res) => {
        console.log("storedres::", res);
        if (res["success"] == true) {
          this.model = res["data"];
          for (let i = 0; i < res["data"].ageArrayCount; i++) {
            this.generateAge(res["data"].formJSON[i]);
          }
          this.deletebtn = true;
        } else {
          this.generateAge("");
          this.deletebtn = false;
        }
      });
  }

  showRelaxation(
    index: number,
    relcount: number,
    relaxField: string,
    editData = ""
  ) {
    /* console.log(index);
    console.log(relcount);
    console.log(relaxField); */
    let relaxFieldVal1 = [];
    for (let optionObj of this.fieldListArr[relaxField]["options"]) {
      relaxFieldVal1.push(optionObj.name);
    }
    this.relaxFieldVal = relaxFieldVal1;
    console.log(this.relaxFieldVal);
    this.generate(index, relcount, this.relaxFieldVal, editData);
    /*  this.myForm = this._fb.group({
             rel: this._fb.array([
               this.initRel(relaxFieldVal),
             ])

           });  */
    let relIndex = index + 1;
    let relcountIndex = relcount;
    console.log(relIndex + "--" + relcountIndex);
    this.getSecondaryOpt(relIndex, relcountIndex);
    this.getSecondaryOptGender(relIndex, relcountIndex);
    //this.getSecondaryOpt(relIndex,relcountIndex,'Avail');
  }

  initRel(relaxFieldVal, editData = "") {
    let fldObj = {
      relaxFormField: [
        editData["relaxFormField"] ? editData["relaxFormField"] : "",
      ],
    };
    fldObj["relaxFormField_sec"] = [
      editData["relaxFormField_sec"] ? editData["relaxFormField_sec"] : "",
    ];
    fldObj["relaxFormField_third"] = [
      editData["relaxFormField_third"] ? editData["relaxFormField_third"] : "",
    ];
    fldObj["relaxFormFieldAvail"] = [
      editData["relaxFormFieldAvail"] ? editData["relaxFormFieldAvail"] : "",
    ];
    //if(editData['relaxFormFieldAvail'])
    fldObj["relaxFormFieldAvail_sec"] = [
      editData["relaxFormFieldAvail_sec"]
        ? editData["relaxFormFieldAvail_sec"]
        : "",
    ];
    fldObj["genderFormField_first"] = [
      editData["genderFormField_first"]
        ? editData["genderFormField_first"]
        : "",
    ];
    fldObj["genderFormField_sec"] = [
      editData["genderFormField_sec"] ? editData["genderFormField_sec"] : "",
    ];
    for (let fldVal of relaxFieldVal) {
      fldObj[fldVal] = [editData[fldVal]];
    }
    return this._fb.group(fldObj);
  }

  generate(index, relcount, relaxFieldVal, editData = "") {
    // const control = <FormArray>this.myForm.controls['rel'];
    let fldVal = "rel" + parseInt(index + 1);
    if (relcount == 0) {
      this.myForm.addControl(
        fldVal,
        this._fb.array([this.initRel(relaxFieldVal, editData)])
      );
      this.relaxFieldCount[index + 1] = [];
    } else {
      const control = <FormArray>this.myForm.controls[fldVal];
      control.push(this.initRel(relaxFieldVal, editData));
    }
    this.relaxFieldCount[index + 1].push("value");
    this.relaxationlistcount[index] = relcount + 1;
    /* console.log(editData);
    this.relaxFormField_third = editData['relaxFormField_third']; */
  }
  /*removeSection(index:any, relcount:number, i: number) {
    let fldVal = 'rel' + parseInt(index+1);
    const control = <FormArray>this.myForm.controls[fldVal];
    control.removeAt(i);
    this.relaxationlistcount[index] = relcount-1;
    this.relaxFieldCount[index+1].pop();

    /*console.log(fldVal);
    console.log(this.relaxationlistcount);*/ /*
}*/
  /** Delte relaxation Fixes**/
  removeSection(index: any, relcount: number, i: number) {
    let fldVal = "rel" + parseInt(index + 1);
    //this.relaxFieldCount[parseInt(index+1)].splice(3,1);
    //const control = <FormArray>this.myForm.controls[fldVal];
    //control.removeAt(i);
    this.relaxationlistcount[parseInt(index)] = relcount - 1;
    //this.relaxFieldCount[parseInt(index+1)].pop();
    //console.log(this.ageRelaxationList);
    //console.log(parseInt(index+1));
    //this.relaxFieldCount[parseInt(index+1)].splice(i,1);
    const control = <FormArray>this.myForm.controls[fldVal];
    control.removeAt(i);
    for (let r = 0; r < relcount - 1; r++) {
      this.showRelaxation(
        index,
        r,
        this.genRelaxAgeJSONList.formVal.relaxFields,
        ""
      );
    }

    //this.showRelaxation(index, i, this.genRelaxAgeJSONList.formVal.relaxFields,'');
    //this.relaxFieldCount[parseInt(index+1)].splice(i);
    //console.log(this.relaxFieldCount);
    //console.log(parseInt(index+1)+"=="+i);
    //delete this.relaxFieldCount[parseInt(index+1)][i];
    //this.relaxFieldCount[parseInt(index+1)].splice(i,1);
    //console.log(this.relaxFieldCount);
    /*console.log(this.relaxationlistcount);*/
    /* 		this.ref.markForCheck();
    this.appRef.tick();
    for (let r = 0; r < relcount-1; r++) {
      this.showRelaxation(index, r, this.genRelaxAgeJSONList.formVal.relaxFields,'');
    } */
  }

  get ageDep() {
    // name property
    return this.myForm.get("ageDep");
  }

  get relaxFields() {
    // name property
    return this.myForm.get("relaxFields");
  }

  get formFields() {
    // name property
    return this.myForm.get("formFields");
  }

  searchStatus() {
    //console.log("innn "+this.inputSearch);
    this.ruleengineService
      .getRulesManage(
        this.model.accountName,
        this.model.projectName,
        this.inputSearch
      )
      .subscribe((res) => {
        this.ruleEngineData = res.data;
      });
  }

  toscrollRule(el: HTMLElement) {
    el.scrollIntoView();
  }

  getParentfieldVal(arrayGroup, index, typeOpt = "") {
    //console.log(this.rel1.value[index].relaxFormField1);
    let fldVal = "rel" + parseInt(arrayGroup);
    let arrayGroupVal = this.myForm.get(fldVal) as FormArray;
    if (typeOpt == "Avail") {
      return arrayGroupVal.value[index]["relaxFormFieldAvail"];
    } else if (typeOpt == "Gender") {
      return arrayGroupVal.value[index]["genderFormField_first"];
    } else {
      return arrayGroupVal.value[index]["relaxFormField_sec"];
    }
  }
  getSecondaryOpt(arrayGroup, index, typeOpt = "") {
    console.log(arrayGroup + "##" + index);
    let fldVal = "rel" + parseInt(arrayGroup);
    let arrayGroupVal = this.myForm.get(fldVal) as FormArray;
    //console.log(arrayGroupVal);
    let arrIndexValopt = arrayGroupVal.value[index];
    if (typeOpt == "Avail") {
      let relaxFormField_secVal =
        arrayGroupVal.value[index]["relaxFormFieldAvail"];
      let relaxFormField_third_val = document.getElementById(
        "relaxFormFieldAvail_sec_" + index
      );
      //this.RelaxFieldThirdAvail[arrayGroup] = new Array();
      if (relaxFormField_secVal != "") {
        //console.log("omomomo");
        if (
          this.config["fields"][relaxFormField_secVal]["type"] == "category"
        ) {
          let arrOpt = this.config["fields"][relaxFormField_secVal]["options"];
          this.RelaxFieldThirdAvail[arrayGroup][index] = arrOpt;
        }
      }
    } else {
      let relaxFormField_secVal =
        arrayGroupVal.value[index]["relaxFormField_sec"];
      /* console.log(this.inputFiledSel);
      console.log(this.QueryBuilderConfigOrigArr);
      console.log(this.query);
      console.log(this.config['fields']);
      console.log(this.config['fields'][relaxFormField_secVal]);  */
      let relaxFormField_third_val = document.getElementById(
        "relaxFormField_third_" + index
      );
      if (relaxFormField_secVal != "") {
        if (
          this.config["fields"][relaxFormField_secVal]["type"] == "category"
        ) {
          //relaxFormField2
          let arrOpt = this.config["fields"][relaxFormField_secVal]["options"];

          console.log(index + "--");
          console.log(arrOpt);
          console.log("arrayGroup::", arrayGroup);
          console.log("this.RelaxFieldThird::", this.RelaxFieldThird);
          this.RelaxFieldThird[arrayGroup][index] = arrOpt;
          console.log(this.RelaxFieldThird);
        }
      }
    }
    /* const control = <FormArray>this.myFormworkexp.controls['workexp'];
  control.push(this.initwork(workDt)); */
  }
  getSecondaryOptGender(arrayGroup, index) {
    console.log("value", arrayGroup + "##" + index);
    let fldVal = "rel" + parseInt(arrayGroup);
    let arrayGroupVal = this.myForm.get(fldVal) as FormArray;
    console.log("grpval::", arrayGroupVal);
    let arrIndexValopt = arrayGroupVal.value[index];

    console.log("inside gender sec");
    let genderFormField_firstVal =
      arrayGroupVal.value[index]["genderFormField_first"];
    console.log("genderFormField_firstVal::", genderFormField_firstVal);

    let genderFormField_second_val = document.getElementById(
      "genderFormField_sec_" + index
    );
    if (genderFormField_firstVal != "") {
      console.log("genderFormField_firstVal::", genderFormField_firstVal);

      if (
        this.config["fields"][genderFormField_firstVal]["type"] == "category"
      ) {
        let arrOpt = this.config["fields"][genderFormField_firstVal]["options"];

        console.log(index + "--");
        console.log("arrOpt", arrOpt);

        this.GenderFieldSecond[arrayGroup][index] = arrOpt;

        console.log("result:", this.GenderFieldSecond);
      }
    }
  }

  showUpload() {
    this.showAge = false;
    this.showCRRule = false;
    this.showWorkexpRule = false;
    this.showWorkexpRuleManagement = false;
    this.showRuleng = false;
    this.showDependent = true;
    this.showUploadSec = true;
    this.showMappingSec = false;
    this.showVacancySec = false;
    this.showUploadSecPref = false;
    this.showPreference = false;
    this.showGridMandatorySec = false;

    this.ruleengineService
      .getMasterDocument(this.model.projectName)
      .subscribe((res) => {
        console.log(res);
        if (res.success) {
          this.masterData = res.data;
        }
      });
  }

  showPreferenceUpload() {
    this.showAge = false;
    this.showCRRule = false;
    this.showWorkexpRule = false;
    this.showWorkexpRuleManagement = false;
    this.showRuleng = false;
    this.showDependent = false;
    this.showUploadSec = false;
    this.showUploadSecPref = true;
    this.showMappingSec = false;
    this.showVacancySec = false;
   // this.showPreference = false;
    this.showGridMandatorySec = false;

    this.ruleengineService
      .getMasterDocument(this.model.projectName)
      .subscribe((res) => {
        console.log(res);
        if (res.success) {
          this.masterData = res.data;
        }
      });
  }

  showMapping() {
    this.showAge = false;
    this.showCRRule = false;
    this.showWorkexpRule = false;
    this.showWorkexpRuleManagement = false;
    this.showRuleng = false;
    this.showDependent = true;
    this.showUploadSec = false;
    this.showMappingSec = true;
    this.showVacancySec = false;
    this.showPreference = false;
    this.showGridMandatorySec = false;
    this.showUploadSecPref = false;
    this.mappingModel = {
      id: "",
      parentField: "",
      parentData: "",
      childField: "",
      childData: "",
    };
    this.ruleengineService
      .getMappingData(this.model.projectName)
      .subscribe((res) => {
        //console.log(res);
        let mappingData = res.data.filter(
          (mData) => mData.mapping.isDeleted == "0"
        );
        this.fldMappingData = mappingData;
      });
    //console.log(this.inputFiledSel);
  }

  showVacancyMapping() {
    this.showAge = false;
    this.showCRRule = false;
    this.showWorkexpRule = false;
    this.showWorkexpRuleManagement = false;
    this.showRuleng = false;
    this.showDependent = true;
    this.showUploadSec = false;
    this.showMappingSec = false;
    this.showVacancySec = true;
    this.showUploadSecPref = false;
    this.showGridMandatorySec = false;
    this.showPreference = false;
    this.vacancyForm = this._fb.group({
      depFieldVacancy: [""],
      vacancyField: [""],
      //ageDependentFields:new FormControl(''),
    });
    // console.log(this.inputFiledSel);
    // this.convertConfigJsonQuery();
    this.ruleengineService
      .getMappingData(this.model.projectName, "vacancy")
      .subscribe((res) => {
        console.log(res);
        this.fldMappingData = res.data;
      });
  }

  updateMasterData(data, tblName) {
    console.log(tblName);
    this.ruleengineService
      .updatetMasterDocument(this.model.projectName, data, tblName)
      .subscribe((res) => {
        console.log(res);
        if (res["success"]) {
          this.tableData = res["data"];
        }
      });
  }

  getDocumentData(selectedTbl) {
    //console.log(selectedTbl);
    if (selectedTbl != "") {
      this.ruleengineService
        .getMasterDocument(this.model.projectName, selectedTbl)
        .subscribe((res) => {
          console.log(res);
          if (res.success) {
            this.tableData = res.data;
          }
        });
    } else {
      this.tableData = [];
    }
  }
  uploadData(event) {
    this.selectedFile = <File>event.target.files[0];
  }
  dependentData(formData: NgForm) {
    console.log(formData);

    let frmData = formData.value;
    var form = new FormData();
    if (frmData.depField == "" || frmData.depField == undefined) {
      this.toastr.error("Please select Dependent Field");
      return;
    } else if (frmData.depData == "" || frmData.depData == undefined) {
      this.toastr.error("Please Upload CSV");
      return;
    } else if (frmData.depField != "" && frmData.depData != "") {
      form.append("depField", frmData.depField);
      form.append("projectId", this.model.projectName);
      form.append("depData", this.selectedFile, this.selectedFile["name"]);

      this.ruleengineService.uploadChildData(form).subscribe((res) => {
        //console.log(res);
        if (res.success) {
          this.toastr.success(res.message);
          this.depmodel = { depField: "", depData: "" };
        } else {
          this.toastr.error(res.message);
        }
      });
    }
  }
  preferenceData(formData: NgForm) {
    let frmData = formData.value;
    var form = new FormData();
    var dataList = [];
    if (frmData.depData == "" || frmData.depData == undefined) {
      this.toastr.error("Please Upload CSV");
      return;
    } else if (frmData.depField != "" && frmData.depData != "") {
      form.append("depField", frmData.depField);
      form.append("projectId", this.model.projectName);
      form.append("depData", this.selectedFile, this.selectedFile["name"]);

      this.ruleengineService.uploadPreferenceData(form).subscribe((res) => {
        dataList.push(res.data);
        if (res.success) {
          this.toastr.success(res.message);
          this.depmodel = { depField: "", depData: "" };
        } else {
          this.toastr.error(res.message);
        }
      });
    }
  }
  saveMappingData(formData: NgForm, id = "") {
    //console.log(id);return false;
    this.ruleengineService
      .dataMapping(formData.value, this.model.projectName, id)
      .subscribe((res) => {
        this.formFieldsM = res;
        if (res.success) {
          //console.log(res);
          this.toastr.success("Saved Successfully");
          this.showMapping();
        }
      });
  }

  delData(mapParentId, mapID) {
    this.ruleengineService
      .delMapping(mapParentId, mapID, this.model.projectName)
      .subscribe((res) => {
        if (res["success"]) {
          //console.log(res);
          this.toastr.success("Deleted Successfully");
          this.showMapping();
        }
      });
  }

  getParentData(fldVal) {
    this.parentData = [];
    let rtnData = [];

    for (var fld in this.dependentinputFiledSel) {
      if (
        fld == fldVal &&
        this.dependentinputFiledSel[fld].hasOwnProperty("options") &&
        this.dependentinputFiledSel[fld]["options"].length > 0
      ) {
        //this.parentData = fld['selectOption']
        for (let option of this.dependentinputFiledSel[fld]["options"]) {
          let opt = {
            Key: option.value,
            Value: option.name,
          };
          rtnData.push(opt);
        }
        this.parentData = rtnData;
      } else if (
        fld == fldVal &&
        !this.dependentinputFiledSel[fld].hasOwnProperty("options")
      ) {
        this.ruleengineService
          .getListData(fldVal, this.model.projectName)
          .subscribe((res) => {
            this.parentData = res.data;
          });
      }
    }
  }
  getListData(fldVal) {
    this.listData = [];
    let rtnData = [];
    console.log("inside getlistData", this.inputFiledSel);
    for (let fld of this.inputFiledSel) {
      if (
        fld["keyVal"] == fldVal &&
        fld.hasOwnProperty("selectOption") &&
        fld["selectOption"].length > 0
      ) {
        //this.listData = fld['selectOption']
        for (let option of fld["selectOption"]) {
          let opt = {
            Key: option.value,
            Value: option.label,
          };
          rtnData.push(opt);
        }
        this.listData = rtnData;
      } else if (
        fld["keyVal"] == fldVal &&
        !fld.hasOwnProperty("selectOption")
      ) {
        this.ruleengineService
          .getListData(fldVal, this.model.projectName)
          .subscribe((res) => {
            this.listData = res.data;
            if (this.listData.length == "0") this.toastr.error(res.message);
            console.log(this.listData);
          });
      }
    }
  }

  getProjects() {
    //console.log(this.model.accountName);
    this.applicationService
      .getProjects(this.model.accountName)
      .subscribe((res) => {
        this.projectData = res.data;
        console.log("this.projectData>>>>", this.projectData);
      });
  }

  getProjectAccDet() {
    this.projectService
      .getProjectDetails(this.model.accountName, this.model.projectName)
      .subscribe((res) => {
        //this.projectData = res.data;
        this.AccProjectdet = res["data"];
        console.log("this.AccProjectdet>>>>>", this.AccProjectdet);
      });
  }

  onFldChange(editData = {}) {
    //console.log(this.vacancyForm);
    if (
      this.vacancyForm.value["depFieldVacancy"] &&
      this.vacancyForm.value["vacancyField"]
    ) {
      let fld1 = this.vacancyForm.value["depFieldVacancy"];
      let fld2 = this.vacancyForm.value["vacancyField"];
      let fld1_opt = [];
      let fld1_opt_value = [];
      let fld2_opt = [];
      let fld2_opt_value = [];
      for (let optionObj of this.fieldListArr[fld1]["options"]) {
        fld1_opt.push(optionObj.name);
        fld1_opt_value.push(optionObj.value);
      }
      for (let optionObj of this.fieldListArr[fld2]["options"]) {
        fld2_opt.push(optionObj.name);
        fld2_opt_value.push(optionObj.value);
      }
      this.vacancyParent = fld1_opt;
      this.vacancyParentValue = fld1_opt_value;
      this.vacancyChild = fld2_opt;
      this.vacancyChildValue = fld2_opt_value;
      //console.log(this.vacancyParent);
      //console.log(this.vacancyChild);

      let _this = this;
      fld1_opt.forEach(function (options) {
        let vacancyObj = {};
        let selected = false;
        if (Object.keys(editData).length > 0) {
          var checkOption = _this.checkboxChecked(editData[options]);

          // console.log(options, subOptions, selected)
        }
        fld2_opt.forEach(function (subOptions) {
          // console.log(editData)
          selected =
            Object.keys(editData).length > 0 && checkOption[subOptions]
              ? true
              : false;
          vacancyObj[subOptions] = [selected];
        });
        _this.vacancyForm.addControl(options, _this._fb.group(vacancyObj));
      });
    }
  }

  checkboxChecked(options) {
    var enabledOptions = {};
    options.forEach((option) => {
      enabledOptions[option.fieldValue] = option.enable;
    });
    return enabledOptions;
  }

  get depFieldVacancy() {
    // name property
    return this.vacancyForm.get("depFieldVacancy");
  }

  get vacancyField() {
    // name property
    return this.vacancyForm.get("vacancyField");
  }

  onvacancyFormSubmit() {
    // console.log(this.vacancyForm.value);
    // console.log(this.inputFiledSel);
    var obj = JSON.parse(JSON.stringify(this.QueryBuilderConfigOrigArr));
    // console.log("")
    let indexPageVal,
      compIndexPageVal,
      pageIndex,
      compIndex,
      elementParent = "";
    let childField = this.inputFiledSel.filter(
      (inputs) => inputs["keyVal"] == this.vacancyForm.value.vacancyField
    );
    if (childField.length > 0) {
      indexPageVal = childField["0"].pageCompVal; //page1
      compIndexPageVal = childField["0"].keyVal; //firstname
    }
    obj.filter(function (element, index) {
      if (element.key === indexPageVal) pageIndex = index;
      // return res = (element.key === "page1");
    });

    /*obj[pageIndex]['components'].filter(function (element, index) {
      if(element.key === compIndexPageVal) compIndex = index;
    });*/
    console.log(obj);

    obj[pageIndex]["components"].filter((element, index) => {
      if (element.hasOwnProperty("components")) {
        element["components"].filter(function (element1, index1) {
          console.log(element1);
          if (element1.key === compIndexPageVal) {
            compIndex = index;
            elementParent = element.type;
            console.log(compIndex);
          }
        });
      } else {
        if (element.key === compIndexPageVal) {
          compIndex = index;
          elementParent = element.type;
        }
      }
    });

    let formData = this.vacancyForm.value;
    let logicArr = this.createSimpleLogic(
      this.vacancyParentValue,
      this.vacancyParent,
      formData["depFieldVacancy"],
      this.vacancyChild,
      this.vacancyChildValue
    );

    let logicArrValue = logicArr.map(function (e) {
      return JSON.stringify(e);
    });

    //let dataString = logicArrValue.join(",");
    this.getElementSection(
      obj,
      pageIndex,
      compIndex,
      compIndexPageVal,
      elementParent,
      logicArrValue,
      "logic"
    );

    // return false;

    for (let key in formData) {
      if (typeof formData[key] === "object" && formData[key] !== null) {
        let element = formData[key];
        let elementarray = [];
        for (let data in element) {
          //console.log(data);
          //console.log(element);
          let dataObj = {
            fieldValue: data,
            enable: element[data] === true ? 1 : 0,
          };
          //console.log(dataObj);
          elementarray.push(dataObj);
        }
        //console.log(elementarray);
        formData[key] = elementarray;
      }
    }
    //console.log(formData);
    this.QueryBuilderConfigOrigArr = obj;
    var Jsonapplncomp: Object = {
      components: this.QueryBuilderConfigOrigArr,
      display: "wizard",
    };
    let ruleEngForm = {
      value: {
        accountName: this.model.accountName,
        projectName: this.model.projectName,
      },
    };

    this.applicationService
      .appSubmit(ruleEngForm.value, Jsonapplncomp)
      .subscribe((res) => {
        if (res.success == true) {
          this.ruleengineService
            .vacancyData(formData, this.model.projectName)
            .subscribe((res) => {
              //this.listData = res.data
              //console.log(res);
              this.formFieldsM = res;
              if (res.success == true) {
                this.showVacancyMapping();
              }
            });
        }
      });
  }

  //createSimpleLogic(logicValues, logicOnField, actionValue = 'disabled') {
  //let logic = [];
  //logicValues.forEach((value, index) => {
  // let fldLogic = {
  // 'name': 'vacancy' + (index + 1),
  //'trigger': {
  //'type': 'simple',
  //'simple': { 'show': true, 'when': logicOnField, 'eq': value }
  //},
  //'actions': [
  //{
  //"name": "vacancy" + (index + 1) + "_action",
  //"type": "property",
  //"property": {
  //"label": actionValue,
  //"value": actionValue,
  //"type": "boolean"
  //},
  //"state": "true"
  //}
  //]
  //};
  //logic.push(fldLogic);
  //});
  //return logic;
  //}

  createSimpleLogic(
    logicValues,
    logicLabel,
    logicOnField,
    VacancyLabel,
    VacancyValue
  ) {
    let logic = [];
    logicValues.forEach((value, index) => {
      var data = [];
      for (var i = 0; i < VacancyLabel.length; i++) {
        var disableValue = Object.values(
          this.vacancyForm.value[logicLabel[index]]
        );
        console.log("disableValue::" + disableValue);
        data.push(
          '{\nlabel: "' +
          VacancyLabel[i] +
          '",\nvalue: "' +
          VacancyValue[i] +
          '",\ndisabled:' +
          disableValue[i] +
          " \n}"
        );
      }
      let fldLogic = {
        name: "vacancy" + (index + 1),
        trigger: {
          type: "javascript",
          javascript:
            "var result = false; \nif(data." +
            logicOnField +
            ' ==="' +
            value +
            '"){\n result = true;\n}',
        },
        actions: [
          {
            name: "vacancy" + (index + 1) + "_action",
            type: "mergeComponentSchema",
            schemaDefinition: "schema = {values:[" + data + "]\n};",
          },
        ],
      };
      logic.push(fldLogic);
    });
    return logic;
  }

  toggleMapData() {
    this.isOpen = !this.isOpen;
  }

  editData(fldData) {
    let parentFld = fldData.parentField;
    let childFld = fldData.childField;
    this.getParentData(parentFld);
    this.getListData(childFld);
    let mappingData = fldData.mapping;
    this.mappingModel = {
      id: fldData.mapping._mappingid,
      parentField: parentFld,
      parentData: fldData.mapping.parentData,
      childField: childFld,
      childData: fldData.mapping.childData,
    };
    // console.log(fldData);
  }

  editMappingData(fldData) {
    let parentFld = fldData.depFieldVacancy;
    let childFld = fldData.vacancyField;
    let mappingData = fldData.mapping;
    this.vacancyForm = this._fb.group({
      depFieldVacancy: [parentFld],
      vacancyField: [childFld],
    });
    // console.log(fldData);
    mappingData.forEach((mdata) => {
      // console.log(mdata.vacancyData);
      this.onFldChange(mdata.vacancyData);
    });
  }

  delMappingData(mapId, vacancyField) {
    var obj = JSON.parse(JSON.stringify(this.QueryBuilderConfigOrigArr));

    let indexPageVal,
      compIndexPageVal,
      pageIndex,
      compIndex,
      elementParent = "";
    let childField = this.inputFiledSel.filter(
      (inputs) => inputs["keyVal"] == vacancyField
    );
    if (childField.length > 0) {
      indexPageVal = childField["0"].pageCompVal;
      compIndexPageVal = childField["0"].keyVal;
    }
    obj.filter(function (element, index) {
      if (element.key === indexPageVal) pageIndex = index;
      // return res = (element.key === "page1");
    });
    console.log(obj);

    obj[pageIndex]["components"].filter(function (element, index) {
      if (element.hasOwnProperty("components")) {
        element["components"].forEach((ele, i) => {
          if (ele.key === compIndexPageVal) {
            compIndex = index;
            elementParent = element.type;
          }
        });
      } else {
        if (element.key === compIndexPageVal) {
          compIndex = index;
          elementParent = element.type;
        }
      }
    });

    //let formData = this.vacancyForm.value;
    //let logicArr = this.createSimpleLogic(this.vacancyParent, formData['depFieldVacancy'], 'disabled');

    //let logicArrValue = logicArr.map(function(e){
    //	return JSON.stringify(e);
    //});

    //let dataString = logicArrValue.join(",");
    console.log(pageIndex, compIndex, compIndexPageVal);
    this.getElementSection(
      obj,
      pageIndex,
      compIndex,
      compIndexPageVal,
      elementParent,
      "",
      "logic",
      "delete"
    );
    this.QueryBuilderConfigOrigArr = obj;
    var Jsonapplncomp: Object = {
      components: this.QueryBuilderConfigOrigArr,
      display: "wizard",
    };
    let ruleEngForm = {
      value: {
        accountName: this.model.accountName,
        projectName: this.model.projectName,
      },
    };

    this.applicationService
      .appSubmit(ruleEngForm.value, Jsonapplncomp)
      .subscribe((res) => {
        if (res.success == true) {
          this.ruleengineService
            .delVacancy(mapId, this.model.projectName)
            .subscribe((res) => {
              this.showVacancyMapping();
            });
        }
      });
  }

  resetVacancyForm() {
    //  console.log('in reset function');
    this.showVacancyMapping();
  }

  resetMappingForm() {
    //  console.log('in reset function');
    this.showMapping();
  }

  backtoSection(section: any) {
    if (section == "dashboard") this.router.navigate(["/dashboard"]);
    else if (section == "rule") {
      this.sharedService.changeAccount(this.model.accountName);
      this.sharedService.changeProject(this.model.projectName);
      this.router.navigate(["/rulengine"]);
    } else if (section == "application") {
      this.sharedService.changeAccount(this.model.accountName);
      this.sharedService.changeProject(this.model.projectName);
      this.router.navigate(["/application"]);
    } else if (section == "ageconfig") {
      this.sharedService.changeAccount(this.model.accountName);
      this.sharedService.changeProject(this.model.projectName);
      this.router.navigate(["/age"]);
    }
  }
  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    if (
      this.unSaveData &&
      ((typeof this.ruleengineform !== "undefined" &&
        this.ruleengineform.dirty) ||
        (typeof this.myForm !== "undefined" && this.myForm.dirty) ||
        (typeof this.myFormworkexp !== "undefined" &&
          this.myFormworkexp.dirty) ||
        (typeof this.myDynFormworkexp !== "undefined" &&
          this.myDynFormworkexp.dirty))
    ) {
      return false;
    } else return true;
  }
}
